import React, {
  useState,
  useMemo,
  useContext,
  useEffect,
  useRef,
  useCallback,
} from "react";
import Card from "../../../Common/Card/Card";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./Candidates.css";
import { useFormik } from "formik";
import TextInput from "../../../Common/Textfield/Textfield";
import styled from "@emotion/styled";
import { createPortal } from "react-dom";
import { useNavigate, useLocation } from "react-router-dom";
import DynamicTextField from "../../../Common/Textfield/Textfield";
import PhoneNumberInput from "../../../Common/PhoneNumberInput/PhoneNumberInput";
import * as Yup from "yup";
import Button from "../../../Common/Button/Button";
import Badge from "@mui/material/Badge";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Lock, Users } from "lucide-react";
import "../../Applicant-Tracking/Clients/Create-Client/CreateClient.css";
import { DynamicContext } from "../../../Context/DynamicContext";
import CandidateLightIcon from "../../../Assets/Images/candidates-header-icon.svg";
import CandidateDarkIcon from "../../../Assets/Images/candidates-header-darkicon.svg";
import { get, post, deleteRequest, patch } from "../../../helper/Api_helper";
import { STREAMING_ENABLED } from "../../../helper/featureFlags";
import { useThinkingFallback } from "../../../helper/useThinkingFallback";
import { RECOVERY_FAILED_MESSAGE } from "../../../helper/chatRecovery";
import SidePopupCan from "../../../Common/SidePopup/SidePopup";
import {
  ConfirmationPopup,
  SidePopup,
  StandardPopup,
} from "../../../Common/PopupStyles/PopupComponent";
import DynamicAutocomplete from "../../../Common/AutoSuggestion/DynamicAutocomplete";
import {
  VYLABS_BASE_URL,
  CAN_LIST,
  CCREATE_CAN,
  GET_CANDIDATE_BY_ID,
  SIMPLE_SEARCH_CANDIDATES,
  WEB_SOCKET_URL,
  CREATE_CHAT_CHANNEL_URL,
  PROCESS_CANDIDATE_CONVERSATION,
  GET_CURRENT_CONVERSATION_TITLE,
  DELETE_CANDIDATE_DETAILS,
  JOBS_SIMPLE_SEARCH,
  GET_JOB_DETAILS_BY_ID,
  UPDATE_CANDIDATE_DETAILS,
  VENDORS_SEARCH,
  GET_VENDOR_DETAILS_BY_ID,
  SIMPLE_SEARCH_CANDIDATES_EXCEL_EXPORT,
  GET_CANDIDATES_EXPORT_FIELDS,
  TENANT_FIELD_DEFINITIONS_LIST,
  CANDIDATE_FILTER_EXPORT,
  GET_SAVED_VIEWS,
  CREATE_SAVED_VIEWS,
  DELETE_SAVED_VIEWS,
  UPDATE_SAVED_VIEWS,
} from "../../../helper/url_helper";
import addIcon from "../../../Assets/Images/create-icon.png";
import AutoComplete from "../../../Common/AutoComplete/AutoComplete";
import OptionsData from "../../../Assets/Json/StaticOptions.json";
import { Toast } from "../../../Common/Toast-Snackbar/ToastSnackbar";
import DynamicSkeleton from "../../../Common/Skeleton/Skeleton";
import backArrowIcon from "../../../Assets/Images/arrow-back-icon.png";
import PageSelector from "../../../Common/Page-Selector/PageSelector";
import RecommendedSearchBox from "../../../Common/RecommendedSearchBox/RecommendedSearchBox";
import SimpleCepheaChat from "../../../Common/Simple-Search-Box/SimpleSearchBox";
import CandidatesAssignJob from "./CandidatesAssignJob";
import AnimationPlayer from "../../../Common/Animation-Player/AnimationPlayer";
import BotReplyIcon from "../../../Assets/Images/VybogTAL GEN Icon White.svg";
import ThinkingBubble from "../../../Common/ThinkingBubble/ThinkingBubble";
import VybogTALLoaderAnimation from "../../../Common/Dynamic-Animations/DynamicAnimations";
import { getStageColor } from "../../../Common/constants/stageColors";
import ResumeUpload from "../../Resume-Upload/ResumeUpload";
import createCandidateIcon from "../../../Assets/Images/Create New Candidate Icon Light.svg";
import createDarkCandidateIcon from "../../../Assets/Images/Create New Candidate Icon Dark.svg";
import gridActiveDarkIcon from "../../../Assets/Images/Grid-Active-Dark.svg";
import gridNotActiveDarkIcon from "../../../Assets/Images/Grid-NotActive-Dark.svg";
import tableActiveDarkIcon from "../../../Assets/Images/Table-Active-Dark.svg";
import tableNotActiveDarkIcon from "../../../Assets/Images/Table-NotActive-Dark.svg";
import { v4 as uuidv4 } from "uuid";
import {
  applyEllipsis,
  toCapitalize,
  BotResponseStarIcon,
  sanitizeBotText,
  parseMessageText,
  toCamelCase,
  renderInlineMarkdown,
  getBulletContent,
  renderBotContent,
  filterPayload,
  formatDateTime,
} from "../../../Common/Common-Function/CommonFunctions";
import CustomTooltip from "../../../Common/Tooltip/Tooltip";
import { jobsCache, channelIdCache } from "./CandidateDetails/RecommendedJobs";
import CandidateDetailsContainer from "../../../Common/Candidate-Details-Container/CandidateDetailsContainer";
import NojobsAnimation from "../../../Assets/Json/nodata-found-robot-animation.json";
import gridNoSelectIcon from "../../../Assets/Images/grid-icon.svg";
import tableSelectIcon from "../../../Assets/Images/tabler_table-icon.svg";
import gridSelectIcon from "../../../Assets/Images/grid-selected-icon.svg";
import tableNoSelectIcon from "../../../Assets/Images/tabler_table-notselect-icon.svg";
import rightArrowIcon from "../../../Assets/Images/arrow-right.png";
import CandidateFilterDrawer from "./CandidateFilterDrawer";
import CALL_STAGE_COLORS from "../../../Common/constants/stageColors";
import Table from "../../../Common/Table/Table";
import DownloadIcon from "../../../Assets/Images/download-white-icon.png";
import EmailCampaignIcon from "../../../Assets/Images/Email-campaign-icon.svg";
import JobsBlastEmailCampaign from "./JobsBlastEmailCampaign";
import JobSelectionPopup from "./JobSelectionPopup";
import ReachOutIcon from "../../../Assets/Images/reach-out-icon.svg";
import editIcon from "../../../Assets/Images/edit-track-icon.svg";
import deleteIcon from "../../../Assets/Images/delete-red-icon.png";
import viewCandidateIcon from "../../../Assets/Images/candidate-view.png";
import ClientEmailPopup from "./ClientEmailPopup";
import VybogTALChatIcon from "../../../Assets/Images/VybogTAL GEN Icon Blue.svg";
import MatchPercentage from "../../../Common/Match-percentage-popup/MatchPercentage";
import networkIcon from "../../../Assets/Images/Network-badge-icon-white.svg";
import DynamicCandidateCustomField from "../../../Common/DynamicCandidateCustomField/DynamicCandidateCustomField";
import { TENANT_CORE_API_KEY } from "../../../Tenant-Config/TenantConfig";
import DynamicSelectInput from "../../../Common/Select-Input/SelectInput";
import { fetchCallStages } from "../../../Common/DynamicCallStage/DynamicCallStageMapping";
const { StaticOptions = {} } = OptionsData || {};
const { skills = [], industry: INDUSTRY_OPTIONS = [] } = StaticOptions || {};
const sentSimpleSearchContextChannelIds = new Set();
const PLACEHOLDER_OPTIONS = [
  "React,Php,Node.js",
  "John Doe",
  "johndoe@gmail.com",
  "+916382068254",
  "Java Developer",
  "Devops,azure",
];
const SEARCH_TABLE_PAGE_SIZE = 10;
const JOBS_PAGE_SIZE = 30;
const CANDIDATE_SAVED_VIEW_SCOPE = "candidates_search";
const SAVED_VIEW_DATE_LABELS = {
  today: "Today",
  yesterday: "Yesterday",
  this_week: "This week",
  this_month: "This month",
};
const SAVED_VIEW_TIME_VALUES = {
  Today: "today",
  Yesterday: "yesterday",
  "This week": "this_week",
  "This month": "this_month",
};
const SAVED_VIEW_AUTOCOMPLETE_SX = {
  width: "100%",
  ".MuiOutlinedInput-root": {
    borderRadius: "8px",
    minHeight: "34px",
    backgroundColor: "var(--sidepopup-background)",
    "& .MuiOutlinedInput-notchedOutline": {
      border: "1px solid var(--search-input-section-border) !important",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#6860ee !important",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#6860ee !important",
    },
  },
  ".MuiInputBase-input": {
    color: "var(--header__color)",
    padding: "0 8px !important",
    fontSize: "13px",
    fontFamily: "Satoshi",
  },
};
const SAVED_VIEW_AUTOCOMPLETE_COMPONENT_PROPS = {
  popper: {
    sx: {
      zIndex: 1402,
      "& .MuiAutocomplete-paper": {
        backgroundColor: "var(--sidepopup-background)",
        color: "var(--header__color)",
        border: "1px solid var(--border__color)",
        borderRadius: "8px",
        boxShadow: "0 8px 22px rgba(15, 23, 42, 0.18)",
      },
      "& .MuiAutocomplete-option": {
        color: "var(--header__color)",
        fontSize: "13px",
      },
      "& .MuiAutocomplete-noOptions": {
        color: "#6860ee",
      },
      "& .MuiAutocomplete-loading": {
        color: "#6860ee",
        fontStyle: "italic",
      },
    },
  },
};
const normalizeSearchSkills = (value) =>
  String(value || "")
    .split(",")
    .map((skill) => skill.trim())
    .filter(Boolean);
const normalizeSearchValue = (value) => String(value ?? "").trim();
const normalizeSearchNumber = (value) => {
  const normalizedValue = normalizeSearchValue(value);
  if (normalizedValue === "") return "";
  const parsedValue = parseInt(normalizedValue, 10);
  return Number.isNaN(parsedValue) ? "" : parsedValue;
};
const formatCandidateFilterDate = (value) => {
  if (!value) return "";
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const hasCandidateDateFilters = (filters = []) =>
  filters.some(
    (filter) =>
      [
        "from_date",
        "to_date",
        "tracking_from_date",
        "tracking_end_date",
      ].includes(filter.type) &&
      Boolean(formatCandidateFilterDate(filter.value)),
  );

const hasCandidateExperienceValue = (value) =>
  value !== undefined && value !== null && value !== "";

const getCandidateExperienceValue = (candidate) => {
  if (hasCandidateExperienceValue(candidate?.years_of_experience)) {
    return candidate.years_of_experience;
  }

  const parsedExperience =
    candidate?.parsedResumeData?.BasicInfo?.YearsOfExperience;

  return hasCandidateExperienceValue(parsedExperience)
    ? parsedExperience
    : "N/A";
};

const getLocationDisplay = (candidate) => {
  if (candidate?.city) return candidate.city;
  if (candidate?.state) return candidate.state;
  if (candidate?.country) return candidate.country;
  return "N/A";
};

const CandidateNameCell = ({ row }) => {
  const candidateInitials = row.name
    ? row.name
        .split(" ")
        .map((namePart) => namePart[0])
        .slice(0, 2)
        .join("")
    : "N/A";
  return (
    <div className="candidate-table-name-cell">
      <div className="candidate-table-avatar">{candidateInitials}</div>
      <span className="candidate-table-name">{row.name || "N/A"}</span>
    </div>
  );
};

const CandidateActionCell = ({ row, onView }) => {
  const handleViewClick = (event) => {
    onView(row, event);
  };

  return (
    <div className="candidate-table-action-cell">
      <CustomTooltip title="View Candidate" arrow>
        <Button
          type="button"
          className="candidate-table-view-button"
          event={handleViewClick}
          backgroundColor="transparent"
          border="none"
          color="inherit"
          hoverd={false}
          aria-label={`View ${row.name || "candidate"}`}
        >
          <img src={viewCandidateIcon} alt="" />
        </Button>
      </CustomTooltip>
    </div>
  );
};

export const StyledGlobelSearch = styled(TextInput)({
  width: "540px",
  padding: "10px",
  marginBottom: "3px",
  border: "1px solid #ccc",
  borderRadius: "7px",
  boxSizing: "border-box",
  outline: "none",
  marginLeft: "15px",
  paddingLeft: "30px",
  "@media screen and (max-width:920px)": {
    width: "400px",
  },
  "@ mediascreen and (max-width:768px)": {
    width: "350px",
  },
});

const JobActionsSelectorWrapper = styled("div")({
  ".szh-menu": {
    width: "220px !important",
    minWidth: "220px !important",
  },
  ".react-menu__menu": {
    width: "220px !important",
    minWidth: "220px !important",
  },
  ".szh-menu__item": {
    whiteSpace: "nowrap",
  },
});

const FilterPill = ({ value, style, color }) => {
  const pillStyle = {
    display: "inline-block",
    ...style,
  };
  const spanStyle = {};
  return (
    <div className="filter-pill" style={pillStyle}>
      <span className="filter-pill-value" style={spanStyle}>
        {value}
      </span>
    </div>
  );
};

const getExportFieldKey = (field, index = 0) => {
  if (typeof field === "string" || typeof field === "number") {
    return String(field);
  }
  return String(
    field?.field_key ||
      field?.key ||
      field?.value ||
      field?.id ||
      field?.name ||
      field?.label ||
      `export-field-${index}`,
  );
};

const isRequiredExportField = (field) =>
  Boolean(field?.required || field?.is_required || field?.mandatory);

const SortableExportField = ({ field, index, children }) => {
  const id = getExportFieldKey(field, index);
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={isDragging ? "candidate-export-field-dragging" : ""}
      {...attributes}
    >
      {children({ listeners, isDragging })}
    </div>
  );
};

function CandidateTableList() {
  const {
    isDarkMode,
    userDetails,
    isUploadResumeViewOpen,
    setUploadResumeViewOpen,
    isVendorFeatureEnabled,
    hideCandidatesHeader,
    setHideCandidatesHeader,
    refetchCanList,
    setRefetchCanList,
    AdminAccess,
    MemberAccess,
    isMonthlyEmailLimitReached,
    getMonthlyEmailTooltip,
    isHiringTeamTenant,
  } = useContext(DynamicContext);
  const navigate = useNavigate();
  const location = useLocation();
  const observer = useRef();
  const topRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);
  const [allCanList, setAllCanList] = useState([]);
  const [allOffset, setAllOffset] = useState(0);
  const [isAllInitialLoading, setIsAllInitialLoading] = useState(false);
  const [isAllLoadingMore, setIsAllLoadingMore] = useState(false);
  const [hasMoreAll, setHasMoreAll] = useState(true);
  const [isAllFetchCompleted, setIsAllFetchCompleted] = useState(false);
  const [myCanList, setMyCanList] = useState([]);
  const [myOffset, setMyOffset] = useState(0);
  const [isMyInitialLoading, setIsMyInitialLoading] = useState(false);
  const [isMyLoadingMore, setIsMyLoadingMore] = useState(false);
  const [hasMoreMy, setHasMoreMy] = useState(true);
  const [isMyFetchCompleted, setIsMyFetchCompleted] = useState(false);
  const [isAllCandidatesActive, setIsAllCandidatesActive] = useState(true);
  const [isTrackedByMeActive, setIsTrackedByMeActive] = useState(false);
  const lastAllOffsetRef = useRef(0);
  const lastMyOffsetRef = useRef(0);
  const lastByMeOffsetRef = useRef(0);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [candidateModal, setCandidateModal] = useState(
    location.state?.openModal || false,
  );
  const [autoCompleteKey, setAutoCompleteKey] = useState(0);
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [isAssignJobModalOpen, setAssignJobModalOpen] = useState(false);
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const [messages, setMessages] = useState([]);
  const [isBotProcessing, setIsBotProcessing] = useState(false);
  const [socket, setSocket] = useState(null);
  const [AiDrivenUploadedFiles, setAiDrivenUploadedFiles] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isSearchBoxCollapsed, setIsSearchBoxCollapsed] = useState(false);
  const [showBackToList, setShowBackToList] = useState(false);
  const [chatChannelID, setChatChannelID] = useState(null);
  const chatChannelIdRef = useRef(null);
  const [openConversationLimitPopup, setOpenConversationLimitPopup] =
    useState(false);
  const [isDeleteCandidatePopupOpen, setIsDeleteCandidatePopupOpen] =
    useState(false);
  const [isSelectMode, setIsSelectMode] = useState(false);
  const [byMeCanList, setByMeCanList] = useState([]);
  const [byMeOffset, setByMeOffset] = useState(0);
  const [isByMeInitialLoading, setIsByMeInitialLoading] = useState(false);
  const [isByMeLoadingMore, setIsByMeLoadingMore] = useState(false);
  const [hasMoreByMe, setHasMoreByMe] = useState(true);
  const [isByMeFetchCompleted, setIsByMeFetchCompleted] = useState(false);
  const [isCreatedByMeActive, setIsCreatedByMeActive] = useState(false);
  const [hasSentCandidateIds, setHasSentCandidateIds] = useState(false);
  const [currentChannelForContext, setCurrentChannelForContext] =
    useState(null);
  const [isJobSelectionOpen, setIsJobSelectionOpen] = useState(false);
  const [jobSelectionActionType, setJobSelectionActionType] =
    useState("assignJob");
  const [jobSelectionActionData, setJobSelectionActionData] = useState({});
  const [assignJobId, setAssignJobId] = useState(null);
  const [assignJobTitle, setAssignJobTitle] = useState("");
  const [searchPagination, setSearchPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCandidates: 0,
    hasMore: false,
    allSearchResults: [],
    isLoadingMore: false,
    currentQuery: "",
    currentMinYearsOfExperience: "",
    currentMaxYearsOfExperience: "",
    currentSkills: "",
    currentIndustry: "",
    currentLocation: "",
    currentFilters: [],
    currentFilterBy: undefined,
  });
  const [searchParams, setSearchParams] = useState({
    query: "",
    minYearsOfExperience: "",
    maxYearsOfExperience: "",
    skills: "",
    industry: "",
    location: "",
  });
  const [locationValue, setLocationValue] = useState("");
  const [fields, setFields] = useState([]);
  const [isRecommendedJobsLoading, setIsRecommendedJobsLoading] =
    useState(false);
  const [exportFilteredCandidatesUrl, setExportFilteredCandidatesUrl] =
    useState("");
  const [isCandidateDetailsLoading, setIsCandidateDetailsLoading] =
    useState(true);
  const [hasExportData, setHasExportData] = useState(false);
  const searchObserver = useRef();
  const reconnectTimeoutRef = useRef(null);
  const socketRef = useRef(null);
  const MAX_RECONNECT_ATTEMPTS = 5;
  const BASE_RECONNECT_DELAY = 1000;
  const PING_INTERVAL = 30000;
  const PING_TIMEOUT = 10000;
  const pingIntervalRef = useRef(null);
  const pingTimeoutRef = useRef(null);
  const responseReceivedRef = useRef(false);
  const isConnectingRef = useRef(false);
  const lastMessageRef = useRef(null);
  const messageQueueRef = useRef([]);
  const lastPingTimeRef = useRef(null);
  const messagesEndRef = useRef(null);

  const isAwaitingReply = messages.some((m) => m.isLoading);
  const resolveLoadingMessages = (text) => {
    setMessages((prev) => {
      const idx = prev.findIndex((m) => m.isLoading || m.isStreaming);
      if (idx === -1) return prev;
      const updated = [...prev];
      updated[idx] = {
        ...updated[idx],
        text,
        isLoading: false,
        isStreaming: false,
      };
      return updated;
    });
    responseReceivedRef.current = true;
    setIsBotProcessing(false);
  };
  useThinkingFallback({
    active: isAwaitingReply,
    getChannelId: () => chatChannelIdRef.current || chatChannelID,
    responseReceivedRef,
    onRecovered: (answer) => resolveLoadingMessages(answer),
    onExhausted: () => resolveLoadingMessages(RECOVERY_FAILED_MESSAGE),
  });

  const [isEditingCandidate, setIsEditingCandidate] = useState(false);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [editedCandidateData, setEditedCandidateData] = useState(null);
  const candidateDetailsRef = useRef(null);
  const [emailError, setEmailError] = useState("");
  const selectedCandidateRef = useRef(null);

  useEffect(() => {
    selectedCandidateRef.current = selectedCandidate;
  }, [selectedCandidate]);
  const [emailTouched, setEmailTouched] = useState(false);
  const [vendorList, setVendorList] = useState([]);
  const [vendorOptionLoading, setVendorOptionLoading] = useState(false);
  const [assignedVendor, setAssignedVendor] = useState(null);
  const [searchResultCandidates, setSearchResultCandidates] = useState([]);
  const [searchResultCandidateIds, setSearchResultCandidateIds] = useState([]);
  const [isSimpleSearchLoading, setIsSimpleSearchLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const simpleSearchAbortRef = useRef(null);
  const simpleSearchRequestKeyRef = useRef("");
  const simpleSearchRequestSeqRef = useRef(0);
  const suppressNextCandidateListFetchRef = useRef(false);
  const [trackedViewTab, setTrackedViewTab] = useState(0);
  const [allCandidatesViewTab, setAllCandidatesViewTab] = useState(0);
  const [showCepheaChat, setShowCepheaChat] = useState(false);
  const [tablePage, setTablePage] = useState(1);
  const [pendingScrollToChat, setPendingScrollToChat] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const [savedViews, setSavedViews] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [selectedExportFieldKeys, setSelectedExportFieldKeys] = useState([]);
  const [isLoadingGetExport, setIsLoadingGetExport] = useState(false);
  const [isExportFieldsPopupOpen, setIsExportFieldsPopupOpen] = useState(false);
  const [selectedSavedViewId, setSelectedSavedViewId] = useState(null);
  const [isLoadingSavedViews, setIsLoadingSavedViews] = useState(false);
  const [isCreateSavedViewOpen, setIsCreateSavedViewOpen] = useState(false);
  const [savedViewName, setSavedViewName] = useState("");
  const [isCreatingSavedView, setIsCreatingSavedView] = useState(false);
  const [isUpdatingSavedView, setIsUpdatingSavedView] = useState(false);
  const [savedViewPendingDelete, setSavedViewPendingDelete] = useState(null);
  const [isSavedViewDeleteDialogOpen, setIsSavedViewDeleteDialogOpen] =
    useState(false);
  const [isDeletingSavedView, setIsDeletingSavedView] = useState(false);
  const [candidateFilterDraft, setCandidateFilterDraft] = useState(null);
  const [savedViewDraft, setSavedViewDraft] = useState(null);
  const [isCandidateFilterOpen, setIsCandidateFilterOpen] = useState(false);
  const [callStageMap, setCallStageMap] = useState({});
  const allStages = useMemo(() => Object.keys(CALL_STAGE_COLORS || {}), []);

  useEffect(() => {
    const loadCallStages = async () => {
      const stages = await fetchCallStages();
      setCallStageMap(stages);
    };

    loadCallStages();
  }, []);
  const [suppressAutoLoadAll, setSuppressAutoLoadAll] = useState(false);
  const [suppressAutoLoadMy, setSuppressAutoLoadMy] = useState(false);
  const [suppressAutoLoadByMe, setSuppressAutoLoadByMe] = useState(false);
  const cepheaChatRef = useRef(null);
  const candidatesListRef = useRef(null);
  const [showFilterCepheaChat, setShowFilterCepheaChat] = useState(false);
  const filterChatRef = useRef(null);
  const [filterChatInput, setFilterChatInput] = useState("");
  const [isEmailPreviewOpen, setIsEmailPreviewOpen] = useState(false);
  const [canPreview, setCanPreview] = useState(false);
  const [minYearsOfExperienceValue, setMinYearsOfExperienceValue] =
    useState("");
  const [maxYearsOfExperienceValue, setMaxYearsOfExperienceValue] =
    useState("");
  const [industryValue, setIndustryValue] = useState("");
  const [skillsValue, setSkillsValue] = useState("");
  const [showExportButton, setShowExportButton] = useState(false);
  const [showMatchPercentagePopup, setShowMatchPercentagePopup] =
    useState(false);
  const searchTableShowingCount = Math.min(
    allCandidatesViewTab === 1
      ? searchPagination.currentPage * SEARCH_TABLE_PAGE_SIZE
      : searchResultCandidates.length,
    searchPagination.totalCandidates,
  );
  const formik = useFormik({
    initialValues: {
      canName: "",
      canEmail: "",
      canLocation: "",
      canMobile: "",
      canSkills: "",
      secondaryPhone: "",
      secondaryEmail: "",
      jobDescription: "",
      askmeanything: "",
      vendorID: "",
      lineAddress1: "",
      lineAddress2: "",
      preferredSalary: "",
      zipCode: "",
      designation: "",
      source: "",
      industry: "",
      custom_fields: {},
    },
    validationSchema: Yup.object({
      canName: Yup.string().required("Candidate Name is required"),

      canEmail: Yup.string()
        .email("Invalid email format")
        .test(
          "email-or-phone",
          "Either Email or Phone Number is required",
          function (value) {
            const { canMobile } = this.parent;
            if (!value && !canMobile) {
              return false;
            }
            return true;
          },
        ),

      canMobile: Yup.string()
        .matches(/^\+?[0-9]*$/, "Only digits are allowed")
        .min(10, "Must be at least 10 digits")
        .test(
          "phone-or-email",
          "Either Email or Phone Number is required",
          function (value) {
            const { canEmail } = this.parent;
            if (!value && !canEmail) {
              return false;
            }
            return true;
          },
        ),

      secondaryPhone: Yup.string()
        .matches(/^[0-9]+$/, "Only digits are allowed")
        .min(10, "Must be at least 10 digits"),

      secondaryEmail: Yup.string().email("Invalid email format"),

      skills: Yup.array()
        .min(1, "At least one skill is required")
        .required("Skills are required"),

      jobDescription: Yup.string(),
      askmeanything: Yup.string(),
      designation: Yup.string(),
      source: Yup.string(),
      industry: Yup.string(),
    }),
  });

  const [isEmailCampaignPopupOpen, setIsEmailCampaignPopupOpen] =
    useState(false);
  const [isClientEmailPopupOpen, setIsClientEmailPopupOpen] = useState(false);

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: "smooth",
      });
    }
  }, [messages]);

  const handleOpenCandidateDeleteDialog = () => {
    setIsDeleteCandidatePopupOpen(true);
  };

  const handleDeleteCandidate = async () => {
    setIsDeleteCandidatePopupOpen(false);
    if (selectedCandidate?.id) {
      try {
        await deleteRequest(VYLABS_BASE_URL, DELETE_CANDIDATE_DETAILS, {
          id: selectedCandidate.id,
        });
        Toast("success", "Candidate deleted successfully");

        if (hasSearched) {
          handleBackToList();
        }

        if (isTrackedByMeActive) {
          fetchTrackedCandidates(0, activeFilters);
        } else if (isCreatedByMeActive) {
          fetchCandidatesCreatedByMe(0, activeFilters);
        } else {
          fetchCandidates(0, activeFilters);
        }

        setSelectedCandidate(null);
        setIsModalOpen(false);
      } catch (error) {
        console.error("Error deleting candidate:", error);
      }
    }
  };
  const fetchVendors = async (inputValue = "") => {
    try {
      setVendorOptionLoading(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${VENDORS_SEARCH}?vendor_name=${encodeURIComponent(inputValue)}`,
      );

      const { vendors = [] } = response;
      const fetchedVendors = Array.isArray(vendors)
        ? vendors
            .filter((v) => v?.id && v?.name)
            .map((v) => ({
              label: v.contact_person
                ? `${v.name} - ${v.contact_person}`
                : v.name,
              value: v.id,
            }))
        : [];

      setVendorList(fetchedVendors);
    } catch (err) {
      console.error("fetchVendors error", err);
      setVendorList([]);
    } finally {
      setVendorOptionLoading(false);
    }
  };

  const handleVendorInputChange = (_, value) => {
    if (value && value.length >= 3) {
      fetchVendors(value);
    } else {
      setVendorList([]);
    }
  };
  const fetchResumesList = useCallback(
    async (candidateIds = [], botMessageId) => {
      const detailedCandidates = await Promise.all(
        candidateIds.map(async (candidateId) => {
          try {
            const res = await get(
              VYLABS_BASE_URL,
              `${GET_CANDIDATE_BY_ID}?id=${candidateId}`,
            );
            return {
              ...res.candidate,
              parsed_resume: res.candidate.parsed_resume
                ? JSON.parse(res.candidate.parsed_resume)
                : {},
              isFileBased: false,
            };
          } catch (err) {
            console.error(`Error fetching candidate ${candidateId}:`, err);
            return null;
          }
        }),
      );
      const filteredCandidates = detailedCandidates.filter(Boolean);

      setMessages((prev) => {
        const updated = [...prev];
        const botMessageIndex = updated.findIndex(
          (msg) => msg.id === botMessageId && msg.sender === "bot",
        );

        if (botMessageIndex !== -1) {
          updated[botMessageIndex] = {
            ...updated[botMessageIndex],
            isLoading: false,
            isResumesLoading: false,
            resumes: filteredCandidates,
          };
        }

        return updated;
      });
      setIsBotProcessing(false);
      setShowBackToList(true);
    },
    [],
  );

  const handleAssignJobFromHistory = (candidateData) => {
    setSelectedCandidates([{ id: candidateData.id, name: candidateData.name }]);
    setIsModalOpen(false);
    setActiveTab(0);
    openJobSelectionPopup("assignJob", { candidateData });
  };
  const openJobSelectionPopup = (actionType = "assignJob", actionData = {}) => {
    setJobSelectionActionType(actionType);
    setJobSelectionActionData(actionData);
    setIsJobSelectionOpen(true);
  };

  const handleReconnect = useCallback(() => {
    if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
      Toast("error", "Max reconnection attempts reached. Please refresh.");
      return;
    }
    const delay = Math.min(
      BASE_RECONNECT_DELAY * Math.pow(2, reconnectAttempts) +
        Math.random() * 1000 +
        5000,
      35000,
    );

    reconnectTimeoutRef.current = setTimeout(() => {
      setReconnectAttempts((prev) => prev + 1);
      initializeWebSocket();
    }, delay);
  }, [reconnectAttempts]);

  useEffect(() => {
    return () => {
      if (socketRef.current) {
        console.log("Cleaning up WebSocket on component unmount");
        socketRef.current.close(1000, "Component unmounted");
        socketRef.current = null;
      }
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
        pingIntervalRef.current = null;
      }
      if (pingTimeoutRef.current) {
        clearTimeout(pingTimeoutRef.current);
        pingTimeoutRef.current = null;
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
    };
  }, []);

  const startPingInterval = useCallback((ws) => {
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
    }
    if (ws.readyState === WebSocket.OPEN) {
      console.warn("Sending initial ping");
      ws.send("ping");
      lastPingTimeRef.current = Date.now();
      pingTimeoutRef.current = setTimeout(() => {
        const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
        if (timeSinceLastPing > PING_TIMEOUT) {
          console.log("No pong received within timeout, reconnecting...");
          ws.close(1000, "Ping timeout");
        }
      }, PING_TIMEOUT);
    }
    pingIntervalRef.current = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        console.warn("Sending ping");
        ws.send("ping");
        lastPingTimeRef.current = Date.now();
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
        }

        pingTimeoutRef.current = setTimeout(() => {
          const timeSinceLastPing = Date.now() - lastPingTimeRef.current;
          if (timeSinceLastPing > PING_TIMEOUT) {
            console.log("No pong received within timeout, reconnecting...");
            ws.close(1000, "Ping timeout");
          }
        }, PING_TIMEOUT);
      }
    }, PING_INTERVAL);
  }, []);

  const fetchCandidateExportFields = useCallback(async () => {
    try {
      setIsLoadingGetExport(true);
      const response = await get(VYLABS_BASE_URL, GET_CANDIDATES_EXPORT_FIELDS);
      const exportFields = Array.isArray(response?.fields)
        ? response.fields
        : Array.isArray(response)
          ? response
          : [];
      setExportData(exportFields);
      setSelectedExportFieldKeys((prev) => {
        const availableKeys = exportFields.map((field, index) =>
          getExportFieldKey(field, index),
        );
        const availableKeySet = new Set(availableKeys);
        const requiredKeys = exportFields
          .filter(isRequiredExportField)
          .map((field, index) => getExportFieldKey(field, index));
        const retainedKeys = prev.filter((key) => availableKeySet.has(key));
        const nextKeys = retainedKeys.length > 0 ? retainedKeys : availableKeys;

        return Array.from(new Set([...requiredKeys, ...nextKeys]));
      });
    } catch (error) {
      console.log("candidates export", error);
      setExportData([]);
      setSelectedExportFieldKeys([]);
    } finally {
      setIsLoadingGetExport(false);
    }
  }, []);

  const handleOpenExportFieldsPopup = () => {
    setIsExportFieldsPopupOpen(true);
    fetchCandidateExportFields();
  };

  const getExportFieldLabel = (field) => {
    if (typeof field === "string") return field;
    if (typeof field === "number") return String(field);
    return (
      field?.label ||
      field?.name ||
      field?.field_name ||
      field?.field_key ||
      field?.key ||
      field?.value ||
      field?.id ||
      "Export field"
    );
  };

  const selectedExportFields = useMemo(
    () =>
      exportData.filter((field, index) =>
        selectedExportFieldKeys.includes(getExportFieldKey(field, index)),
      ),
    [exportData, selectedExportFieldKeys],
  );

  const exportCandidateCount =
    selectedCandidates.length > 0
      ? selectedCandidates.length
      : searchPagination.totalCandidates || searchResultCandidates.length;

  const handleExportFieldDragEnd = (event) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setExportData((prevFields) => {
      const oldIndex = prevFields.findIndex(
        (field, index) => getExportFieldKey(field, index) === active.id,
      );
      const newIndex = prevFields.findIndex(
        (field, index) => getExportFieldKey(field, index) === over.id,
      );

      if (oldIndex === -1 || newIndex === -1) return prevFields;
      return arrayMove(prevFields, oldIndex, newIndex);
    });
  };

  const toggleExportField = (field, index) => {
    const key = getExportFieldKey(field, index);
    if (isRequiredExportField(field)) return;

    setSelectedExportFieldKeys((prev) =>
      prev.includes(key)
        ? prev.filter((selectedKey) => selectedKey !== key)
        : [...prev, key],
    );
  };

  const handleSelectAllExportFields = () => {
    setSelectedExportFieldKeys((prev) =>
      prev.length === exportData.length
        ? exportData
            .filter(isRequiredExportField)
            .map((field, index) => getExportFieldKey(field, index))
        : exportData.map((field, index) => getExportFieldKey(field, index)),
    );
  };

  const handleResetExportFieldOrder = () => {
    fetchCandidateExportFields();
  };

  const handleExportCandidatesFromPopup = async () => {
    if (selectedExportFields.length === 0) {
      Toast("error", "Please select at least one field to export.");
      return;
    }

    await handleSimpleSearchCanExport({ fields: selectedExportFields });
    setIsExportFieldsPopupOpen(false);
  };

  const initializeWebSocket = useCallback(() => {
    if (isConnectingRef.current) {
      console.log("Already attempting to connect, skipping...");
      return;
    }
    const currentChannelId = chatChannelIdRef.current || chatChannelID;
    if (!currentChannelId) {
      console.log("No channel ID, skipping WebSocket initialization.");
      return;
    }
    isConnectingRef.current = true;
    if (socketRef.current) {
      socketRef.current.close();
    }
    if (pingIntervalRef.current) {
      clearInterval(pingIntervalRef.current);
      pingIntervalRef.current = null;
    }
    if (pingTimeoutRef.current) {
      clearTimeout(pingTimeoutRef.current);
      pingTimeoutRef.current = null;
    }
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }
    responseReceivedRef.current = false;

    const token = localStorage.getItem("token");
    const wsProtocol =
      window.location.protocol === "https:" ? "wss://" : "wss://";
    const channelIdForWs = chatChannelIdRef.current || chatChannelID;
    const wsUrl = `${wsProtocol}${WEB_SOCKET_URL}/ws?token=${encodeURIComponent(
      "Bearer " + token,
    )}&channel_id=${channelIdForWs}`;
    try {
      console.log("Creating new WebSocket connection...");
      const ws = new WebSocket(wsUrl);
      socketRef.current = ws;
      setSocket(ws);
      ws.onopen = () => {
        console.log("WebSocket connection established");
        setReconnectAttempts(0);
        isConnectingRef.current = false;
        if (lastMessageRef.current) {
          console.log("Resending last message:", lastMessageRef.current);
          ws.send(lastMessageRef.current);
        }
        if (messageQueueRef.current.length > 0) {
          console.log(
            `Processing ${messageQueueRef.current.length} queued messages`,
          );
          messageQueueRef.current.forEach((msg) => {
            if (ws.readyState === WebSocket.OPEN) {
              ws.send(msg);
            }
          });
          messageQueueRef.current = [];
        }
        startPingInterval(ws);
      };
      ws.onmessage = (event) => {
        if (event.data === "pong") {
          console.log("Pong received");
          if (pingTimeoutRef.current) {
            clearTimeout(pingTimeoutRef.current);
            pingTimeoutRef.current = null;
          }
          return;
        }
        try {
          console.log("WebSocket response received:", event.data);
          const separatorIndex = event.data.indexOf("|");
          const topic =
            separatorIndex !== -1
              ? event.data.substring(0, separatorIndex)
              : event.data;
          const payload =
            separatorIndex !== -1
              ? event.data.substring(separatorIndex + 1)
              : "";
          const trimmedTopic = topic.split(":")[0].trim();
          console.log("Parsed topic:", topic, "Trimmed topic:", trimmedTopic);
          const parseNestedJSON = (str) => {
            try {
              return JSON.parse(
                str
                  .replace(/^"+|"+$/g, "")
                  .replace(/\\"/g, '"')
                  .replace(/\\\\/g, "\\"),
              );
            } catch (error) {
              return {};
            }
          };
          const response = parseNestedJSON(payload);
          const findSimilarTopicWithID = `find-similar-resumes-completed:${userDetails?.id}`;
          setMessages((prev) => {
            const updated = [...prev];
            const loadingIndex = updated.findIndex(
              (msg) => msg.isLoading || msg.isStreaming,
            );
            if (trimmedTopic === "screening-message-delta") {
              if (!STREAMING_ENABLED) return updated;
              let chunk = "";
              try {
                chunk = JSON.parse(payload);
              } catch (e) {
                chunk = payload;
              }
              if (typeof chunk !== "string") {
                chunk = chunk == null ? "" : String(chunk);
              }
              if (loadingIndex !== -1 && chunk) {
                updated[loadingIndex] = {
                  ...updated[loadingIndex],
                  text: (updated[loadingIndex].text || "") + chunk,
                  isLoading: false,
                  isStreaming: true,
                };
              }
              return updated;
            }
            if (topic === findSimilarTopicWithID) {
              console.log("Find similar resumes completed:", response);
              responseReceivedRef.current = true;
              try {
                const similarResumes = Array.isArray(response)
                  ? response
                  : JSON.parse(payload);
                if (
                  Array.isArray(similarResumes) &&
                  similarResumes.length > 0
                ) {
                  fetchResumesList(
                    similarResumes,
                    updated[loadingIndex]?.id || uuidv4(),
                  );
                } else {
                  if (loadingIndex !== -1) {
                    updated[loadingIndex] = {
                      ...updated[loadingIndex],
                      text: "No similar resumes found.",
                      isLoading: false,
                      resumes: [],
                    };
                  }
                  setIsBotProcessing(false);
                  setShowBackToList(true);
                }
              } catch (error) {
                setShowBackToList(true);
              }
            } else if (trimmedTopic === "screening-send-message-completed") {
              console.log("Screening message completed:", response);
              responseReceivedRef.current = true;
              if (response && response.answer) {
                const candidateIds = [];
                const lines = response.answer.split("\n");
                lines.forEach((line) => {
                  const match = line.match(/Candidate ID:\s*([a-f0-9]+)/);
                  if (match) {
                    candidateIds.push(match[1]);
                  }
                });
                if (loadingIndex !== -1) {
                  const filteredAnswer = sanitizeBotText(response.answer);
                  const hasCandidates = candidateIds.length > 0;
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: filteredAnswer,
                    isLoading: false,
                    isStreaming: false,
                    resumes: [],
                    isResumesLoading: hasCandidates,
                  };
                  if (candidateIds.length > 0) {
                    fetchResumesList(candidateIds, updated[loadingIndex]?.id);
                  } else {
                    setIsBotProcessing(false);
                    setShowBackToList(true);
                  }
                }
              } else {
                console.error("Invalid response format:", response);
                if (loadingIndex !== -1) {
                  updated[loadingIndex] = {
                    ...updated[loadingIndex],
                    text: "Error: Invalid response format received.",
                    isLoading: false,
                    isResumesLoading: false,
                  };
                }
                setShowBackToList(true);
              }
            } else if (trimmedTopic === "screening-total-tokens-err") {
              console.log("Token limit exceeded:", response);
              responseReceivedRef.current = true;
              setOpenConversationLimitPopup(true);
            } else if (trimmedTopic === "screening-message-update") {
              console.log("Screening message update received:", response);
            } else {
              console.warn("Unhandled topic received:", topic);
              setShowBackToList(true);
            }
            return updated;
          });
          if (responseReceivedRef.current && ws.readyState === WebSocket.OPEN) {
            setTimeout(() => {
              ws.close(1000, "Response received, closing connection");
            }, 1000);
          }
        } catch (error) {
          console.error("Error processing WebSocket message:", error);
          setShowBackToList(true);
        }
      };
      ws.onclose = (event) => {
        console.log("WebSocket connection closed", event);
        isConnectingRef.current = false;
        if (pingIntervalRef.current) {
          clearInterval(pingIntervalRef.current);
          pingIntervalRef.current = null;
        }
        if (pingTimeoutRef.current) {
          clearTimeout(pingTimeoutRef.current);
          pingTimeoutRef.current = null;
        }
        if (
          event.code === 1006 ||
          (!responseReceivedRef.current && event.code !== 1000)
        ) {
          console.log(
            `Connection closed with code ${event.code}, attempting to reconnect...`,
          );
          handleReconnect();
        }
      };
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
        isConnectingRef.current = false;
        setShowBackToList(true);
        handleReconnect();
      };
    } catch (error) {
      console.error("Error creating WebSocket:", error);
      isConnectingRef.current = false;
      setShowBackToList(true);
      handleReconnect();
    }
  }, [
    startPingInterval,
    userDetails?.id,
    fetchResumesList,
    handleReconnect,
    chatChannelID,
  ]);

  const handleSimpleSearchCanExport = async (options = {}) => {
    try {
      const { fields: exportFields } = options;
      const searchSkills = normalizeSearchSkills(searchParams.skills);
      const minYearsOfExperience = normalizeSearchNumber(
        searchParams.minYearsOfExperience,
      );
      const maxYearsOfExperience = normalizeSearchNumber(
        searchParams.maxYearsOfExperience,
      );
      const searchFilterPayload = buildCandidateSearchFilterPayload(
        searchPagination.currentFilters.length > 0
          ? searchPagination.currentFilters
          : activeFilters,
        searchPagination.currentFilterBy !== undefined
          ? searchPagination.currentFilterBy
          : (isTrackedByMeActive && "tracked") ||
              (isCreatedByMeActive && "created") ||
              undefined,
      );
      const exportPayload = {
        ...searchFilterPayload,
        ...(searchParams.query && { query: searchParams.query }),
        ...(searchSkills.length > 0 && { skills: searchSkills }),
        ...(minYearsOfExperience !== "" && {
          min_years_of_experience: minYearsOfExperience,
        }),
        ...(maxYearsOfExperience !== "" && {
          max_years_of_experience: maxYearsOfExperience,
        }),
        ...(searchParams.industry && { industry: searchParams.industry }),
        ...(searchParams.location && { location: searchParams.location }),
        ...(exportFields?.length > 0 && {
          fields: exportFields.map((field, index) =>
            getExportFieldKey(field, index),
          ),
        }),
      };

      const exportWithCandidateIdsPayload = {
        candidate_ids: selectedCandidates.map((c) => c.id),
        ...(exportFields?.length > 0 && {
          fields: exportFields.map((field, index) =>
            getExportFieldKey(field, index),
          ),
        }),
      };
      const response = await post(
        VYLABS_BASE_URL,
        SIMPLE_SEARCH_CANDIDATES_EXCEL_EXPORT,
        selectedCandidates.length === 0
          ? exportPayload
          : exportWithCandidateIdsPayload,
      );
      if (response && response.url) {
        try {
          const fileResponse = await fetch(response.url);
          if (!fileResponse.ok) {
            throw new Error(`HTTP error! status: ${fileResponse.status}`);
          }
          const blob = await fileResponse.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          let filename = "candidates_export.xlsx";
          const urlParts = response.url.split("/");
          const lastPart = urlParts[urlParts.length - 1];
          const filenameMatch = lastPart.match(/[^?]+\.xlsx/);
          if (filenameMatch) {
            filename = filenameMatch[0];
          }
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
          Toast("success", "File downloaded successfully");
        } catch (downloadError) {
          console.error("Error downloading file:", downloadError);
        }
      }
    } catch (error) {
      console.log("handleSimpleSearchCanExport", error);
      Toast("error", "Failed to generate export. Please try again.");
    }
  };

  const handleSimpleSearch = useCallback(
    async (page = 1, options = {}) => {
      const {
        replaceResults = allCandidatesViewTab === 1,
        query: optionQuery,
        skills: optionSkills,
        minExp: optionMinExp,
        maxExp: optionMaxExp,
        industry: optionIndustry,
        loc: optionLoc,
        filters: optionFilters,
        filterBy: optionFilterBy,
      } = options;
      let query, minExp, maxExp, searchSkills, industry, loc;
      let appliedFilters, appliedFilterBy;

      if (page === 1) {
        query = normalizeSearchValue(
          optionQuery !== undefined ? optionQuery : formik.values.askmeanything,
        );
        searchSkills = normalizeSearchValue(
          optionSkills !== undefined ? optionSkills : skillsValue,
        );
        minExp = normalizeSearchValue(
          optionMinExp !== undefined ? optionMinExp : minYearsOfExperienceValue,
        );
        maxExp = normalizeSearchValue(
          optionMaxExp !== undefined ? optionMaxExp : maxYearsOfExperienceValue,
        );
        industry = normalizeSearchValue(
          optionIndustry !== undefined ? optionIndustry : industryValue,
        );
        loc = normalizeSearchValue(
          optionLoc !== undefined ? optionLoc : locationValue,
        );
        appliedFilters = Array.isArray(optionFilters)
          ? optionFilters
          : activeFilters;
        appliedFilterBy =
          optionFilterBy !== undefined
            ? optionFilterBy
            : isTrackedByMeActive
              ? "tracked"
              : isCreatedByMeActive
                ? "created"
                : undefined;
      } else {
        query = normalizeSearchValue(searchPagination.currentQuery);
        searchSkills = normalizeSearchValue(searchPagination.currentSkills);
        minExp = normalizeSearchValue(
          searchPagination.currentMinYearsOfExperience,
        );
        maxExp = normalizeSearchValue(
          searchPagination.currentMaxYearsOfExperience,
        );
        industry = normalizeSearchValue(searchPagination.currentIndustry);
        loc = normalizeSearchValue(searchPagination.currentLocation);
        appliedFilters = searchPagination.currentFilters || [];
        appliedFilterBy = searchPagination.currentFilterBy;
      }

      const skillsArray = normalizeSearchSkills(searchSkills);
      const minYearsOfExperience = normalizeSearchNumber(minExp);
      const maxYearsOfExperience = normalizeSearchNumber(maxExp);
      const searchFilterPayload = buildCandidateSearchFilterPayload(
        appliedFilters,
        appliedFilterBy,
      );

      if (
        !query &&
        skillsArray.length === 0 &&
        minYearsOfExperience === "" &&
        maxYearsOfExperience === "" &&
        !industry &&
        !loc &&
        Object.keys(searchFilterPayload).length === 0
      ) {
        Toast("error", "Please enter at least one search criteria.");
        return;
      }

      const pageSize = allCandidatesViewTab === 1 ? 10 : 20;
      const requestKey = [
        page,
        pageSize,
        query || "",
        skillsArray.join(","),
        minExp || "",
        maxExp || "",
        industry || "",
        loc || "",
        JSON.stringify(appliedFilters || []),
        appliedFilterBy || "",
        replaceResults ? "replace" : "append",
      ].join("|");

      if (simpleSearchRequestKeyRef.current === requestKey) {
        return;
      }

      const requestSeq = simpleSearchRequestSeqRef.current + 1;
      simpleSearchRequestSeqRef.current = requestSeq;
      simpleSearchRequestKeyRef.current = requestKey;

      try {
        if (simpleSearchAbortRef.current) {
          try {
            simpleSearchAbortRef.current.abort();
          } catch (_) {}
        }

        const controller = new AbortController();
        simpleSearchAbortRef.current = controller;

        if (page === 1) {
          setIsSimpleSearchLoading(true);
          setShowExportButton(false);
          setSearchPagination((prev) => ({ ...prev, isLoadingMore: false }));
          if (topRef.current) {
            topRef.current.scrollIntoView({ behavior: "auto", block: "start" });
          }
          window.scrollTo(0, 0);
        } else {
          setSearchPagination((prev) => ({ ...prev, isLoadingMore: true }));
        }

        if (page === 1) {
          setSearchParams({
            query: query,
            skills: searchSkills,
            minYearsOfExperience: minExp,
            maxYearsOfExperience: maxExp,
            industry,
            location: loc,
          });
        }

        setHasSearched(true);
        setShowBackToList(false);
        setIsSelectMode(false);
        setSelectedCandidates([]);
        const payload = {
          page,
          limit: pageSize,
          ...searchFilterPayload,
          ...(query && { query }),
          ...(skillsArray.length > 0 && { skills: skillsArray }),
          ...(minYearsOfExperience !== "" && {
            min_years_of_experience: minYearsOfExperience,
          }),
          ...(maxYearsOfExperience !== "" && {
            max_years_of_experience: maxYearsOfExperience,
          }),
          ...(industry && { industry }),
          ...(loc && { location: loc }),
        };
        const response = await post(
          VYLABS_BASE_URL,
          SIMPLE_SEARCH_CANDIDATES,
          payload,
          { timeout: 45000, signal: controller.signal },
        );

        if (simpleSearchRequestSeqRef.current !== requestSeq) {
          return;
        }

        const {
          candidates = [],
          total_candidates = 0,
          total_pages = 1,
          page: currentPage = 1,
          has_more = false,
        } = response;

        setSearchResultCandidates((prev) =>
          page === 1 || replaceResults ? candidates : [...prev, ...candidates],
        );

        setSearchResultCandidateIds((prev) =>
          page === 1 || replaceResults
            ? candidates.map((c) => c.id)
            : [...prev, ...candidates.map((c) => c.id)],
        );

        setSearchPagination((prev) => ({
          ...prev,
          currentPage: currentPage,
          totalPages: total_pages,
          totalCandidates: total_candidates,
          hasMore: has_more,
          allSearchResults:
            page === 1 || replaceResults
              ? candidates
              : [...prev.allSearchResults, ...candidates],
          isLoadingMore: false,
          currentQuery: page === 1 ? query : prev.currentQuery,
          currentSkills: page === 1 ? searchSkills : prev.currentSkills,
          currentMinYearsOfExperience:
            page === 1 ? minExp : prev.currentMinYearsOfExperience,
          currentMaxYearsOfExperience:
            page === 1 ? maxExp : prev.currentMaxYearsOfExperience,
          currentIndustry: page === 1 ? industry : prev.currentIndustry,
          currentLocation: page === 1 ? loc : prev.currentLocation,
          currentFilters: page === 1 ? appliedFilters : prev.currentFilters,
          currentFilterBy: page === 1 ? appliedFilterBy : prev.currentFilterBy,
        }));
        if (page === 1 && candidates.length > 0) {
          setShowExportButton(true);
        }
        if (candidates.length === 0 && page === 1) {
          Toast("info", "No candidates found matching your search.");
          setShowExportButton(false);
        } else if (candidates.length > 0 && page === 1) {
          Toast("success", `Found ${total_candidates} candidates`);
        }
      } catch (error) {
        console.error("Failed to search candidates. Please try again.", error);
        if (error.name !== "AbortError") {
          Toast("error", "Failed to search candidates. Please try again.");
          setShowExportButton(false);
        }
      } finally {
        if (simpleSearchRequestSeqRef.current === requestSeq) {
          if (page === 1) {
            setIsSimpleSearchLoading(false);
          }
          setSearchPagination((prev) => ({ ...prev, isLoadingMore: false }));
          simpleSearchAbortRef.current = null;
          simpleSearchRequestKeyRef.current = "";
        }
      }
    },
    [
      formik.values,
      searchPagination.currentQuery,
      skillsValue,
      minYearsOfExperienceValue,
      maxYearsOfExperienceValue,
      industryValue,
      locationValue,
      allCandidatesViewTab,
      searchPagination.currentSkills,
      searchPagination.currentMinYearsOfExperience,
      searchPagination.currentMaxYearsOfExperience,
      searchPagination.currentIndustry,
      searchPagination.currentLocation,
      searchPagination.currentFilters,
      searchPagination.currentFilterBy,
      activeFilters,
      AdminAccess,
      isTrackedByMeActive,
      isCreatedByMeActive,
    ],
  );
  const loadMoreSearchResults = useCallback(() => {
    if (
      searchPagination.hasMore &&
      !searchPagination.isLoadingMore &&
      !isSimpleSearchLoading &&
      searchPagination.currentPage < searchPagination.totalPages
    ) {
      const nextPage = searchPagination.currentPage + 1;
      handleSimpleSearch(nextPage);
    }
  }, [
    searchPagination.hasMore,
    searchPagination.isLoadingMore,
    searchPagination.currentPage,
    searchPagination.totalPages,
    isSimpleSearchLoading,
  ]);

  const lastSearchElement = useCallback(
    (node) => {
      if (searchObserver.current) {
        searchObserver.current.disconnect();
      }

      if (allCandidatesViewTab === 1) return;
      if (isSimpleSearchLoading || searchPagination.isLoadingMore) return;

      searchObserver.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && searchPagination.hasMore) {
            setTimeout(() => {
              loadMoreSearchResults();
            }, 100);
          }
        },
        {
          root: null,
          rootMargin: "100px",
          threshold: 0.1,
        },
      );

      if (node) {
        searchObserver.current.observe(node);
      }
    },
    [
      isSimpleSearchLoading,
      allCandidatesViewTab,
      searchPagination.hasMore,
      searchPagination.isLoadingMore,
      loadMoreSearchResults,
    ],
  );

  useEffect(() => {
    return () => {
      if (searchObserver.current) {
        searchObserver.current.disconnect();
        searchObserver.current = null;
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (simpleSearchAbortRef.current) {
        try {
          simpleSearchAbortRef.current.abort();
        } catch (_) {}
      }
    };
  }, [chatChannelID]);

  useEffect(() => {
    if (
      pendingScrollToChat &&
      showCepheaChat &&
      hasSearched &&
      !isSimpleSearchLoading &&
      searchResultCandidates.length > 0 &&
      cepheaChatRef.current
    ) {
      try {
        cepheaChatRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      } catch (_) {}
      setPendingScrollToChat(false);
    }
  }, [
    pendingScrollToChat,
    showCepheaChat,
    hasSearched,
    isSimpleSearchLoading,
    searchResultCandidates.length,
  ]);
  const handleClearSimpleSearch = useCallback(() => {
    setHasSearched(false);
    setSearchResultCandidates([]);
    setSearchResultCandidateIds([]);
    simpleSearchRequestKeyRef.current = "";
    simpleSearchRequestSeqRef.current += 1;
    if (simpleSearchAbortRef.current) {
      try {
        simpleSearchAbortRef.current.abort();
      } catch (_) {}
      simpleSearchAbortRef.current = null;
    }
    setMessages([]);
    setSkillsValue("");
    setMinYearsOfExperienceValue("");
    setMaxYearsOfExperienceValue("");
    setIndustryValue("");
    setLocationValue("");
    setChatChannelID(null);
    chatChannelIdRef.current = null;
    setIsBotProcessing(false);
    setShowCepheaChat(false);
    setPendingScrollToChat(false);
    formik.resetForm();
    setHasSentCandidateIds(false);
    setCurrentChannelForContext(null);
    setShowExportButton(false);
    setIsSelectMode(false);
    setSelectedCandidates([]);
    setSearchPagination({
      currentPage: 1,
      totalPages: 1,
      totalCandidates: 0,
      hasMore: false,
      allSearchResults: [],
      isLoadingMore: false,
      currentQuery: "",
      currentSkills: "",
      currentMinYearsOfExperience: "",
      currentMaxYearsOfExperience: "",
      currentIndustry: "",
      currentLocation: "",
      currentFilters: [],
      currentFilterBy: undefined,
    });
    setSearchParams({
      query: "",
      skills: "",
      minYearsOfExperience: "",
      maxYearsOfExperience: "",
      industry: "",
      location: "",
    });
    if (searchObserver.current) {
      searchObserver.current.disconnect();
      searchObserver.current = null;
    }
  }, []);

  const handleCandidateConversation = useCallback(async () => {
    const { askmeanything } = formik.values;
    const hasUserQuery = askmeanything?.trim();
    const hasUploadedFiles = AiDrivenUploadedFiles.length > 0;
    if (hasUploadedFiles && !hasUserQuery) {
      Toast("error", "Please provide a message along with the file.");
      return;
    } else if (!hasUserQuery && !hasUploadedFiles) {
      Toast("error", "Please provide a message or upload a file.");
      return;
    }
    setHasSearched(true);
    setShowBackToList(true);
    setIsBotProcessing(true);
    const messageId = uuidv4();
    const botMessageId = uuidv4();
    setMessages((prevMessages) => [
      ...prevMessages,
      {
        id: messageId,
        sender: "user",
        text: hasUserQuery ? askmeanything : "File uploaded",
        files: hasUploadedFiles ? AiDrivenUploadedFiles : [],
      },
      { id: botMessageId, sender: "bot", text: "", isLoading: true },
    ]);

    try {
      let channelID = chatChannelID;
      let isNewChannel = false;

      if (!channelID || channelID === "null" || channelID === "undefined") {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: "candidate" },
        );
        channelID = createChatChannelResponse.ID;
        setChatChannelID(channelID);
        chatChannelIdRef.current = channelID;
        isNewChannel = true;
      }

      if (isNewChannel) {
        const titlePayload = {
          chat_channel_id: channelID,
          message: askmeanything || "File uploaded",
        };
        if (hasUploadedFiles) {
          titlePayload.file_name = AiDrivenUploadedFiles[0].name;
        }
        post(
          VYLABS_BASE_URL,
          GET_CURRENT_CONVERSATION_TITLE,
          titlePayload,
        ).catch((error) =>
          console.error("Error setting conversation title:", error),
        );
      }

      const formData = new FormData();
      formData.append("channel_id", channelID);
      formData.append("message_content", askmeanything || "");
      if (hasUploadedFiles) {
        formData.append("file", AiDrivenUploadedFiles[0]);
      }
      const shouldSendContext =
        searchResultCandidateIds.length > 0 &&
        !sentSimpleSearchContextChannelIds.has(channelID);
      if (shouldSendContext) {
        formData.append(
          "candidate_id",
          JSON.stringify(searchResultCandidateIds),
        );
        sentSimpleSearchContextChannelIds.add(channelID);
      }

      await post(VYLABS_BASE_URL, PROCESS_CANDIDATE_CONVERSATION, formData);
      if (shouldSendContext) {
        sentSimpleSearchContextChannelIds.add(channelID);
      }
      setChatChannelID(channelID);
      chatChannelIdRef.current = channelID;
      initializeWebSocket();
    } catch (error) {
      console.error("Error in candidate conversation:", error);
      if (
        error.response?.data &&
        error.response.data.includes("chat channel is blocked")
      ) {
        setMessages((prev) =>
          prev.filter((msg) => msg.id !== messageId && msg.id !== botMessageId),
        );
        setOpenConversationLimitPopup(true);
        setIsBotProcessing(false);
      } else {
        setMessages((prev) => {
          const updated = [...prev];
          const loadingIndex = updated.findIndex((msg) => msg.isLoading);
          if (loadingIndex !== -1) {
            updated[loadingIndex] = {
              sender: "system",
              text: "Error processing request. Please try again.",
              isLoading: false,
            };
          }
          return updated;
        });
      }
    } finally {
      formik.resetForm();
      setAiDrivenUploadedFiles([]);
    }
  }, [
    formik.values,
    AiDrivenUploadedFiles,
    chatChannelID,
    initializeWebSocket,
    searchResultCandidateIds,
    messages.length,
  ]);

  const handleFilterCandidateConversation = useCallback(async () => {
    const query = filterChatInput?.trim();
    if (!query) {
      Toast("error", "Please provide a message.");
      return;
    }

    setIsBotProcessing(true);
    const messageId = uuidv4();
    const botMessageId = uuidv4();

    setMessages((prevMessages) => [
      ...prevMessages,
      {
        id: messageId,
        sender: "user",
        text: query,
        files: [],
      },
      { id: botMessageId, sender: "bot", text: "", isLoading: true },
    ]);

    try {
      let channelID = chatChannelID;
      let isNewChannel = false;
      let shouldSendCandidateIds = false;

      if (!channelID || channelID === "null" || channelID === "undefined") {
        const createChatChannelResponse = await post(
          VYLABS_BASE_URL,
          CREATE_CHAT_CHANNEL_URL,
          { chat_channel_type: "candidate" },
        );
        channelID = createChatChannelResponse.ID;
        setChatChannelID(channelID);
        chatChannelIdRef.current = channelID;
        isNewChannel = true;
        setCurrentChannelForContext(channelID);
        setHasSentCandidateIds(false);
        shouldSendCandidateIds = true;
      } else if (channelID !== currentChannelForContext) {
        setCurrentChannelForContext(channelID);
        setHasSentCandidateIds(false);
        shouldSendCandidateIds = true;
      }

      if (isNewChannel) {
        const titlePayload = {
          chat_channel_id: channelID,
          message: query,
        };
        post(
          VYLABS_BASE_URL,
          GET_CURRENT_CONVERSATION_TITLE,
          titlePayload,
        ).catch((error) =>
          console.error("Error setting conversation title:", error),
        );
      }

      const formData = new FormData();
      formData.append("channel_id", channelID);
      formData.append("message_content", query);

      const candidateIds = selectedCandidates.map((c) => c.id);

      if (
        candidateIds.length > 0 &&
        (shouldSendCandidateIds || !hasSentCandidateIds)
      ) {
        formData.append("candidate_id", JSON.stringify(candidateIds));
        setHasSentCandidateIds(true);
      }
      await post(VYLABS_BASE_URL, PROCESS_CANDIDATE_CONVERSATION, formData);

      setChatChannelID(channelID);
      chatChannelIdRef.current = channelID;
      initializeWebSocket();
    } catch (error) {
      console.error("Error in filter candidate conversation:", error);
      if (
        error.response?.data &&
        error.response.data.includes("chat channel is blocked")
      ) {
        setMessages((prev) =>
          prev.filter((msg) => msg.id !== messageId && msg.id !== botMessageId),
        );
        setOpenConversationLimitPopup(true);
        setIsBotProcessing(false);
      } else {
        setMessages((prev) => {
          const updated = [...prev];
          const loadingIndex = updated.findIndex((msg) => msg.isLoading);
          if (loadingIndex !== -1) {
            updated[loadingIndex] = {
              sender: "system",
              text: "Error processing request. Please try again.",
              isLoading: false,
            };
          }
          return updated;
        });
      }
    } finally {
      setFilterChatInput("");
    }
  }, [
    filterChatInput,
    chatChannelID,
    initializeWebSocket,
    selectedCandidates,
    currentChannelForContext,
    hasSentCandidateIds,
  ]);

  const SearchFilterPills = ({
    query,
    skills,
    minYearsOfExperience,
    maxYearsOfExperience,
    industry,
    location,
  }) => {
    const filters = [];

    if (query && query.trim()) {
      filters.push({ value: query, type: "query" });
    }
    if (skills && skills.trim()) {
      filters.push({ value: `Skills: ${skills}`, type: "skills" });
    }
    if (minYearsOfExperience && minYearsOfExperience.trim()) {
      filters.push({
        value: `Min ${minYearsOfExperience} yrs`,
        type: "minExp",
      });
    }
    if (maxYearsOfExperience && maxYearsOfExperience.trim()) {
      filters.push({
        value: `Max ${maxYearsOfExperience} yrs`,
        type: "maxExp",
      });
    }
    if (industry && industry.trim()) {
      filters.push({ value: `Industry: ${industry}`, type: "industry" });
    }
    if (location && location.trim()) {
      filters.push({ value: location, type: "location" });
    }

    return (
      <div
        style={{
          display: "flex",
          gap: "8px",
          flexDirection: "row",
          alignItems: "center",
          whiteSpace: "nowrap",
        }}
      >
        {filters.map((filter, index) => (
          <FilterPill key={`${filter.type}-${index}`} value={filter.value} />
        ))}
      </div>
    );
  };

  const handleBackToList = () => {
    setShowBackToList(false);
    setHasSearched(false);
    setMessages([]);
    setChatChannelID(null);
    chatChannelIdRef.current = null;
    setShowFilterCepheaChat(false);
    setIsBotProcessing(false);
    setShowCepheaChat(false);
    setPendingScrollToChat(false);
    setIsSelectMode(false);
    setSelectedCandidates([]);
    setSearchResultCandidates([]);
    setSearchResultCandidateIds([]);
    simpleSearchRequestKeyRef.current = "";
    simpleSearchRequestSeqRef.current += 1;
    if (simpleSearchAbortRef.current) {
      try {
        simpleSearchAbortRef.current.abort();
      } catch (_) {}
      simpleSearchAbortRef.current = null;
    }
    formik.resetForm();
    setSkillsValue("");
    setMinYearsOfExperienceValue("");
    setMaxYearsOfExperienceValue("");
    setIndustryValue("");
    setLocationValue("");
    setSearchQuery("");
    setSearchParams({
      query: "",
      skills: "",
      minYearsOfExperience: "",
      maxYearsOfExperience: "",
      industry: "",
      location: "",
    });
  };

  const handleSearchBoxCollapse = (isCollapsed) => {
    setIsSearchBoxCollapsed(isCollapsed);
  };

  const handleClearSearchForm = () => {
    formik.setFieldValue("jobDescription", "");
    formik.setFieldValue("askmeanything", "");
    setSkillsValue("");
    setMinYearsOfExperienceValue("");
    setMaxYearsOfExperienceValue("");
    setIndustryValue("");
    setLocationValue("");
    setAiDrivenUploadedFiles([]);
  };

  const mergeCandidateLists = (prevList, newList, isReset = false) => {
    if (isReset) return newList;
    const updatedList = prevList.map((existing) => {
      const incoming = newList.find((n) => n.id === existing.id);
      if (!incoming) return existing;
      const safeUpdates = Object.fromEntries(
        Object.entries(incoming).filter(([_, v]) => v != null),
      );
      return { ...existing, ...safeUpdates };
    });
    const appended = newList.filter(
      (n) => !prevList.some((e) => e.id === n.id),
    );
    return [...updatedList, ...appended];
  };

  const buildCandidateListPayload = (
    customOffset = 0,
    filters = [],
    filterBy,
  ) => {
    const page = Math.floor(customOffset / 10) + 1;
    const stageFilter = filters.find((f) => f.type === "call_stage")?.value;
    const dateFilter = filters.find((f) => f.type === "date")?.value;
    const fromDateFilter = filters.find((f) => f.type === "from_date")?.value;
    const toDateFilter = filters.find((f) => f.type === "to_date")?.value;
    const userFilter = filters.find((f) => f.type === "user_id")?.value;
    const industry = filters.find((f) => f.type === "industry")?.value;
    const timeParam = timeMap[dateFilter] || "";
    const jobIdFilter = filters.find((f) => f.type === "job_id")?.value;

    return filterPayload({
      page,
      limit: 10,
      filter_by: filterBy,
      stages: stageFilter,
      time: timeParam,
      from_date: formatCandidateFilterDate(fromDateFilter),
      end_date: formatCandidateFilterDate(toDateFilter),
      user_id: AdminAccess ? userFilter : undefined,
      industry,
      filter_job_id: jobIdFilter,
    });
  };

  function buildCandidateSearchFilterPayload(filters = [], filterBy) {
    const stageFilter = filters.find((f) => f.type === "call_stage")?.value;
    const dateFilter = filters.find((f) => f.type === "date");
    const fromDateFilter = filters.find((f) => f.type === "from_date")?.value;
    const toDateFilter = filters.find((f) => f.type === "to_date")?.value;
    const userFilter = filters.find((f) => f.type === "user_id")?.value;
    const industry = filters.find((f) => f.type === "industry")?.value;
    const timeParam = timeMap[dateFilter?.value] || "";
    const isTrackingDate = dateFilter?.dateFilterType === "tracked";
    const jobIdFilter = filters.find((f) => f.type === "job_id")?.value;

    return filterPayload({
      filter_by: filterBy,
      stages: stageFilter,
      time: isTrackingDate ? undefined : timeParam,
      tracking_time: isTrackingDate ? timeParam : undefined,
      created_from_date: timeParam
        ? undefined
        : formatCandidateFilterDate(fromDateFilter),
      created_end_date: timeParam
        ? undefined
        : formatCandidateFilterDate(toDateFilter),
      tracking_from_date: timeParam
        ? undefined
        : formatCandidateFilterDate(
            filters.find((f) => f.type === "tracking_from_date")?.value,
          ),
      tracking_end_date: timeParam
        ? undefined
        : formatCandidateFilterDate(
            filters.find((f) => f.type === "tracking_end_date")?.value,
          ),
      user_id: AdminAccess ? userFilter : undefined,
      industry,
      filter_job_id: jobIdFilter,
    });
  }

  const buildCandidateExportPayload = (
    filters = [],
    isTracked = false,
    isCreated = false,
  ) => {
    const stageFilter = filters.find((f) => f.type === "call_stage")?.value;
    const dateFilter = filters.find((f) => f.type === "date")?.value;
    const fromDateFilter = filters.find((f) => f.type === "from_date")?.value;
    const toDateFilter = filters.find((f) => f.type === "to_date")?.value;
    const userFilter = filters.find((f) => f.type === "user_id")?.value;
    const industry = filters.find((f) => f.type === "industry")?.value;
    const timeParam = timeMap[dateFilter] || "";

    return filterPayload({
      limit: 10000,
      filter_by: isTracked ? "tracked" : isCreated ? "created" : undefined,
      stage: stageFilter,
      time: timeParam,
      from_date: formatCandidateFilterDate(fromDateFilter),
      end_date: formatCandidateFilterDate(toDateFilter),
      user_id: AdminAccess ? userFilter : undefined,
      industry,
    });
  };

  const fetchCandidatesCreatedByMe = async (customOffset = 0, filters = []) => {
    const payload = buildCandidateListPayload(customOffset, filters, "created");

    if (customOffset === 0) {
      setIsByMeInitialLoading(true);
    } else {
      setIsByMeLoadingMore(true);
    }
    try {
      const response = await post(VYLABS_BASE_URL, CAN_LIST, payload);
      const cand = response?.candidates || [];
      const candidatesWithDetails = cand
        .map((candidateData) => {
          const candidate = candidateData;
          const { applications, files } = candidateData;
          return {
            ...candidate,
            files: files || null,
            applications: applications || [],
          };
        })
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setByMeCanList((prev) =>
        mergeCandidateLists(prev, candidatesWithDetails, customOffset === 0),
      );
      setHasMoreByMe(candidatesWithDetails.length >= 10);
    } catch (err) {
      console.error("GET_CANDIDATE_TRACK_BY_USER error", err);
    } finally {
      if (customOffset === 0) {
        setIsByMeInitialLoading(false);
        setIsByMeFetchCompleted(true);
      } else {
        setIsByMeLoadingMore(false);
      }
    }
  };

  const DateTimeCell = ({ value }) => {
    if (!value) return <span>N/A</span>;

    const date = new Date(value);
    const fullDateTime = Number.isNaN(date.getTime())
      ? String(value)
      : date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

    return (
      <CustomTooltip title={fullDateTime} arrow>
        <span>{formatDateTime(value)}</span>
      </CustomTooltip>
    );
  };

  const fetchTrackedCandidates = async (customOffset = 0, filters = []) => {
    const payload = buildCandidateListPayload(customOffset, filters, "tracked");

    if (customOffset === 0) {
      setIsMyInitialLoading(true);
    } else {
      setIsMyLoadingMore(true);
    }
    try {
      const response = await post(VYLABS_BASE_URL, CAN_LIST, payload);
      const cand = response?.candidates || [];
      const candidatesWithDetails = cand.map((candidateData) => {
        const candidate = candidateData;
        const { applications, files } = candidateData;
        return {
          ...candidate,
          files: files || null,
          applications: applications || [],
        };
      });
      setMyCanList((prev) =>
        mergeCandidateLists(prev, candidatesWithDetails, customOffset === 0),
      );
      setHasMoreMy(candidatesWithDetails.length >= 10);
    } catch (err) {
      console.error("GET_CANDIDATE_TRACKED_BY_ME error", err);
    } finally {
      if (customOffset === 0) {
        setIsMyInitialLoading(false);
        setIsMyFetchCompleted(true);
      } else {
        setIsMyLoadingMore(false);
      }
    }
  };

  const fetchJobDetailsById = useCallback(async (jobId) => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_JOB_DETAILS_BY_ID}?id=${jobId}`,
      );
      return response?.job || null;
    } catch (error) {
      console.error("Error fetching job details for ID", jobId, ":", error);
      return null;
    }
  }, []);

  const columnsDefinition = useMemo(() => [
    {
      name: "Candidate Name",
      selector: (row) => row.name || "N/A",
      cell: (row) => <CandidateNameCell row={row} />,
    },
    {
      name: "Candidate Email",
      selector: (row) => row.email || "N/A",
      width: "250px",
      minWidth: "130px",
      maxWidth: "270px",
    },
    {
      name: "Candidate Contact",
      selector: (row) => row.phone || "N/A",
      width: "130px",
      minWidth: "110px",
      maxWidth: "150px",
    },
    {
      name: "Created At",
      selector: (row) => row.created_at,
      cell: (row) => <DateTimeCell value={row.created_at} />,
      sortable: true,
      width: "180px",
      minWidth: "150px",
    },
    {
      name: "Updated At",
      selector: (row) => row.updated_at,
      cell: (row) => <DateTimeCell value={row.updated_at} />,
      sortable: true,
      width: "180px",
      minWidth: "150px",
    },
    {
      name: "Action",
      cell: (row) => <CandidateActionCell row={row} onView={handleCardView} />,
      width: "90px",
      center: true,
      ignoreRowClick: true,
      allowOverflow: true,
    },
    // {
    //   name: "Latest Stage",
    //   selector: (row) => {
    //     if (!row.applications || row.applications.length === 0) return "N/A";
    //     const latestApp = row.applications.reduce((latest, current) => {
    //       return new Date(current.updated_at) > new Date(latest.updated_at) ? current : latest;
    //     });
    //     return latestApp?.stage || "N/A";
    //   },
    //   cell: (row) => {
    //     if (!row.applications || row.applications.length === 0) {
    //       return <span>N/A</span>;
    //     }
    //     const latestApp = row.applications.reduce((latest, current) => {
    //       return new Date(current.updated_at) > new Date(latest.updated_at) ? current : latest;
    //     });
    //     const stage = latestApp?.stage || "N/A";
    //     return (
    //       <span
    //         style={{
    //           backgroundColor: getStageColor(stage),
    //           color: "white",
    //           padding: "4px 12px",
    //           borderRadius: "20px",
    //           fontSize: "13px",
    //         }}
    //       >
    //         {stage}
    //       </span>
    //     );
    //   },
    // },
    {
      name: "Assigned Job",
      selector: (row) => {
        if (!row.applications || row.applications.length === 0) {
          return "Job not yet assigned";
        }
        const latestApp = row.applications.reduce((latest, current) => {
          return new Date(current.updated_at) > new Date(latest.updated_at)
            ? current
            : latest;
        }, row.applications[0]);
        return latestApp?.job_title || "Job not yet assigned";
      },
      cell: (row) => {
        if (!row.applications || row.applications.length === 0) {
          return <span>Job not yet assigned</span>;
        }
        const latestApp = row.applications.reduce((latest, current) => {
          return new Date(current.updated_at) > new Date(latest.updated_at)
            ? current
            : latest;
        }, row.applications[0]);

        const jobTitle = latestApp?.job_title;
        const remainingJobsCount = row.applications.length - 1;

        if (!jobTitle) {
          return <span>Job not yet assigned</span>;
        }

        return (
          <CustomTooltip title={jobTitle} arrow>
            <span>
              {applyEllipsis(jobTitle, 30)}
              {remainingJobsCount > 0 && (
                <span
                  style={{
                    color: "#6860ee",
                    fontWeight: "bold",
                    marginLeft: "5px",
                  }}
                >
                  +{remainingJobsCount}
                </span>
              )}
            </span>
          </CustomTooltip>
        );
      },
    },
  ]);

  const timeMap = {
    Today: "today",
    Yesterday: "yesterday",
    "This week": "this_week",
    "This month": "this_month",
    "This Year": "this_year",
  };

  const fetchCandidates = async (customOffset = 0, filters = []) => {
    const payload = buildCandidateListPayload(customOffset, filters);

    if (customOffset === 0) {
      setIsAllInitialLoading(true);
    } else {
      setIsAllLoadingMore(true);
    }
    try {
      const response = await post(VYLABS_BASE_URL, CAN_LIST, payload);
      const cand = response?.candidates || [];
      const candidatesWithDetails = cand.map((candidateData) => {
        const candidate = candidateData;
        return {
          ...candidate,
          files: candidateData.files || null,
          applications: candidateData.applications || [],
        };
      });

      setAllCanList((prev) =>
        mergeCandidateLists(prev, candidatesWithDetails, customOffset === 0),
      );
      setHasMoreAll(candidatesWithDetails.length >= 10);
    } catch (err) {
      console.error("GET_CAN_LIST_URL error", err);
    } finally {
      if (customOffset === 0) {
        setIsAllInitialLoading(false);
        setIsAllFetchCompleted(true);
      } else {
        setIsAllLoadingMore(false);
      }
      setRefetchCanList(false);
    }
  };
  useEffect(() => {
    if (!refetchCanList) return;

    if (isTrackedByMeActive) {
      fetchTrackedCandidates(0, activeFilters).finally(() =>
        setRefetchCanList(false),
      );
    } else if (isCreatedByMeActive) {
      fetchCandidatesCreatedByMe(0, activeFilters).finally(() =>
        setRefetchCanList(false),
      );
    } else {
      fetchCandidates(0, activeFilters);
    }
  }, [refetchCanList]);

  const fetchCandidateById = useCallback(async (id) => {
    try {
      const res = await get(VYLABS_BASE_URL, `${GET_CANDIDATE_BY_ID}?id=${id}`);
      const candidate = res?.candidate;
      const candidatefiles = res?.files;
      let parsedResumeData = {};
      if (candidate?.parsed_resume && candidate.parsed_resume.trim() !== "") {
        try {
          parsedResumeData = JSON.parse(candidate.parsed_resume);
        } catch (error) {
          console.error("Error parsing resume data:", error);
          parsedResumeData = {};
        }
      }
      const presignedUrl =
        candidatefiles && candidatefiles.length > 0
          ? candidatefiles[0].presigned_url
          : null;

      const updatedCandidate = {
        ...candidate,
        secondaryEmail: candidate.secondary_email,
        secondaryPhone: candidate.secondary_phone,
        vendorID: candidate.vendor_id,
        parsedResumeData,
        files: candidatefiles || null,
        presignedUrl,
        isFileBased: false,
        avatar: res?.profile_img_url,
        preferredSalary: candidate.preferred_salary,
        lineAddress1: candidate.line_address_1,
        lineAddress2: candidate.line_address_2,
        zipCode: candidate.zip_code,
        designation: candidate.designation,
        source: candidate.source,
        industry: candidate.industry,
        experience: candidate.years_of_experience,
      };
      if (updatedCandidate.vendorID) {
        try {
          const vendorResponse = await get(
            VYLABS_BASE_URL,
            `${GET_VENDOR_DETAILS_BY_ID}?id=${updatedCandidate.vendorID}`,
          );
          setAssignedVendor(vendorResponse);
          updatedCandidate.vendorDetails = vendorResponse?.vendor || null;
        } catch (err) {
          console.error("Error fetching vendor details:", err);
          updatedCandidate.vendorDetails = null;
        }
      } else {
        updatedCandidate.vendorDetails = null;
      }
      setSelectedCandidate(updatedCandidate);
      setIsModalOpen(true);
      setIsCandidateDetailsLoading(false);
      return updatedCandidate;
    } catch (error) {
      console.error("Error fetching candidate:", error);
      Toast(
        "error",
        error.response.data || "Failed to fetch candidate details.",
      );
      setIsModalOpen(false);
      setAssignedVendor(null);
      setActiveTab(0);
      setSelectedCandidate(null);
      setIsCandidateDetailsLoading(false);
    }
  }, []);
  const fetchRecommendedJobs = useCallback(async (candidate) => {
    try {
      const locationParts = [
        candidate?.city,
        candidate?.state,
        candidate?.country,
      ]
        .filter((part) => typeof part === "string" && part.trim())
        .map((part) => part.trim());

      const payload = {
        limit: JOBS_PAGE_SIZE,
        active_only: true,
        page: 1,
        // Opt into the backend LLM re-ranker: jobs are scored for fitness
        // against this candidate's profile and returned with a `fitness` tier.
        rerank: true,
      };

      if (candidate?.id) {
        payload.candidate_id = candidate.id;
      }

      const location = locationParts.join(", ");
      if (location) payload.location = location;

      if (candidate?.designation?.trim()) {
        payload.job_role = candidate.designation.trim();
      }

      const yearsExp = parseInt(candidate?.years_of_experience, 10);
      if (!Number.isNaN(yearsExp)) {
        payload.min_years_experience = yearsExp;
      }

      const skills = Array.isArray(candidate?.skills)
        ? candidate.skills
        : typeof candidate?.skills === "string"
          ? candidate.skills.split(",")
          : [];
      const nonEmptySkills = skills
        .filter((skill) => typeof skill === "string" && skill.trim())
        .map((skill) => skill.trim());
      if (nonEmptySkills.length > 0) {
        payload.skills = nonEmptySkills;
      }

      const response = await post(VYLABS_BASE_URL, JOBS_SIMPLE_SEARCH, payload);
      return response;
    } catch (error) {
      console.error("Error fetching recommended jobs:", error);
      return [];
    }
  }, []);

  const lastElement = useCallback(
    (node) => {
      if (observer.current) observer.current.disconnect();
      if (showFilterCepheaChat) return;

      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            if (
              (isAllCandidatesActive && suppressAutoLoadAll) ||
              (isTrackedByMeActive && suppressAutoLoadMy) ||
              (isCreatedByMeActive && suppressAutoLoadByMe)
            ) {
              return;
            }

            if (
              (isAllCandidatesActive && allCandidatesViewTab === 0) ||
              (isTrackedByMeActive && trackedViewTab === 0) ||
              (isCreatedByMeActive && trackedViewTab === 0)
            ) {
              if (
                isAllCandidatesActive &&
                hasMoreAll &&
                !isAllInitialLoading &&
                !isAllLoadingMore
              ) {
                setAllOffset((prev) => prev + 10);
              } else if (
                isTrackedByMeActive &&
                hasMoreMy &&
                !isMyInitialLoading &&
                !isMyLoadingMore
              ) {
                setMyOffset((prev) => prev + 10);
              } else if (
                isCreatedByMeActive &&
                hasMoreByMe &&
                !isByMeInitialLoading &&
                !isByMeLoadingMore
              ) {
                setByMeOffset((prev) => prev + 10);
              }
            }
          }
        },
        { root: null, rootMargin: "20px", threshold: 0.1 },
      );

      if (node) observer.current.observe(node);
    },
    [
      isAllCandidatesActive,
      hasMoreAll,
      isAllInitialLoading,
      isAllLoadingMore,
      isTrackedByMeActive,
      hasMoreMy,
      isMyInitialLoading,
      isMyLoadingMore,
      isCreatedByMeActive,
      isByMeInitialLoading,
      isByMeLoadingMore,
      hasMoreByMe,
      trackedViewTab,
      allCandidatesViewTab,
      suppressAutoLoadAll,
      suppressAutoLoadMy,
      suppressAutoLoadByMe,
      showFilterCepheaChat,
    ],
  );

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
      observer.current = null;
    }
  }, [isAllCandidatesActive, isTrackedByMeActive, isCreatedByMeActive]);
  useEffect(() => {
    const handleTrackUpdated = (e) => {
      if (!isTrackedByMeActive) return;
      const { candidateId, updatedAt } = e.detail || {};
      if (!candidateId) return;
      setMyCanList((prev) => {
        const updated = prev.map((c) => {
          if (c.id === candidateId) {
            const nowIso = updatedAt || new Date().toISOString();
            const newApplications = Array.isArray(c.applications)
              ? [
                  { ...(c.applications[0] || {}), updated_at: nowIso },
                  ...c.applications.slice(1),
                ]
              : [];
            return {
              ...c,
              updated_at: nowIso,
              UpdatedAt: nowIso,
              created_at: c.created_at || nowIso,
              applications: newApplications,
            };
          }
          return c;
        });
        return updated;
      });
    };
    window.addEventListener("candidate-track-updated", handleTrackUpdated);
    return () => {
      window.removeEventListener("candidate-track-updated", handleTrackUpdated);
    };
  }, [isTrackedByMeActive]);

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    if (suppressNextCandidateListFetchRef.current) {
      suppressNextCandidateListFetchRef.current = false;
      return;
    }

    if (isAllCandidatesActive) {
      setShowFilterCepheaChat(false);
      setMyOffset(0);
      setByMeOffset(0);
      setIsMyInitialLoading(false);
      setIsByMeInitialLoading(false);
      setMyCanList([]);
      setByMeCanList([]);

      setSuppressAutoLoadAll(true);
      setIsAllInitialLoading(true);
      setIsAllFetchCompleted(false);
      setAllCanList([]);
      setAllOffset(0);
      lastAllOffsetRef.current = 0;

      fetchCandidates(0, activeFilters).finally(() => {
        if (candidatesListRef.current) {
          candidatesListRef.current.scrollTop = 0;
        }
        setTimeout(() => setSuppressAutoLoadAll(false), 500);
      });
    } else if (isTrackedByMeActive) {
      setShowFilterCepheaChat(false);
      setAllOffset(0);
      setByMeOffset(0);
      setIsAllInitialLoading(false);
      setIsByMeInitialLoading(false);
      setAllCanList([]);
      setByMeCanList([]);
      setSuppressAutoLoadMy(true);
      setIsMyInitialLoading(true);
      setIsMyFetchCompleted(false);
      setMyCanList([]);
      setMyOffset(0);
      lastMyOffsetRef.current = 0;

      fetchTrackedCandidates(0, activeFilters).finally(() => {
        if (candidatesListRef.current) {
          candidatesListRef.current.scrollTop = 0;
        }
        setTimeout(() => setSuppressAutoLoadMy(false), 500);
      });
    } else if (isCreatedByMeActive) {
      setShowFilterCepheaChat(false);
      setAllOffset(0);
      setMyOffset(0);
      setIsAllInitialLoading(false);
      setIsMyInitialLoading(false);
      setAllCanList([]);
      setMyCanList([]);

      setSuppressAutoLoadByMe(true);
      setIsByMeInitialLoading(true);
      setIsByMeFetchCompleted(false);
      setByMeCanList([]);
      setByMeOffset(0);
      lastByMeOffsetRef.current = 0;

      fetchCandidatesCreatedByMe(0, activeFilters).finally(() => {
        if (candidatesListRef.current) {
          candidatesListRef.current.scrollTop = 0;
        }
        setTimeout(() => setSuppressAutoLoadByMe(false), 500);
      });
    }
  }, [
    isAllCandidatesActive,
    isTrackedByMeActive,
    isCreatedByMeActive,
    activeFilters,
  ]);

  useEffect(() => {
    if (!isAllCandidatesActive) return;

    if (allOffset === 0) {
      lastAllOffsetRef.current = 0;
      return;
    }

    if (allOffset > lastAllOffsetRef.current) {
      fetchCandidates(allOffset, activeFilters);
      lastAllOffsetRef.current = allOffset;
    }
  }, [allOffset, isAllCandidatesActive, activeFilters]);

  useEffect(() => {
    if (!isTrackedByMeActive) return;

    if (myOffset === 0) {
      lastMyOffsetRef.current = 0;
      return;
    }

    if (myOffset > lastMyOffsetRef.current) {
      fetchTrackedCandidates(myOffset, activeFilters);
      lastMyOffsetRef.current = myOffset;
    }
  }, [myOffset, isTrackedByMeActive, activeFilters]);

  useEffect(() => {
    if (!isCreatedByMeActive) return;

    if (byMeOffset === 0) {
      lastByMeOffsetRef.current = 0;
      return;
    }

    if (byMeOffset > lastByMeOffsetRef.current) {
      fetchCandidatesCreatedByMe(byMeOffset, activeFilters);
      lastByMeOffsetRef.current = byMeOffset;
    }
  }, [byMeOffset, isCreatedByMeActive, activeFilters]);

  const closeModal = async () => {
    if (selectedCandidate?.id && !selectedCandidate.isFileBased) {
      if (selectedCandidate?.id) {
        jobsCache.delete(selectedCandidate.id);
        channelIdCache.delete(selectedCandidate.id);
      }
    }
    setAssignedVendor(null);
    resetCandidateEdit();
    setIsModalOpen(false);
    setActiveTab(0);
    setSelectedCandidate(null);
  };

  useEffect(() => {
    if (!isModalOpen) {
      setActiveTab(null);
    }
  }, [isModalOpen]);

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setAiDrivenUploadedFiles([files[0]]);
    }
  };

  const handleFileDelete = (fileName) => {
    setAiDrivenUploadedFiles((prev) =>
      prev.filter((file) => file.name !== fileName),
    );
  };

  const handlePhoneInputChange = React.useCallback(
    (phone) => {
      const normalizedPhone =
        phone?.startsWith("+") || phone.length === 0 ? phone : `+${phone}`;
      formik.setFieldValue("canMobile", normalizedPhone);
      formik.setFieldTouched("canMobile", true, false);
      formik.validateField("canMobile");
    },
    [formik],
  );

  const handleOpenInviteModal = () => {
    setCandidateModal(true);
    formik.resetForm();
    setAutoCompleteKey((prev) => prev + 1);
  };

  const handleCloseInviteModal = () => {
    formik.resetForm();
    setAutoCompleteKey((prev) => prev + 1);
    setVendorList([]);
    setCandidateModal(false);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const setTagColor = (tag) => {
    return getStageColor(tag);
  };

  const handleCreateCandidate = async () => {
    await formik.validateForm();
    if (!formik.isValid || Object.keys(formik.touched).length === 0) {
      formik.setTouched(
        {
          canName: true,
          canEmail: true,
          canMobile: true,
          skills: true,
          designation: true,
        },
        false,
      );
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    try {
      const response = await post(VYLABS_BASE_URL, CCREATE_CAN, {
        name: formik.values.canName,
        email: formik.values.canEmail,
        secondaryEmail: formik.values.secondaryEmail,
        phone: formik.values.canMobile,
        secondaryPhone: formik.values.secondaryPhone,
        city: formik.values.city,
        state: formik.values.state,
        country: formik.values.country,
        status: "New Profile",
        contactPerson: formik.values.contactPerson,
        contactDesignation: formik.values.contactDesignation,
        skills: formik.values.skills,
        vendorID: formik.values.vendorID,
        designation: formik.values.designation,
        source: formik.values.source
          ? toCamelCase(formik.values.source)
          : "Manual Creation",
        industry: formik.values.industry,
        custom_fields: filterPayload(formik.values.custom_fields),
      });

      if (response.message === "candidate updated") {
        Toast(
          "info",
          `Candidate with email "${formik.values.canEmail}" or phone "${formik.values.canMobile}" already exists. Their information has been updated instead.`,
        );
      } else {
        Toast("success", "Candidate created successfully");
      }
      setCandidateModal(false);
      formik.resetForm();
      await fetchCandidates(0);
    } catch (error) {
      console.error("Create Candidate response error:", error);
      Toast(
        "error",
        error.response.data || "Candidate creation failed. Please try again.",
      );
    }
  };

  const handleOpenUploadResumeView = () => {
    setUploadResumeViewOpen(true);
    setHideCandidatesHeader(false);
    setMessages([]);
    setAiDrivenUploadedFiles([]);
    setHasSearched(false);
    setShowBackToList(false);
  };

  const handleCloseUploadResumeView = () => {
    // if (!isParsingComplete && UploadedResumes.length > 0) {
    //   Toast("warning", "Please wait until all files are processed.");
    //   return;
    // }
    setHideCandidatesHeader(true);
    setUploadResumeViewOpen(false);
    // resetUploadState();
    fetchCandidates(0);
  };

  const pageMenuOptions = [
    {
      name: "Manual Creation",
      path: "",
      onClick: () => {
        fetchCustomFields();
        handleOpenInviteModal();
      },
    },
    {
      name: "Upload Files",
      onClick: handleOpenUploadResumeView,
    },
  ];

  const handleResetAllFilters = useCallback(() => {
    setIsAllCandidatesActive(true);
    setIsTrackedByMeActive(false);
    setIsCreatedByMeActive(false);
    setTablePage(1);
    setSelectedCandidates([]);
    setIsSelectMode(false);
    setActiveFilters([]);
    setSelectedSavedViewId(null);
    setCandidateFilterDraft(null);
    setSavedViewDraft(null);
    setMessages([]);
    setChatChannelID(null);
    chatChannelIdRef.current = null;
    setHasSearched(false);
    setSearchResultCandidates([]);
    setSearchResultCandidateIds([]);
    simpleSearchRequestKeyRef.current = "";
    simpleSearchRequestSeqRef.current += 1;
    setHasExportData(false);
    setExportFilteredCandidatesUrl("");
    if (simpleSearchAbortRef.current) {
      try {
        simpleSearchAbortRef.current.abort();
      } catch (_) {}
      simpleSearchAbortRef.current = null;
    }
    setShowCepheaChat(false);
    setFilterChatInput("");
    setShowBackToList(false);
    setPendingScrollToChat(false);
    setShowFilterCepheaChat(false);
    formik.resetForm();
    setSkillsValue("");
    setMinYearsOfExperienceValue("");
    setMaxYearsOfExperienceValue("");
    setIndustryValue("");
    setLocationValue("");
    setSearchQuery("");
    setSearchParams({
      query: "",
      skills: "",
      minYearsOfExperience: "",
      maxYearsOfExperience: "",
      industry: "",
      location: "",
    });
    setSearchPagination((prev) => ({
      ...prev,
      currentFilters: [],
      currentFilterBy: undefined,
    }));
  }, [formik]);

  const handleCandidateFilterClose = useCallback(() => {
    setIsCandidateFilterOpen(false);
    setSelectedSavedViewId(null);
    setCandidateFilterDraft(null);
    setSavedViewDraft(null);
  }, []);

  const totalActiveFiltersCount = useMemo(() => {
    let count = 0;
    if (skillsValue && skillsValue.trim()) count++;
    if (
      (minYearsOfExperienceValue && String(minYearsOfExperienceValue).trim()) ||
      (maxYearsOfExperienceValue && String(maxYearsOfExperienceValue).trim())
    )
      count++;
    if (industryValue && industryValue.trim()) count++;
    if (locationValue && locationValue.trim()) count++;
    if (isTrackedByMeActive || isCreatedByMeActive) count++;
    const stageFilter = activeFilters.find((f) => f.type === "call_stage");
    const dateFilter = activeFilters.find((f) => f.type === "date");
    const fromDateFilter = activeFilters.find((f) => f.type === "from_date");
    const toDateFilter = activeFilters.find((f) => f.type === "to_date");
    if (stageFilter?.value) count++;
    if (dateFilter?.value) count++;
    if (fromDateFilter?.value || toDateFilter?.value) count++;
    if (
      activeFilters.some(
        (f) =>
          ["tracking_from_date", "tracking_end_date"].includes(f.type) &&
          f.value,
      )
    )
      count++;
    return count;
  }, [
    skillsValue,
    minYearsOfExperienceValue,
    maxYearsOfExperienceValue,
    industryValue,
    locationValue,
    isTrackedByMeActive,
    isCreatedByMeActive,
    activeFilters,
  ]);

  const fetchSavedViews = useCallback(async () => {
    try {
      setIsLoadingSavedViews(true);
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_SAVED_VIEWS}?scope=${CANDIDATE_SAVED_VIEW_SCOPE}`,
      );
      const views = Array.isArray(response?.views) ? response.views : [];
      setSavedViews(views);
      return views;
    } catch (error) {
      console.error("Candidate fetchSavedViews error:", error);
      setSavedViews([]);
      return [];
    } finally {
      setIsLoadingSavedViews(false);
    }
  }, []);

  const savedViewOptions = useMemo(
    () =>
      savedViews
        .filter((view) => view?.id && view?.name)
        .map((view) => ({ label: view.name, value: view.id })),
    [savedViews],
  );

  const activeSavedViewOption = useMemo(() => {
    const view = savedViews.find((item) => item.id === selectedSavedViewId);
    return view ? { label: view.name, value: view.id } : null;
  }, [savedViews, selectedSavedViewId]);

  const normalizeSavedViewSkills = (value) =>
    Array.isArray(value) ? value.join(", ") : normalizeSearchValue(value);

  const normalizeSavedViewDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const buildSavedViewDraftFromFilters = (filters = {}) => {
    const filterBy = filters.filter_by;

    return {
      skills: normalizeSavedViewSkills(filters.skills),
      minExp: normalizeSearchValue(filters.min_years_of_experience),
      maxExp: normalizeSearchValue(filters.max_years_of_experience),
      industry: normalizeSearchValue(filters.industry),
      location: normalizeSearchValue(filters.location),
      query: normalizeSearchValue(filters.query),
      stage: normalizeSearchValue(filters.stage),
      dateRange: SAVED_VIEW_DATE_LABELS[filters.time] || "",
      fromDate: normalizeSavedViewDateValue(
        filters.created_from_date || filters.fromDate,
      ),
      toDate: normalizeSavedViewDateValue(
        filters.created_end_date || filters.toDate,
      ),
      trackingFromDate: normalizeSavedViewDateValue(filters.tracking_from_date),
      trackingToDate: normalizeSavedViewDateValue(filters.tracking_end_date),
      ownershipType: filterBy || "",
      userId: AdminAccess ? filters.user_id || "" : "",
      userLabel:
        filters.userLabel ||
        (String(filters.user_id) === String(userDetails?.id) ? "Me" : ""),
    };
  };

  const buildActiveFiltersFromSavedViewDraft = (draft) => {
    const nextFilters = [];

    if (draft.stage) {
      nextFilters.push({ type: "call_stage", value: draft.stage });
    }
    if (draft.dateRange) {
      nextFilters.push({ type: "date", value: draft.dateRange });
    }
    if (!draft.dateRange && draft.fromDate) {
      nextFilters.push({ type: "from_date", value: draft.fromDate });
    }
    if (!draft.dateRange && draft.toDate) {
      nextFilters.push({
        type: "to_date",
        value: draft.toDate,
      });
    }
    if (!draft.dateRange && draft.trackingFromDate) {
      nextFilters.push({
        type: "tracking_from_date",
        value: draft.trackingFromDate,
      });
    }
    if (!draft.dateRange && draft.trackingToDate) {
      nextFilters.push({
        type: "tracking_end_date",
        value: draft.trackingToDate,
      });
    }
    if (draft.industry) {
      nextFilters.push({ type: "industry", value: draft.industry });
    }
    if (draft.location) {
      nextFilters.push({ type: "location", value: draft.location });
    }
    if (AdminAccess && draft.userId) {
      nextFilters.push({
        type: "user_id",
        value: draft.userId,
        label: draft.userLabel,
      });
    }

    return nextFilters;
  };

  const handleSavedViewChange = (option) => {
    if (!option) {
      handleResetAllFilters();
      return;
    }

    const view = savedViews.find((item) => item.id === option.value);
    if (!view) return;

    const filters = view.filters || {};
    const nextDraft = buildSavedViewDraftFromFilters(filters);
    const nextSkills = nextDraft.skills;
    const nextMinExp = nextDraft.minExp;
    const nextMaxExp = nextDraft.maxExp;
    const nextIndustry = nextDraft.industry;
    const nextLocation = nextDraft.location;
    const nextQuery = nextDraft.query;
    const nextFilterBy = nextDraft.ownershipType;
    const nextFilters = buildActiveFiltersFromSavedViewDraft(nextDraft);
    const isTracked = nextFilterBy === "tracked";
    const isCreated = nextFilterBy === "created";
    const hasCandidateCriteria = Boolean(
      Object.keys(buildCandidateSearchFilterPayload(nextFilters, nextFilterBy))
        .length > 0 ||
      nextQuery ||
      nextSkills ||
      nextMinExp ||
      nextMaxExp ||
      nextIndustry ||
      nextLocation,
    );

    setSelectedSavedViewId(view.id);
    if (isCandidateFilterOpen) {
      setSavedViewDraft(nextDraft);
      setCandidateFilterDraft(nextDraft);
      return;
    }

    setSkillsValue(nextSkills);
    setMinYearsOfExperienceValue(nextMinExp);
    setMaxYearsOfExperienceValue(nextMaxExp);
    setIndustryValue(nextIndustry);
    setLocationValue(nextLocation);
    formik.setFieldValue("askmeanything", nextQuery);
    setActiveFilters(nextFilters);
    setIsAllCandidatesActive(!isTracked && !isCreated);
    setIsTrackedByMeActive(isTracked);
    setIsCreatedByMeActive(isCreated);
    setTablePage(1);
    setSelectedCandidates([]);
    setIsSelectMode(false);
    setTrackedViewTab(0);

    if (hasCandidateCriteria) {
      suppressNextCandidateListFetchRef.current = true;
      handleSimpleSearch(1, {
        query: nextQuery,
        skills: nextSkills,
        minExp: nextMinExp,
        maxExp: nextMaxExp,
        industry: nextIndustry,
        loc: nextLocation,
        filters: nextFilters,
        filterBy: nextFilterBy || undefined,
      });
    } else {
      setHasSearched(false);
      setSearchResultCandidates([]);
      setSearchResultCandidateIds([]);
      simpleSearchRequestKeyRef.current = "";
      if (isTracked) {
        fetchTrackedCandidates(0, nextFilters);
      } else if (isCreated) {
        fetchCandidatesCreatedByMe(0, nextFilters);
      } else {
        fetchCandidates(0, nextFilters);
      }
      exportCandidateByFilter(nextFilters, isTracked, isCreated);
    }
  };

  useEffect(() => {
    if (isCandidateFilterOpen && savedViews.length === 0) {
      fetchSavedViews();
    }
  }, [fetchSavedViews, isCandidateFilterOpen, savedViews.length]);

  const candidateSavedViewFilters = useMemo(() => {
    const filters = {};
    const shouldUseDraft = isCandidateFilterOpen && candidateFilterDraft;
    const query = normalizeSearchValue(formik.values.askmeanything);
    const savedSkills = normalizeSearchSkills(
      shouldUseDraft ? candidateFilterDraft.skills : skillsValue,
    );
    const minExp = normalizeSearchNumber(
      shouldUseDraft ? candidateFilterDraft.minExp : minYearsOfExperienceValue,
    );
    const maxExp = normalizeSearchNumber(
      shouldUseDraft ? candidateFilterDraft.maxExp : maxYearsOfExperienceValue,
    );
    const industry = normalizeSearchValue(
      shouldUseDraft ? candidateFilterDraft.industry : industryValue,
    );
    const location = normalizeSearchValue(
      shouldUseDraft ? candidateFilterDraft.location : locationValue,
    );
    const stageFilter = shouldUseDraft
      ? { value: candidateFilterDraft.stage }
      : activeFilters.find((f) => f.type === "call_stage");
    const dateFilter = shouldUseDraft
      ? { value: candidateFilterDraft.dateRange }
      : activeFilters.find((f) => f.type === "date");
    const fromDateFilter = shouldUseDraft
      ? { value: candidateFilterDraft.fromDate }
      : activeFilters.find((f) => f.type === "from_date");
    const toDateFilter = shouldUseDraft
      ? { value: candidateFilterDraft.toDate }
      : activeFilters.find((f) => f.type === "to_date");
    const userFilter = shouldUseDraft
      ? {
          value: candidateFilterDraft.userId,
          label: candidateFilterDraft.userLabel,
        }
      : activeFilters.find((f) => f.type === "user_id");
    const ownershipType = shouldUseDraft
      ? candidateFilterDraft.ownershipType
      : isTrackedByMeActive
        ? "tracked"
        : isCreatedByMeActive
          ? "created"
          : "";

    if (query) filters.query = query;
    if (savedSkills.length > 0) filters.skills = savedSkills;
    if (minExp !== "") filters.min_years_of_experience = minExp;
    if (maxExp !== "") filters.max_years_of_experience = maxExp;
    if (industry) filters.industry = industry;
    if (location) filters.location = location;
    if (stageFilter?.value) filters.stage = stageFilter.value;

    const timeValue = SAVED_VIEW_TIME_VALUES[dateFilter?.value] || "";
    if (timeValue) filters.time = timeValue;

    const fromDate = formatCandidateFilterDate(fromDateFilter?.value);
    const toDate = formatCandidateFilterDate(toDateFilter?.value);
    if (!timeValue && fromDate) filters.created_from_date = fromDate;
    if (!timeValue && toDate) filters.created_end_date = toDate;
    const trackingFromDate = formatCandidateFilterDate(
      shouldUseDraft
        ? candidateFilterDraft.trackingFromDate
        : activeFilters.find((f) => f.type === "tracking_from_date")?.value,
    );
    const trackingToDate = formatCandidateFilterDate(
      shouldUseDraft
        ? candidateFilterDraft.trackingToDate
        : activeFilters.find((f) => f.type === "tracking_end_date")?.value,
    );
    if (!timeValue && trackingFromDate)
      filters.tracking_from_date = trackingFromDate;
    if (!timeValue && trackingToDate)
      filters.tracking_end_date = trackingToDate;

    if (ownershipType === "tracked") {
      filters.filter_by = "tracked";
    } else if (ownershipType === "created") {
      filters.filter_by = "created";
    }

    if (AdminAccess && userFilter?.value) {
      filters.user_id = userFilter.value;
      if (userFilter.label) filters.userLabel = userFilter.label;
    }

    return filters;
  }, [
    activeFilters,
    candidateFilterDraft,
    AdminAccess,
    formik.values.askmeanything,
    industryValue,
    isCandidateFilterOpen,
    isCreatedByMeActive,
    isTrackedByMeActive,
    locationValue,
    maxYearsOfExperienceValue,
    minYearsOfExperienceValue,
    skillsValue,
  ]);

  const isCreateSavedViewButtonActive = Object.keys(
    candidateSavedViewFilters,
  ).some((key) => key !== "user_id" && key !== "userLabel");

  const handleCreateSavedViewOpen = () => {
    if (!isCreateSavedViewButtonActive) {
      Toast("error", "Please select at least one filter");
      return;
    }
    setIsCreateSavedViewOpen(true);
  };

  const handleCreateSavedViewClose = () => {
    setIsCreateSavedViewOpen(false);
    setSavedViewName("");
  };

  const createCandidateSavedView = async () => {
    const trimmedName = savedViewName.trim();

    if (!trimmedName) {
      Toast("error", "Please enter saved view name");
      return;
    }

    if (!isCreateSavedViewButtonActive) {
      Toast("error", "Please select at least one filter");
      return;
    }

    const payload = {
      filters: candidateSavedViewFilters,
      isDefault: false,
      name: trimmedName,
      scope: CANDIDATE_SAVED_VIEW_SCOPE,
    };

    try {
      setIsCreatingSavedView(true);
      const response = await post(VYLABS_BASE_URL, CREATE_SAVED_VIEWS, payload);
      Toast("success", "Saved view created successfully");
      const views = await fetchSavedViews();
      const createdViewId = response?.view?.id || response?.id;
      const createdView =
        views.find((view) => String(view.id) === String(createdViewId)) ||
        views.find((view) => view.name === trimmedName);
      if (createdView?.id) {
        setSelectedSavedViewId(createdView.id);
      }
      handleCreateSavedViewClose();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Failed to create saved view";
      Toast("error", errorMessage);
    } finally {
      setIsCreatingSavedView(false);
    }
  };

  const updateCandidateSavedView = async () => {
    if (!selectedSavedViewId) {
      Toast("error", "Please select a saved filter to update");
      return;
    }

    if (!isCreateSavedViewButtonActive) {
      Toast("error", "Please select at least one filter");
      return;
    }

    const selectedView = savedViews.find(
      (view) => String(view.id) === String(selectedSavedViewId),
    );
    const payload = {
      filters: candidateSavedViewFilters,
      isDefault: Boolean(selectedView?.isDefault),
      name: selectedView?.name || activeSavedViewOption?.label || "",
    };

    try {
      setIsUpdatingSavedView(true);
      const response = await patch(
        VYLABS_BASE_URL,
        `${UPDATE_SAVED_VIEWS}/${encodeURIComponent(selectedSavedViewId)}`,
        payload,
      );
      Toast("success", "Saved filter updated successfully");
      const views = await fetchSavedViews();
      const updatedViewId =
        response?.view?.id || response?.id || selectedSavedViewId;
      const updatedView = views.find(
        (view) => String(view.id) === String(updatedViewId),
      );
      setSelectedSavedViewId(updatedView?.id || selectedSavedViewId);
      const updatedDraft = buildSavedViewDraftFromFilters(
        updatedView?.filters || candidateSavedViewFilters,
      );
      const updatedActiveFilters =
        buildActiveFiltersFromSavedViewDraft(updatedDraft);
      const updatedFilterBy = updatedDraft.ownershipType;

      setSavedViewDraft(updatedDraft);
      setCandidateFilterDraft(updatedDraft);
      setSkillsValue(updatedDraft.skills);
      setMinYearsOfExperienceValue(updatedDraft.minExp);
      setMaxYearsOfExperienceValue(updatedDraft.maxExp);
      setIndustryValue(updatedDraft.industry);
      setLocationValue(updatedDraft.location);
      formik.setFieldValue("askmeanything", updatedDraft.query || "");
      setActiveFilters(updatedActiveFilters);
      setIsAllCandidatesActive(
        updatedFilterBy !== "tracked" && updatedFilterBy !== "created",
      );
      setIsTrackedByMeActive(updatedFilterBy === "tracked");
      setIsCreatedByMeActive(updatedFilterBy === "created");
    } catch (error) {
      console.error("Error updating saved view", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data ||
        "Failed to update saved filter";
      Toast("error", errorMessage);
    } finally {
      setIsUpdatingSavedView(false);
    }
  };

  const handleSavedViewDeleteClose = useCallback(() => {
    if (isDeletingSavedView) return;
    setIsSavedViewDeleteDialogOpen(false);
    setSavedViewPendingDelete(null);
  }, [isDeletingSavedView]);

  const handleDeleteViews = useCallback(
    async (savedViewId = selectedSavedViewId) => {
      if (!savedViewId) {
        Toast("error", "Please select a saved filter to delete");
        return;
      }

      try {
        setIsDeletingSavedView(true);
        await deleteRequest(
          VYLABS_BASE_URL,
          `${DELETE_SAVED_VIEWS}/${encodeURIComponent(savedViewId)}`,
        );
        Toast("success", "Saved filter deleted successfully");
        if (String(savedViewId) === String(selectedSavedViewId)) {
          setSelectedSavedViewId(null);
          setCandidateFilterDraft(null);
          setSavedViewDraft(null);
        }
        await fetchSavedViews();
        setIsSavedViewDeleteDialogOpen(false);
        setSavedViewPendingDelete(null);
      } catch (error) {
        console.error("Error deleting saved view", error);
        const errorMessage =
          error?.response?.data?.message ||
          error?.response?.data ||
          "Failed to delete saved filter";
        Toast("error", errorMessage);
      } finally {
        setIsDeletingSavedView(false);
      }
    },
    [fetchSavedViews, selectedSavedViewId],
  );

  const canListOptions = [
    {
      name: "All Candidates",
      path: "",
      disabled:
        activeFilters.length === 0 &&
        (isMyInitialLoading ||
          isMyLoadingMore ||
          isByMeInitialLoading ||
          isByMeLoadingMore),
      onClick: () => {
        handleResetAllFilters();
      },
    },
  ];

  const handleCardSelect = (candidate, event) => {
    event && event.stopPropagation();
    if (selectedCandidates.some((c) => c.id === candidate.id)) {
      setSelectedCandidates(
        selectedCandidates.filter((c) => c.id !== candidate.id),
      );
    } else {
      setSelectedCandidates([...selectedCandidates, candidate]);
    }
  };

  const handleCardView = useCallback(
    async (candidate, e) => {
      e.stopPropagation();
      setSelectedCandidate({
        recommendedJobs: [],
        isRankingJobs: true,
      });
      setIsModalOpen(true);
      setIsCandidateDetailsLoading(true);
      setIsRecommendedJobsLoading(true);
      try {
        let enrichedCandidate;
        if (!candidate.isFileBased && candidate.id) {
          const candidateDetails = await fetchCandidateById(candidate.id);
          if (candidateDetails) {
            enrichedCandidate = {
              ...candidateDetails,
              isFileBased: false,
              parsedResumeData: candidateDetails.parsedResumeData || {},
            };
            setSelectedCandidate((prev) => ({
              ...prev,
              isRankingJobs: true,
            }));
          }
        }

        const response = await fetchRecommendedJobs(enrichedCandidate);
        const recommendedJobs = response?.jobs || [];

        setSelectedCandidate((prev) => ({
          ...prev,
          recommendedJobs,
          isRankingJobs: false,
        }));
      } catch (error) {
        setSelectedCandidate((prev) => ({
          recommendedJobs: prev?.recommendedJobs || [],
          isRankingJobs: false,
        }));
        console.error("error in handleCardView", error);
      } finally {
        setIsRecommendedJobsLoading(false);
      }
    },
    [fetchCandidateById, fetchRecommendedJobs, fetchJobDetailsById],
  );

  const createdByMeColumnsDefinition = useMemo(
    () => [
      {
        name: "Candidate Name",
        selector: (row) => row.name || "N/A",
        cell: (row) => <CandidateNameCell row={row} />,
      },
      {
        name: "Candidate Email",
        selector: (row) => row.email || "N/A",
      },
      {
        name: "Candidate Contact",
        selector: (row) => row.phone || "N/A",
      },
      {
        name: "Created At",
        selector: (row) => row.created_at,
        cell: (row) => <DateTimeCell value={row.created_at} />,
        sortable: true,
        width: "180px",
        minWidth: "150px",
      },
      {
        name: "Updated At",
        selector: (row) => row.updated_at,
        cell: (row) => <DateTimeCell value={row.updated_at} />,
        sortable: true,
        width: "180px",
        minWidth: "150px",
      },
      {
        name: "Action",
        cell: (row) => (
          <CandidateActionCell row={row} onView={handleCardView} />
        ),
        width: "90px",
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ],
    [handleCardView],
  );

  const allCandidatesColumnsDefinition = useMemo(
    () => [
      {
        name: "Candidate Name",
        selector: (row) => row.name || "N/A",
        cell: (row) => <CandidateNameCell row={row} />,
      },
      {
        name: "Candidate Email",
        selector: (row) => row.email || "N/A",
        width: "250px",
        minWidth: "130px",
        maxWidth: "270px",
      },
      {
        name: "Candidate Contact",
        selector: (row) => row.phone || "N/A",
        width: "130px",
        minWidth: "110px",
        maxWidth: "150px",
      },
      {
        name: "Created At",
        selector: (row) => row.created_at,
        cell: (row) => <DateTimeCell value={row.created_at} />,
        sortable: true,
        width: "180px",
        minWidth: "150px",
      },
      {
        name: "Updated At",
        selector: (row) => row.updated_at,
        cell: (row) => <DateTimeCell value={row.updated_at} />,
        sortable: true,
        width: "180px",
        minWidth: "150px",
      },
      {
        name: "Action",
        cell: (row) => (
          <CandidateActionCell row={row} onView={handleCardView} />
        ),
        width: "90px",
        center: true,
        ignoreRowClick: true,
        allowOverflow: true,
      },
    ],
    [handleCardView],
  );

  const getMatchFitLabel = useCallback((matchPercentage) => {
    if (
      matchPercentage === null ||
      matchPercentage === undefined ||
      matchPercentage === ""
    ) {
      return "N/A";
    }

    const numericMatchPercentage = Number(matchPercentage);
    if (!Number.isFinite(numericMatchPercentage)) {
      return "N/A";
    }

    if (numericMatchPercentage >= 90) return "Top Fit";
    if (numericMatchPercentage >= 75) return "Good Fit";
    if (numericMatchPercentage >= 50) return "Partial Fit";
    return "Unlikely Fit";
  }, []);

  const getMatchFitClassName = useCallback((fitLabel) => {
    return `candidate-fit-pill candidate-fit-pill-${fitLabel
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "")}`;
  }, []);

  const searchCandidatesColumnsDefinition = useMemo(() => {
    const actionColumn = allCandidatesColumnsDefinition.find(
      (column) => column.name === "Action",
    );
    const columnsWithoutAction = allCandidatesColumnsDefinition.filter(
      (column) => column.name !== "Action",
    );

    return [
      ...columnsWithoutAction,
      {
        name: "Match Fit",
        selector: (row) =>
          getMatchFitLabel(row.match_percentage ?? row.matchPercentage),
        width: "160px",
        minWidth: "140px",
        maxWidth: "180px",
        cell: (row) => {
          const fitLabel = getMatchFitLabel(
            row.match_percentage ?? row.matchPercentage,
          );
          return (
            <span className={getMatchFitClassName(fitLabel)}>{fitLabel}</span>
          );
        },
      },
      actionColumn,
    ].filter(Boolean);
  }, [allCandidatesColumnsDefinition, getMatchFitClassName, getMatchFitLabel]);

  const renderCepheaLoader = () => (
    <div
      className="cephea-loader-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "20px",
        width: "100%",
      }}
    >
      <VybogTALLoaderAnimation />
    </div>
  );

  const selectAllCandidates = () => {
    if (selectedCandidates.length === visibleList.length) {
      setSelectedCandidates([]);
      setIsSelectMode(false);
    } else {
      setSelectedCandidates([...visibleList]);
    }
  };

  const handleAssignJobModal = async () => {
    if (selectedCandidates.length === 0) {
      Toast("error", "Please select at least one candidate to assign job.");
      return;
    }
    // setAssignJobModalOpen(true);
    openJobSelectionPopup("assignJob", { candidates: selectedCandidates });
  };

  const handleClientEmailModal = async () => {
    if (isMonthlyEmailLimitReached) {
      Toast("error", "Monthly email limit reached. Please upgrade your plan.");
      return;
    }

    if (selectedCandidates.length === 0) {
      Toast("error", "Please select at least one candidate to email client.");
      return;
    }
    openJobSelectionPopup("clientEmail", { candidates: selectedCandidates });
  };

  const handleJobsBlastEmail = () => {
    if (isMonthlyEmailLimitReached) {
      Toast("error", "Monthly email limit reached. Please upgrade your plan.");
      return;
    }

    if (selectedCandidates.length > 0) {
      const candidatesWithoutEmail = selectedCandidates.filter(
        (c) => !c.email || (typeof c.email === "string" && !c.email.trim()),
      );
      if (candidatesWithoutEmail.length > 0) {
        const names = candidatesWithoutEmail
          .map((c) => c.name || "Unknown")
          .join(", ");
        Toast(
          "error",
          `${names} ${
            candidatesWithoutEmail.length === 1 ? "doesn't" : "don't"
          } have email.Please only select candidates with email.`,
        );
      } else {
        setIsEmailCampaignPopupOpen(true);
      }
    } else {
      Toast(
        "error",
        "Please select at least one candidate to start an email campaign.",
      );
    }
  };

  const jobActionsOptions = [
    {
      name:
        selectedCandidates.length > 0
          ? `Assign Job (${selectedCandidates.length})`
          : "Assign Job",
      onClick: handleAssignJobModal,
    },
    {
      name:
        selectedCandidates.length > 0
          ? `Jobs Blast (${selectedCandidates.length})`
          : "Jobs Blast",
      onClick: handleJobsBlastEmail,
    },
    ...(!MemberAccess
      ? [
          {
            name:
              selectedCandidates.length > 0
                ? isHiringTeamTenant
                  ? `Email Hiring Team (${selectedCandidates.length})`
                  : `Email Client (${selectedCandidates.length})`
                : isHiringTeamTenant
                  ? `Email Hiring Team`
                  : `Email Client`,
            onClick: handleClientEmailModal,
          },
        ]
      : []),
  ];
  const handleToggleSelectMode = () => {
    setIsSelectMode((prev) => !prev);
    if (isSelectMode) {
      setSelectedCandidates([]);
    }
  };

  const handleEditCandidate = () => {
    const getValidExperience = (value) => {
      const num = Number(value);

      if (isNaN(num)) return "";
      if (num < 0) return 0;
      return num;
    };

    let experienceValue = "";
    const directExp = getValidExperience(
      selectedCandidate?.years_of_experience,
    );

    const parsedExp = getValidExperience(
      selectedCandidate?.parsedResumeData?.BasicInfo?.YearsOfExperience,
    );

    if (directExp !== "") {
      experienceValue = directExp;
    } else if (parsedExp !== "") {
      experienceValue = parsedExp;
    }
    const candidateWithFormattedSkills = {
      ...selectedCandidate,
      name:
        selectedCandidate.name ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Name ||
        "",
      email:
        selectedCandidate.email ||
        selectedCandidate.parsedResumeData?.BasicInfo?.Email ||
        "",
      secondaryEmail:
        selectedCandidate.secondaryEmail ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryEmail ||
        "",
      phone:
        selectedCandidate.phone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.PhoneNumber ||
        "",
      lineAddress1:
        selectedCandidate.lineAddress1 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress1 ||
        "",
      lineAddress2:
        selectedCandidate.lineAddress2 ||
        selectedCandidate.parsedResumeData?.BasicInfo?.lineAddress2 ||
        "",
      preferredSalary:
        selectedCandidate.preferredSalary ||
        selectedCandidate.parsedResumeData?.BasicInfo?.preferredSalary ||
        "",
      zipCode:
        selectedCandidate.zipCode ||
        selectedCandidate.parsedResumeData?.BasicInfo?.zipCode ||
        "",
      secondaryPhone:
        selectedCandidate.secondaryPhone ||
        selectedCandidate.parsedResumeData?.BasicInfo?.secondaryPhone ||
        "",
      city:
        selectedCandidate.city ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCity ||
        "",
      state:
        selectedCandidate.state ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationState ||
        "",
      country:
        selectedCandidate.country ||
        selectedCandidate.parsedResumeData?.BasicInfo?.CurrentLocationCountry ||
        "",
      skills: Array.isArray(selectedCandidate.skills)
        ? selectedCandidate.skills
        : selectedCandidate.parsedResumeData?.Skills || [],
      vendorID:
        selectedCandidate.vendorID ||
        selectedCandidate.parsedResumeData?.BasicInfo?.vendorID ||
        "",
      designation:
        selectedCandidate.designation?.trim() ||
        selectedCandidate.parsedResumeData?.CareerHistory?.JobDetails?.[0]
          ?.JobTitle ||
        "",
      source: selectedCandidate.source,
      industry: selectedCandidate.industry,
      experience: experienceValue,
      custom_fields: selectedCandidate?.custom_fields || {},
    };

    setOriginalCandidateData({ ...selectedCandidate });
    setEditedCandidateData(candidateWithFormattedSkills);
    setIsEditingCandidate(true);
    setEmailError("");
    setEmailTouched(false);
  };

  const resetCandidateEdit = () => {
    if (originalCandidateData) {
      setSelectedCandidate(originalCandidateData);
    }
    setIsEditingCandidate(false);
    setOriginalCandidateData(null);
    setEditedCandidateData(null);
    setEmailError("");
    setEmailTouched(false);
  };

  const saveCandidateChanges = async () => {
    if (!editedCandidateData) {
      return;
    }
    const email =
      editedCandidateData.email !== undefined
        ? editedCandidateData.email
        : selectedCandidate.email || "";

    if (!email.trim()) {
      setEmailError("Email is required");
      setEmailTouched(true);
      Toast("error", "Email is required");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format");
      setEmailTouched(true);
      Toast("error", "Please fill all required fields correctly");
      return;
    }
    setEmailError("");
    setEmailTouched(false);
    try {
      const candidateData = { id: selectedCandidate.id };

      Object.keys(editedCandidateData).forEach((key) => {
        const newValue = editedCandidateData[key];
        const oldValue = selectedCandidate[key];

        const isChanged = Array.isArray(newValue)
          ? JSON.stringify(newValue) !== JSON.stringify(oldValue)
          : newValue !== oldValue;

        if (
          isChanged &&
          newValue !== undefined &&
          newValue !== null &&
          (newValue !== "" || key === "industry")
        ) {
          candidateData[key] = newValue;
        }
      });
      if (!candidateData.designation && selectedCandidate.designation) {
        candidateData.designation = selectedCandidate.designation;
      }
      Object.keys(candidateData).forEach((key) => {
        if (key === "preferredSalary") {
          candidateData[key] = Number(candidateData[key]);
        }
      });
      if (candidateData.experience !== undefined) {
        candidateData.yearsOfExperience = Number(candidateData.experience);
        delete candidateData.experience;
      }
      if (candidateData.source !== undefined) {
        candidateData.source = toCamelCase(candidateData.source);
      }
      if (editedCandidateData.custom_fields) {
        const oldCustomFields = selectedCandidate.custom_fields || {};
        const newCustomFields = editedCandidateData.custom_fields;
        const hasCustomFieldChanges = Object.keys(newCustomFields).some(
          (key) => newCustomFields[key] !== oldCustomFields[key],
        );

        if (hasCustomFieldChanges) {
          candidateData.custom_fields = filterPayload({
            ...oldCustomFields,
            ...newCustomFields,
          });
        }
      }

      const response = await post(
        VYLABS_BASE_URL,
        UPDATE_CANDIDATE_DETAILS,
        candidateData,
      );

      if (response) {
        await fetchCandidateById(selectedCandidate.id);
        setIsEditingCandidate(false);
        setOriginalCandidateData(null);
        setEditedCandidateData(null);
        Toast("success", "Candidate updated successfully");
        if (isAllCandidatesActive) fetchCandidates(0);
        else if (isTrackedByMeActive) fetchTrackedCandidates(0);
        else if (isCreatedByMeActive) fetchCandidatesCreatedByMe(0);
      }
    } catch (error) {
      console.error("Error updating candidate:", error);
      const backendMessage =
        error?.response?.data?.message ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error.message ||
        "Failed to update candidate";
      Toast("error", backendMessage);
    }
  };

  const handleCandidateChange = (data) => {
    setEditedCandidateData((prev) => {
      const updated = {
        ...prev,
        ...data,
      };
      return updated;
    });
  };

  const handleTablePageChange = (page) => {
    setTablePage(page);
    let list, hasMore, isLoadingMore, setOffset;

    if (isAllCandidatesActive) {
      list = allCanList;
      hasMore = hasMoreAll;
      isLoadingMore = isAllLoadingMore;
      setOffset = setAllOffset;
    } else {
      list = isTrackedByMeActive ? myCanList : byMeCanList;
      hasMore = isTrackedByMeActive ? hasMoreMy : hasMoreByMe;
      isLoadingMore = isTrackedByMeActive ? isMyLoadingMore : isByMeLoadingMore;
      setOffset = isTrackedByMeActive ? setMyOffset : setByMeOffset;
    }

    if (!hasMore || isLoadingMore) return;
    const itemsPerPage = 10;
    const totalPagesInState = Math.ceil(list.length / itemsPerPage);
    if (page >= totalPagesInState) {
      if (list.length > 0 && list.length % itemsPerPage === 0) {
        setOffset(list.length);
      }
    }
  };

  const fullVisibleList = isAllCandidatesActive
    ? allCanList
    : isTrackedByMeActive
      ? myCanList
      : byMeCanList;

  const visibleList = showFilterCepheaChat
    ? selectedCandidates
    : hasSearched
      ? searchResultCandidates
      : fullVisibleList;
  const hasCandidateProfiles = allCanList.length > 0;
  const shouldShowCandidatesSearchBox =
    !showFilterCepheaChat &&
    (hasCandidateProfiles ||
      hasSearched ||
      activeFilters.length > 0 ||
      isTrackedByMeActive ||
      isCreatedByMeActive);

  const isInitialLoading = isAllCandidatesActive
    ? isAllInitialLoading
    : isTrackedByMeActive
      ? isMyInitialLoading
      : isByMeInitialLoading;

  const isLoadingMore = isAllCandidatesActive
    ? isAllLoadingMore
    : isTrackedByMeActive
      ? isMyLoadingMore
      : isByMeLoadingMore;

  const isFetchCompleted = isAllCandidatesActive
    ? isAllFetchCompleted
    : isTrackedByMeActive
      ? isMyFetchCompleted
      : isByMeFetchCompleted;

  useEffect(() => {
    const inTableView =
      (isAllCandidatesActive && allCandidatesViewTab === 1) ||
      (!isAllCandidatesActive && trackedViewTab === 1);
    if (!inTableView) return;
    let list, hasMore, isLoading, setOffset;
    if (isAllCandidatesActive) {
      list = allCanList;
      hasMore = hasMoreAll;
      isLoading = isAllInitialLoading || isAllLoadingMore;
      setOffset = setAllOffset;
    } else if (isTrackedByMeActive) {
      list = myCanList;
      hasMore = hasMoreMy;
      isLoading = isMyInitialLoading || isMyLoadingMore;
      setOffset = setMyOffset;
    } else {
      list = byMeCanList;
      hasMore = hasMoreByMe;
      isLoading = isByMeInitialLoading || isByMeLoadingMore;
      setOffset = setByMeOffset;
    }
    if (list.length === 10 && hasMore && !isLoading) {
      setOffset(10);
    }
  }, [allCandidatesViewTab, trackedViewTab]);

  useEffect(() => {
    if (selectedCandidate) {
      fetchCustomFields();
    }
  }, [selectedCandidate]);

  useEffect(() => {
    if (fields.length > 0) {
      const booleanFields = {};

      fields.forEach((field) => {
        if (
          field.field_type === "boolean" &&
          formik.values.custom_fields[field.field_key] === undefined
        ) {
          booleanFields[field.field_key] = false;
        }
      });

      if (Object.keys(booleanFields).length > 0) {
        formik.setValues((prev) => ({
          ...prev,
          custom_fields: {
            ...prev.custom_fields,
            ...booleanFields,
          },
        }));
      }
    }
  }, [fields]);

  const renderBotResponse = (message) => {
    if (message.sender !== "bot") return null;

    const { summary } = parseMessageText(message.text);

    return (
      <div className="bot-message-container">
        <img src={BotReplyIcon} alt="BotReplyIcon" className="replay-icon" />
        <div
          className="bot-message-content"
          style={
            message.isLoading
              ? { border: "none" }
              : {
                  border: "1px solid var(--border__color)",
                  padding: "15px",
                  borderRadius: "8px",
                }
          }
        >
          {isBotProcessing && message.isLoading ? (
            <ThinkingBubble />
          ) : (
            <div className="message-and-cards-container">
              {summary && (
                <div className="summary-container">
                  {summary.split("\n").map((line, idx) => {
                    const trimmedLine = line.trim();
                    const bulletContent = getBulletContent(trimmedLine);
                    if (bulletContent !== null) {
                      return (
                        <div
                          key={idx}
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "5px",
                          }}
                        >
                          <img
                            src={BotResponseStarIcon}
                            alt="bullet"
                            style={{
                              width: "18px",
                              height: "18px",
                              marginRight: "8px",
                              marginTop: "10px",
                              flexShrink: 0,
                            }}
                          />
                          <span
                            style={{
                              fontSize: "18px",
                              textAlign: "left",
                              color: "var(--chat-text)",
                              whiteSpace: "pre-wrap",
                            }}
                          >
                            {renderInlineMarkdown(bulletContent)}
                          </span>
                        </div>
                      );
                    }
                    return (
                      <p
                        key={idx}
                        style={{
                          fontSize: "18px",
                          textAlign: "left",
                          color: "var(--chat-text)",
                          whiteSpace: "pre-wrap",
                          marginBottom: "5px",
                          marginTop: "0px",
                          minHeight: line.trim() ? "auto" : "1em",
                        }}
                      >
                        {renderBotContent(line)}
                      </p>
                    );
                  })}
                  {message.isStreaming && (
                    <>
                      <style>{`@keyframes vyblink{0%,100%{opacity:1}50%{opacity:0}}`}</style>
                      <span
                        style={{
                          display: "inline-block",
                          width: "7px",
                          height: "16px",
                          marginLeft: "2px",
                          background: "var(--chat-text)",
                          animation: "vyblink 1s steps(1) infinite",
                          verticalAlign: "text-bottom",
                        }}
                      />
                    </>
                  )}
                </div>
              )}
              <div className="recommended-candidates-grid">
                {message.isResumesLoading && (
                  <>
                    {Array.from({ length: 3 }).map((_, idx) => (
                      <DynamicSkeleton
                        key={`bot-resume-skel-${idx}`}
                        variant="rectangular"
                        dimensions={{
                          width: "100%",
                          height: "180px",
                          sx: {
                            borderRadius: "12px",
                            border: "1px solid #e0e0e0",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                      />
                    ))}
                  </>
                )}
                {!message.isResumesLoading &&
                  Array.isArray(message.resumes) &&
                  message.resumes.length > 0 &&
                  message.resumes.map((candidate, index) => (
                    <Card
                      callStageMap={callStageMap}
                      key={candidate.id || `resume-${index}`}
                      name={
                        candidate.name ||
                        candidate.parsed_resume?.BasicInfo?.Name ||
                        "N/A"
                      }
                      email={
                        candidate.email ||
                        candidate.parsed_resume?.BasicInfo?.Email ||
                        "N/A"
                      }
                      phone={
                        candidate.phone ||
                        candidate.parsed_resume?.BasicInfo?.PhoneNumber ||
                        "N/A"
                      }
                      location={
                        candidate.city ||
                        candidate.state ||
                        candidate.country ||
                        candidate.parsed_resume?.BasicInfo
                          ?.CurrentLocationCity ||
                        "N/A"
                      }
                      role={
                        candidate.designation &&
                        candidate.designation.trim() !== ""
                          ? candidate.designation
                          : candidate.parsedResumeData?.CareerHistory
                                ?.JobDetails?.[0]?.JobTitle
                            ? candidate.parsedResumeData.CareerHistory
                                .JobDetails[0].JobTitle
                            : "Not specified"
                      }
                      experience={getCandidateExperienceValue(candidate)}
                      skills={
                        candidate.parsed_resume?.Skills ||
                        candidate.skills ||
                        []
                      }
                      secondaryEmail={
                        candidate.parsed_resume?.secondaryEmail ||
                        candidate.secondaryEmail ||
                        "N/A"
                      }
                      secondaryPhone={
                        candidate.parsed_resume?.secondaryPhone ||
                        candidate.secondaryPhone ||
                        "N/A"
                      }
                      vendorID={
                        candidate.parsed_resume?.vendorID ||
                        candidate.vendorID ||
                        "N/A"
                      }
                      preferredSalary={
                        candidate.parsed_resume?.preferredSalary ||
                        candidate.preferredSalary ||
                        "N/A"
                      }
                      lineAddress1={
                        candidate.parsed_resume?.lineAddress1 ||
                        candidate.lineAddress1 ||
                        "N/A"
                      }
                      lineAddress2={
                        candidate.parsed_resume?.lineAddress2 ||
                        candidate.lineAddress2 ||
                        "N/A"
                      }
                      zipCode={
                        candidate.parsed_resume?.zipCode ||
                        candidate.zipCode ||
                        "N/A"
                      }
                      applications={candidate?.applications}
                      cardbackgroundColor="var(--card__background)"
                      cardBorder="1px solid var(--card__border)"
                      cardColor="black"
                      skillbackgroundColor="var(--skill-badge-bg)"
                      skillColor="var(--skill-badge-color)"
                      viewEvent={(e) => {
                        e.stopPropagation();
                        handleCardView(candidate, e);
                      }}
                    />
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderChatMessages = (children = null, style = {}) => {
    return (
      <div className="chat-messages-container" style={style}>
        {children}
        {messages.map((message, index) => (
          <div
            key={message?.id ?? index}
            className={`message-wrapper ${message.sender}`}
          >
            {message.sender === "user" ? (
              <div className="user-message-container">
                <div className="user-message-content">
                  <p className="user-message-query-text">{message.text}</p>
                  {message.files && message.files.length > 0 && (
                    <div className="uploaded-files">
                      {message.files.map((file, fileIndex) => (
                        <span key={fileIndex}>{file.name}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              renderBotResponse(message)
            )}
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>
    );
  };

  const showFitCalculationButton =
    hasSearched &&
    !isSimpleSearchLoading &&
    !showFilterCepheaChat &&
    !isSelectMode &&
    searchResultCandidates.length > 0;

  const fetchCustomFields = async () => {
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${TENANT_FIELD_DEFINITIONS_LIST}?entity_type=candidate`,
        {
          headers: {
            "X-API-Key": TENANT_CORE_API_KEY,
          },
        },
      );
      if (response?.definitions) {
        const definitions = response.definitions;
        setFields(definitions);
      }
    } catch (error) {
      console.error("error in fetchFields:", error);
    }
  };

  async function exportCandidateByFilter(filters, isTracked, isCreated) {
    try {
      const payload = buildCandidateExportPayload(
        filters,
        isTracked,
        isCreated,
      );
      const res = await post(VYLABS_BASE_URL, CANDIDATE_FILTER_EXPORT, payload);
      if (res?.url) {
        setExportFilteredCandidatesUrl(res.url);
        setHasExportData(true);
      } else {
        setExportFilteredCandidatesUrl("");
        setHasExportData(false);
      }
    } catch (error) {
      console.error("error in exportCandidateByFilter", error);
      setHasExportData(false);
      setExportFilteredCandidatesUrl("");
    }
  }

  const exportCandidateByFilterOnClick = async () => {
    const exportUrl = exportFilteredCandidatesUrl;
    try {
      const fileResponse = await fetch(exportUrl);
      if (!fileResponse.ok) {
        throw new Error(`HTTP error! status: ${fileResponse.status}`);
      }
      const blob = await fileResponse.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      let filename = "candidates_export.xlsx";
      const urlParts = exportUrl.split("/");
      const lastPart = urlParts[urlParts.length - 1];
      const filenameMatch = lastPart.match(/[^?]+\.xlsx/);
      if (filenameMatch) {
        filename = filenameMatch[0];
      }
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      Toast("success", "File downloaded successfully");
    } catch (error) {
      console.error("error in exportCandidateByFilterOnClick", error);
      Toast("error", "Error downloading file");
    }
  };

  return (
    <div ref={topRef}>
      {hideCandidatesHeader && (
        <div className="candidate-header-main-container">
          <div className="header-icon-title-container">
            <img
              alt=""
              src={isDarkMode ? CandidateDarkIcon : CandidateLightIcon}
              className="header-title-icon"
            ></img>
            <h2 className="header-container">Candidates</h2>
          </div>{" "}
          <div
            className="candidate-header-button-container"
            style={
              showBackToList && !showFilterCepheaChat
                ? { justifyContent: "space-between" }
                : { justifyContent: "flex-start" }
            }
          >
            {isUploadResumeViewOpen ? (
              <div className="back-to-list-button-from-resume">
                <Button
                  label="Back to Candidates List"
                  event={handleCloseUploadResumeView}
                  iconSrc={backArrowIcon}
                />
              </div>
            ) : null}
            {showBackToList && !showFilterCepheaChat && (
              <div className="back-to-list-button">
                <Button
                  label="Back to Candidates List"
                  event={handleBackToList}
                  iconSrc={backArrowIcon}
                />
              </div>
            )}
          </div>
          {!isUploadResumeViewOpen && (
            <div className="selection-actions">
              {showFitCalculationButton && (
                <Button
                  label="How is fit calculated?"
                  event={() => setShowMatchPercentagePopup(true)}
                  iconSrc={networkIcon}
                  iconWidth="18px"
                />
              )}
              <div className="select-button-container">
                {!isUploadResumeViewOpen && !showFilterCepheaChat && (
                  <PageSelector
                    dropdownHeading="Create"
                    options={pageMenuOptions}
                    iconSrc={addIcon}
                    iconWidth="10px"
                    className="match-select-button"
                  />
                )}
                {!(
                  (isTrackedByMeActive || isCreatedByMeActive) &&
                  trackedViewTab === 1
                ) &&
                  !(isAllCandidatesActive && allCandidatesViewTab === 1) &&
                  !showFilterCepheaChat &&
                  !isSelectMode && (
                    <Button
                      label="Select"
                      event={handleToggleSelectMode}
                      style={{ padding: "5px 10px" }}
                      backgroundColor="#6665ea"
                      color="#fff"
                      border="1px solid #6665ea"
                    />
                  )}
                {isSelectMode &&
                  !(
                    (isTrackedByMeActive || isCreatedByMeActive) &&
                    trackedViewTab === 1
                  ) &&
                  !(isAllCandidatesActive && allCandidatesViewTab === 1) &&
                  !showFilterCepheaChat && (
                    <>
                      {(hasSearched || activeFilters.length > 0) && (
                        <CustomTooltip
                          title={"Export selected results as a (.xlsx)."}
                        >
                          <Button
                            label={
                              selectedCandidates.length > 0
                                ? `Export Candidate (${selectedCandidates.length})`
                                : "Export Candidates"
                            }
                            event={() => {
                              if (selectedCandidates.length === 0) {
                                Toast(
                                  "error",
                                  "Please select at least one candidate to export.",
                                );
                                return;
                              }
                              handleOpenExportFieldsPopup();
                            }}
                            style={{
                              padding: "3px 10px",
                              whiteSpace: "nowrap",
                            }}
                            backgroundColor="#6860ee"
                            color="#fff"
                            border="1px solid #6860ee"
                            iconSrc={DownloadIcon}
                          />
                        </CustomTooltip>
                      )}
                      <JobActionsSelectorWrapper>
                        <PageSelector
                          dropdownHeading="Job Actions"
                          options={jobActionsOptions}
                          className="match-select-button"
                        />
                      </JobActionsSelectorWrapper>

                      <CustomTooltip
                        title="You can only select up to 10 candidates to chat"
                        arrow
                      >
                        <Button
                          label={
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {selectedCandidates.length > 0
                                ? `VybogTAL Chat (${selectedCandidates.length})`
                                : "VybogTAL Chat"}
                              <Badge
                                badgeContent="BETA"
                                sx={{
                                  "& .MuiBadge-badge": {
                                    fontSize: "10px",
                                    height: "20px",
                                    minWidth: "auto",
                                    // padding: "0 8px",
                                    backgroundColor: "#fff4e5",
                                    color: "#ffa408",
                                    border: "1px solid #ffa408",
                                    position: "static",
                                    transform: "none",
                                    borderRadius: "12px",
                                    fontWeight: 500,
                                  },
                                }}
                              />
                            </span>
                          }
                          className="cephea-filter-chat-pill"
                          style={{ marginRight: "9px", padding: "5px 11px" }}
                          iconSrc={VybogTALChatIcon}
                          iconWidth="20px"
                          event={() => {
                            if (selectedCandidates.length === 0) {
                              Toast(
                                "error",
                                "Please select at least one candidate to chat with VybogTAL.",
                              );
                              return;
                            }
                            if (selectedCandidates.length > 10) {
                              Toast(
                                "error",
                                "You can only select up to 10 candidates.",
                              );
                              return;
                            }
                            if (!showFilterCepheaChat) {
                              setMessages([]);
                              setChatChannelID(null);
                              chatChannelIdRef.current = null;
                              setHasSentCandidateIds(false);
                              setCurrentChannelForContext(null);
                              setShowFilterCepheaChat(true);
                            }
                            setTimeout(() => {
                              filterChatRef.current?.scrollIntoView({
                                behavior: "smooth",
                              });
                            }, 100);
                          }}
                        />
                      </CustomTooltip>
                      <Button
                        label={
                          selectedCandidates.length === visibleList.length
                            ? "Deselect All"
                            : "Select All"
                        }
                        event={selectAllCandidates}
                        style={{
                          padding: "5px 10px",
                          whiteSpace: "nowrap",
                        }}
                        backgroundColor="#6665ea"
                        color="#fff"
                        border="1px solid #6665ea"
                      />
                      <CustomTooltip
                        title={toCapitalize("Cancel the selected candidates")}
                        arrow
                      >
                        <Button
                          label="Cancel"
                          event={handleToggleSelectMode}
                          style={{ padding: "5px 10px" }}
                          backgroundColor="var(--body__background)"
                          color="var(--header__color)"
                          border="1px solid var(--border__color)"
                        />
                      </CustomTooltip>
                    </>
                  )}
              </div>
            </div>
          )}
        </div>
      )}

      <div className="outer-main-container">
        <div className="outer-container">
          {isUploadResumeViewOpen ? (
            <div className="resume-upload-container">
              <ResumeUpload
                showHeader={true}
                isComingFromCandidates={true}
                handleCloseUploadResumeView={handleCloseUploadResumeView}
              />
            </div>
          ) : (
            <>
              {!showCepheaChat && (
                <div
                  className={`page-selector-container-wrapper ${
                    isAllCandidatesActive && allCandidatesViewTab === 1
                      ? "table-search-sticky"
                      : ""
                  }`}
                >
                  {shouldShowCandidatesSearchBox && (
                    <div className="can-page-selector-container">
                      <SimpleCepheaChat
                        isDarkMode={isDarkMode}
                        recommendedSearchBoxTitle="Candidates Search"
                        askMeAnythingPlaceholder="Search candidates"
                        placeholderOptions={PLACEHOLDER_OPTIONS}
                        buttonLabel="Search"
                        TextAreaStyle={{ height: "55px" }}
                        inputsectionstylewrap={{ paddingBottom: "2px" }}
                        inputsectionstyle={{ paddingTop: "1px" }}
                        jobDescriptionValue={formik.values.jobDescription}
                        askMeAnythingValue={formik.values.askmeanything}
                        skillsValue={skillsValue}
                        minYearsOfExperienceValue={minYearsOfExperienceValue}
                        maxYearsOfExperienceValue={maxYearsOfExperienceValue}
                        industryValue={industryValue}
                        totalActiveFiltersCount={totalActiveFiltersCount}
                        onSkillsChange={(e) => setSkillsValue(e.target.value)}
                        onMinYearsOfExperienceChange={(e) =>
                          setMinYearsOfExperienceValue(e.target.value)
                        }
                        onMaxYearsOfExperienceChange={(e) =>
                          setMaxYearsOfExperienceValue(e.target.value)
                        }
                        onIndustryChange={(e) =>
                          setIndustryValue(e.target.value)
                        }
                        locationValue={locationValue}
                        onLocationChange={(e) =>
                          setLocationValue(e.target.value)
                        }
                        jobDescriptionOnChange={formik.handleChange}
                        showExperienceAndLocation={true}
                        onAskChange={(e) => {
                          formik.setFieldValue("askmeanything", e.target.value);
                        }}
                        onSubmit={handleSimpleSearch}
                        uploadedFiles={[]}
                        showAttachResume={false}
                        isCollapsed={isSearchBoxCollapsed}
                        onCollapseChange={handleSearchBoxCollapse}
                        onClearForm={handleClearSearchForm}
                        showCepheaActions={hasSearched && !showCepheaChat}
                        showChatWithCephea={
                          hasSearched &&
                          !showCepheaChat &&
                          searchResultCandidates.length > 0
                        }
                        isSimpleSearchLoading={isSimpleSearchLoading}
                        onClearSimpleSearch={handleClearSimpleSearch}
                        onChatWithCephea={() => {
                          setShowCepheaChat(true);
                          setPendingScrollToChat(true);
                          setShowBackToList(true);
                        }}
                        headerRightContent={null}
                        showJobDescriptionField={false}
                        askmeanythingOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSimpleSearch();
                          }
                        }}
                        minYearsOfExperienceOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSimpleSearch();
                          }
                        }}
                        skillsOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSimpleSearch();
                          }
                        }}
                        maxYearsOfExperienceOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSimpleSearch();
                          }
                        }}
                        locationOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleSimpleSearch();
                          }
                        }}
                        onAdvancedFilterClick={() =>
                          setIsCandidateFilterOpen(true)
                        }
                        isAdvancedFilterOpen={isCandidateFilterOpen}
                      />
                    </div>
                  )}
                  {typeof document !== "undefined" &&
                    createPortal(
                      <SidePopupCan
                        isOpen={isCandidateFilterOpen}
                        onClose={handleCandidateFilterClose}
                        showHeaderBorder={false}
                        headerBackgroundColor="var(--sidepopup-background)"
                        headerContent={
                          <div className="advanced-search-popup-header">
                            <h2>Filters</h2>
                            <p>
                              Refine your search to find the right candidates
                            </p>
                          </div>
                        }
                        sidePopupWidth="560px"
                        contentPadding="0"
                        closeOnOverlayClick
                        className="advanced-filter-sidepopup"
                      >
                        <CandidateFilterDrawer
                          savedFilterControl={
                            <DynamicAutocomplete
                              options={savedViewOptions}
                              value={activeSavedViewOption}
                              onChange={handleSavedViewChange}
                              id="candidate-saved-filter"
                              placeholder="Choose a saved filter"
                              popupIcon={<KeyboardArrowDownIcon />}
                              customHeight="40px"
                              noOptionsText="No saved views found..."
                              loading={isLoadingSavedViews}
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;

                                return (
                                  <li {...optionProps} key={key}>
                                    <span className="candidate-saved-view-option-label">
                                      {option.label}
                                    </span>
                                    <Button
                                      type="button"
                                      className="candidate-saved-view-delete-button"
                                      ariaLabel={`Delete ${option.label}`}
                                      iconSrc={deleteIcon}
                                      iconWidth="15px"
                                      backgroundColor="transparent"
                                      border="none"
                                      hoverd={false}
                                      style={{
                                        width: "26px",
                                        height: "26px",
                                        minWidth: "26px",
                                        marginLeft: "10px",
                                        padding: 0,
                                        borderRadius: "50%",
                                      }}
                                      onMouseDown={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                      }}
                                      event={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        setSavedViewPendingDelete(option);
                                        setIsSavedViewDeleteDialogOpen(true);
                                      }}
                                    />
                                  </li>
                                );
                              }}
                              sx={SAVED_VIEW_AUTOCOMPLETE_SX}
                              componentsProps={
                                SAVED_VIEW_AUTOCOMPLETE_COMPONENT_PROPS
                              }
                            />
                          }
                          isOpen={isCandidateFilterOpen}
                          activeFilters={activeFilters}
                          stages={allStages}
                          onApplyFull={(filtersWithValues, meta = {}) => {
                            if (meta.hasCandidateCriteria) {
                              suppressNextCandidateListFetchRef.current = true;
                            }
                            setActiveFilters(filtersWithValues);
                            setIsCandidateFilterOpen(false);
                          }}
                          onReset={() => {
                            handleResetAllFilters();
                            handleCandidateFilterClose();
                          }}
                          onClose={() => setIsCandidateFilterOpen(false)}
                          onDraftChange={setCandidateFilterDraft}
                          savedViewDraft={savedViewDraft}
                          onCreateSavedView={handleCreateSavedViewOpen}
                          isCreateSavedViewActive={
                            isCreateSavedViewButtonActive
                          }
                          onUpdateSavedView={updateCandidateSavedView}
                          isUpdateSavedViewActive={
                            Boolean(selectedSavedViewId) &&
                            isCreateSavedViewButtonActive
                          }
                          isUpdatingSavedView={isUpdatingSavedView}
                          isSavedViewSelected={Boolean(selectedSavedViewId)}
                          setIsAllCandidatesActive={setIsAllCandidatesActive}
                          isTrackedByMeActive={isTrackedByMeActive}
                          setIsTrackedByMeActive={setIsTrackedByMeActive}
                          isCreatedByMeActive={isCreatedByMeActive}
                          setIsCreatedByMeActive={setIsCreatedByMeActive}
                          setTablePage={setTablePage}
                          setSelectedCandidates={setSelectedCandidates}
                          setIsSelectMode={setIsSelectMode}
                          setTrackedViewTab={setTrackedViewTab}
                          isDarkMode={isDarkMode}
                          skillsValue={skillsValue}
                          onSkillsChange={(e) => setSkillsValue(e.target.value)}
                          minYearsOfExperienceValue={minYearsOfExperienceValue}
                          onMinYearsOfExperienceChange={(e) =>
                            setMinYearsOfExperienceValue(e.target.value)
                          }
                          maxYearsOfExperienceValue={maxYearsOfExperienceValue}
                          onMaxYearsOfExperienceChange={(e) =>
                            setMaxYearsOfExperienceValue(e.target.value)
                          }
                          industryValue={industryValue}
                          onIndustryChange={(e) =>
                            setIndustryValue(e.target.value)
                          }
                          industryOptions={INDUSTRY_OPTIONS}
                          locationValue={locationValue}
                          onLocationChange={(e) =>
                            setLocationValue(e.target.value)
                          }
                          onSubmit={handleSimpleSearch}
                        />
                      </SidePopupCan>,
                      document.body,
                    )}
                  <StandardPopup
                    isOpen={isCreateSavedViewOpen}
                    onClose={handleCreateSavedViewClose}
                    onSubmit={createCandidateSavedView}
                    submitLabel="Save"
                    isSubmitting={isCreatingSavedView}
                    title="Save Candidate Filter"
                    width="520px"
                    maxHeight="95vh"
                    popupStyle={{
                      overflow: "hidden",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <DynamicTextField
                      label="Filter Name"
                      name="savedViewName"
                      value={savedViewName}
                      onChange={(event) => setSavedViewName(event.target.value)}
                      placeholder="Save name"
                      required
                      style={{ width: "100%" }}
                    />
                  </StandardPopup>
                  <ConfirmationPopup
                    isOpen={isSavedViewDeleteDialogOpen}
                    onClose={handleSavedViewDeleteClose}
                    onConfirm={() =>
                      handleDeleteViews(savedViewPendingDelete?.value)
                    }
                    title="Delete Saved Filter?"
                    subTitle="Confirmation required"
                    message={
                      <span>
                        This will delete{" "}
                        <span
                          style={{
                            color: "#6665ea",
                            fontWeight: "bold",
                          }}
                        >
                          "{applyEllipsis(savedViewPendingDelete?.label, 35)}"
                        </span>
                        . Are you sure you want to delete this saved filter?
                      </span>
                    }
                    cancelLabel="No, Cancel"
                    confirmLabel="Yes, Delete"
                    confirmButtonClass="popup-button-danger"
                    isSubmitting={isDeletingSavedView}
                  />
                  {!(
                    isAllCandidatesActive &&
                    !isInitialLoading &&
                    !isLoadingMore &&
                    isFetchCompleted &&
                    visibleList.length === 0 &&
                    activeFilters.length === 0
                  ) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "10px",
                        padding: "4px",
                      }}
                    >
                      {!isUploadResumeViewOpen && (
                        <div
                          className="page-selector-dropdown"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div className="can-list-buttons">
                            {isAllCandidatesActive &&
                            (activeFilters.length > 0 ||
                              showFilterCepheaChat ||
                              hasSearched) ? (
                              <>
                                <Button
                                  label="Back to Candidates List"
                                  iconSrc={rightArrowIcon}
                                  iconPosition="left"
                                  iconStyle={{ marginRight: "8px" }}
                                  event={canListOptions[0].onClick}
                                  disabled={canListOptions[0].disabled}
                                  className={`can-btn ${"active"}`}
                                />
                              </>
                            ) : isAllCandidatesActive &&
                              activeFilters.length === 0 ? (
                              <h3
                                style={{
                                  margin: 0,
                                  fontSize: "18px",
                                  fontWeight: "700",
                                  color: "var(--page_Header_Color)",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                All Candidates
                              </h3>
                            ) : !isAllCandidatesActive ? (
                              <Button
                                label="Back to Candidates List"
                                iconSrc={rightArrowIcon}
                                iconPosition="left"
                                iconStyle={{ marginRight: "8px" }}
                                event={() => {
                                  setExportFilteredCandidatesUrl("");
                                  canListOptions[0].onClick();
                                }}
                                disabled={canListOptions[0].disabled}
                                className={`can-btn ${"active"}`}
                              />
                            ) : null}
                            {/* {(activeFilters.length > 0 ||
                              isTrackedByMeActive ||
                              isCreatedByMeActive) && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                  marginLeft: "2px",
                                }}
                              >
                                <h4
                                  style={{
                                    margin: 0,
                                    fontWeight: "500",
                                    color: "var(--grid-na-text)",
                                    borderLeft: "1px solid var(--grid-na-text)",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Applied Filters
                                </h4>
                                {isTrackedByMeActive && (
                                  <FilterPill value="Tracked By" />
                                )}
                                {isCreatedByMeActive && (
                                  <FilterPill value="Created By" />
                                )}
                                {activeFilters
                                  .filter((f) => f.type === "user_id")
                                  .map((filter) => (
                                    <FilterPill
                                      key={filter.value}
                                      value={filter.label || filter.value}
                                    />
                                  ))}
                                {activeFilters
                                  .filter((f) => f.type === "date")
                                  .map((filter) => (
                                    <FilterPill
                                      key={`${filter.type}-${filter.value}`}
                                      value={filter.value}
                                    />
                                  ))}
                                {activeFilters
                                  .filter((f) => f.type === "industry")
                                  .map((filter) => (
                                    <FilterPill
                                      key={`${filter.type}-${filter.value}`}
                                      value={filter.value}
                                    />
                                  ))}
                                {activeFilters
                                  .filter((f) => f.type === "call_stage")
                                  .map((filter) => {
                                    const stageName =
                                      callStageMap[filter.value] ||
                                      filter.label ||
                                      filter.value;

                                    return (
                                      <FilterPill
                                        key={`${filter.type}-${filter.value}`}
                                        value={stageName}
                                      />
                                    );
                                  })}
                              </div>
                            )} */}
                          </div>
                        </div>
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        {(isTrackedByMeActive ||
                          isCreatedByMeActive ||
                          isAllCandidatesActive) &&
                          !hasSearched &&
                          !showFilterCepheaChat &&
                          activeFilters.length === 0 &&
                          !(isTrackedByMeActive || isCreatedByMeActive) && (
                            <div
                              className="filter-stages"
                              style={{ display: "flex" }}
                            >
                              <Button
                                label="Grid"
                                iconSrc={
                                  isDarkMode
                                    ? (isAllCandidatesActive
                                        ? allCandidatesViewTab
                                        : trackedViewTab) === 0
                                      ? gridActiveDarkIcon
                                      : gridNotActiveDarkIcon
                                    : (isAllCandidatesActive
                                          ? allCandidatesViewTab
                                          : trackedViewTab) === 0
                                      ? gridSelectIcon
                                      : gridNoSelectIcon
                                }
                                iconPosition="left"
                                iconStyle={{ marginRight: "8px" }}
                                event={() => {
                                  if (isAllCandidatesActive) {
                                    setAllCandidatesViewTab(0);
                                  } else {
                                    setTrackedViewTab(0);
                                  }
                                }}
                                disabled={
                                  isInitialLoading ||
                                  (isLoadingMore && activeFilters.length === 0)
                                }
                                className={`grid-btn ${
                                  (isAllCandidatesActive
                                    ? allCandidatesViewTab
                                    : trackedViewTab) === 0
                                    ? "active"
                                    : ""
                                }`}
                              />
                              <Button
                                label="Table"
                                iconSrc={
                                  isDarkMode
                                    ? (isAllCandidatesActive
                                        ? allCandidatesViewTab
                                        : trackedViewTab) === 1
                                      ? tableActiveDarkIcon
                                      : tableNotActiveDarkIcon
                                    : (isAllCandidatesActive
                                          ? allCandidatesViewTab
                                          : trackedViewTab) === 1
                                      ? tableSelectIcon
                                      : tableNoSelectIcon
                                }
                                iconPosition="left"
                                iconStyle={{ marginRight: "8px" }}
                                event={() => {
                                  if (isAllCandidatesActive) {
                                    setAllCandidatesViewTab(1);
                                  } else {
                                    setTrackedViewTab(1);
                                  }
                                }}
                                disabled={
                                  isInitialLoading ||
                                  (isLoadingMore && activeFilters.length === 0)
                                }
                                className={`grid-btn ${
                                  (isAllCandidatesActive
                                    ? allCandidatesViewTab
                                    : trackedViewTab) === 1
                                    ? "active"
                                    : ""
                                }`}
                              />
                            </div>
                          )}
                        {(isTrackedByMeActive ||
                          isCreatedByMeActive ||
                          isAllCandidatesActive) &&
                          !hasSearched &&
                          !showFilterCepheaChat && (
                            <div
                              className="filter-stages-and-popup"
                              style={{ display: "flex" }}
                            >
                              {activeFilters.length > 0 &&
                                !hasSearched &&
                                !showFilterCepheaChat &&
                                !isSelectMode && (
                                  <Button
                                    label="Export Candidates"
                                    event={handleSimpleSearchCanExport}
                                    style={{
                                      padding: "5px 15px",
                                      whiteSpace: "nowrap",
                                      marginRight: "10px",
                                      marginLeft: "10px",
                                    }}
                                    backgroundColor="#6860ee"
                                    color="#fff"
                                    border="1px solid #6860ee"
                                    iconSrc={DownloadIcon}
                                  />
                                )}
                            </div>
                          )}
                        {hasSearched &&
                          !isSimpleSearchLoading &&
                          !showFilterCepheaChat && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <h3
                                style={{
                                  margin: 0,
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {`Showing ${searchTableShowingCount} of ${searchPagination.totalCandidates} results`}
                              </h3>
                              {/* <SearchFilterPills
                                query={searchParams.query}
                                skills={searchParams.skills}
                                minYearsOfExperience={
                                  searchParams.minYearsOfExperience
                                }
                                maxYearsOfExperience={
                                  searchParams.maxYearsOfExperience
                                }
                                industry={searchParams.industry}
                                location={searchParams.location}
                              /> */}
                              {showExportButton && (
                                <>
                                  {AdminAccess && !isSelectMode && (
                                    <CustomTooltip
                                      title={"export all results as a (.xlsx)."}
                                    >
                                      <Button
                                        label="Export Candidates"
                                        event={handleOpenExportFieldsPopup}
                                        style={{
                                          padding: "5px 15px",
                                          whiteSpace: "nowrap",
                                          marginLeft: "10px",
                                        }}
                                        backgroundColor="#6860ee"
                                        color="#fff"
                                        border="1px solid #6860ee"
                                        iconSrc={DownloadIcon}
                                      />
                                    </CustomTooltip>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </div>
              )}
              {hasSearched &&
              !isSimpleSearchLoading &&
              !showFilterCepheaChat ? (
                <>
                  {!isSimpleSearchLoading &&
                    searchResultCandidates.length > 0 && (
                      <>
                        {allCandidatesViewTab === 1 ? (
                          <div className="candidate-search-table-results">
                            <Table
                              key="search-results-table"
                              className="can-global-data-table"
                              columns={searchCandidatesColumnsDefinition}
                              data={searchResultCandidates}
                              highlightOnHover
                              pagination
                              paginationServer
                              paginationTotalRows={
                                searchPagination.totalCandidates
                              }
                              currentPage={searchPagination.currentPage}
                              paginationPerPage={SEARCH_TABLE_PAGE_SIZE}
                              paginationRowsPerPageOptions={[10]}
                              hideRowsPerPage
                              onChangePage={(page) => {
                                if (
                                  page === searchPagination.currentPage ||
                                  searchPagination.isLoadingMore ||
                                  isSimpleSearchLoading
                                ) {
                                  return;
                                }
                                handleSimpleSearch(page, {
                                  replaceResults: true,
                                });
                              }}
                              fixedHeader
                              fixedHeaderScrollHeight={
                                isSearchBoxCollapsed
                                  ? "calc(100vh - 250px)"
                                  : "calc(100vh - 360px)"
                              }
                              progressPending={searchPagination.isLoadingMore}
                            />
                          </div>
                        ) : (
                          <div className="overall-card-container">
                            {searchResultCandidates.map((candidate, index) => {
                              const isLast =
                                index === searchResultCandidates.length - 1;
                              const isSelected =
                                !showFilterCepheaChat &&
                                isSelectMode &&
                                selectedCandidates.some(
                                  (c) => c.id === candidate.id,
                                );
                              return (
                                <div
                                  className={`candidate-card-outer-container ${isSelected ? "selected" : ""}`}
                                  key={`search-result-${candidate?.id ?? "noid"}-${index}`}
                                  ref={isLast ? lastSearchElement : null}
                                  onClick={(e) => {
                                    if (!showFilterCepheaChat && isSelectMode) {
                                      handleCardSelect(candidate, e);
                                    }
                                  }}
                                  style={{
                                    cursor:
                                      !showFilterCepheaChat && isSelectMode
                                        ? "pointer"
                                        : "default",
                                  }}
                                >
                                  <Card
                                    callStageMap={callStageMap}
                                    name={candidate.name}
                                    email={candidate.email}
                                    phone={candidate.phone}
                                    location={getLocationDisplay(candidate)}
                                    role={
                                      candidate.designation &&
                                      candidate.designation.trim() !== ""
                                        ? candidate.designation
                                        : candidate.parsedResumeData
                                              ?.CareerHistory?.JobDetails?.[0]
                                              ?.JobTitle
                                          ? candidate.parsedResumeData
                                              .CareerHistory.JobDetails[0]
                                              .JobTitle
                                          : "Not specified"
                                    }
                                    tag={candidate.stage}
                                    tagBackgroundColor={setTagColor(
                                      candidate.stage,
                                    )}
                                    experience={getCandidateExperienceValue(
                                      candidate,
                                    )}
                                    skills={candidate.skills || []}
                                    cardbackgroundColor={
                                      isSelected
                                        ? "rgba(104, 96, 238, 0.1)"
                                        : "var(--card__background)"
                                    }
                                    cardBorder={
                                      isSelected
                                        ? "1px solid rgba(104, 96, 238, 0.5)"
                                        : "1px solid var(--card__border)"
                                    }
                                    cardColor={"black"}
                                    skillbackgroundColor="var(--skill-badge-bg)"
                                    skillColor="var(--skill-badge-color)"
                                    viewEvent={(e) => {
                                      e.stopPropagation();
                                      handleCardView(candidate, e);
                                    }}
                                    isDarkMode={isDarkMode}
                                    isSelectMode={
                                      !showFilterCepheaChat && isSelectMode
                                    }
                                    isSelected={isSelected}
                                    handleCardSelect={() => {
                                      if (!showFilterCepheaChat)
                                        handleCardSelect(candidate);
                                    }}
                                    applications={candidate?.applications}
                                    matchPercentage={candidate.match_percentage}
                                  />
                                </div>
                              );
                            })}

                            {searchPagination.isLoadingMore && (
                              <>
                                {Array.from({ length: 20 }).map((_, idx) => (
                                  <DynamicSkeleton
                                    key={`all-scroll-skeleton-${idx}`}
                                    variant="rectangular"
                                    dimensions={{
                                      width: "100%",
                                      height: "180px",
                                      sx: {
                                        borderRadius: "12px",
                                        border: "1px solid #e0e0e0",
                                        boxShadow:
                                          "0 2px 4px rgba(0, 0, 0, 0.1)",
                                      },
                                    }}
                                  />
                                ))}
                              </>
                            )}
                          </div>
                        )}
                        {messages.length > 0 && (
                          <div style={{ padding: "20px 5px" }}>
                            {renderChatMessages()}
                          </div>
                        )}
                        <div
                          ref={cepheaChatRef}
                          style={{
                            marginTop: "30px",
                            display: showCepheaChat ? "block" : "none",
                          }}
                        >
                          <RecommendedSearchBox
                            isDarkMode={isDarkMode}
                            recommendedSearchBoxTitle="VybogTAL Chat"
                            askMeAnythingPlaceholder="Explore, compare, and review skills from the candidate results."
                            buttonLabel="Search"
                            TextAreaStyle={{ height: "55px" }}
                            inputsectionstylewrap={{ paddingBottom: "20px" }}
                            inputsectionstyle={{ paddingTop: "1px" }}
                            askMeAnythingValue={formik.values.askmeanything}
                            onAskChange={(e) =>
                              formik.setFieldValue(
                                "askmeanything",
                                e.target.value,
                              )
                            }
                            onSubmit={handleCandidateConversation}
                            uploadedFiles={AiDrivenUploadedFiles}
                            onFileUpload={handleFileUpload}
                            onFileDelete={handleFileDelete}
                            showAttachResume={true}
                            isCollapsed={isSearchBoxCollapsed}
                            onCollapseChange={handleSearchBoxCollapse}
                            showJobDescriptionField={false}
                            submitErrorMessage="Please enter a query."
                            askmeanythingOnKeyDown={(e) => {
                              if (e.key === "Enter" && !e.shiftKey) {
                                e.preventDefault();
                                handleCandidateConversation();
                              }
                            }}
                            isSearchLoading={isBotProcessing}
                          />
                        </div>
                      </>
                    )}
                  {!isSimpleSearchLoading &&
                    searchResultCandidates.length === 0 && (
                      <div
                        style={{
                          textAlign: "center",
                          color: "var(--text-secondary)",
                        }}
                      >
                        <h3>
                          No candidates found. Try adjusting your search query.
                        </h3>
                        <div style={{ textAlign: "center" }}>
                          <AnimationPlayer
                            animationSrc={NojobsAnimation}
                            playerHeight="250px"
                            playerWidth="250px"
                          />
                        </div>
                      </div>
                    )}
                </>
              ) : isSimpleSearchLoading ? (
                renderCepheaLoader()
              ) : isInitialLoading || !isFetchCompleted ? (
                allCandidatesViewTab === 1 ? (
                  renderCepheaLoader()
                ) : (
                  <div className="overall-card-container">
                    {Array.from({ length: 10 }).map((_, idx) => (
                      <DynamicSkeleton
                        key={idx}
                        variant="rectangular"
                        dimensions={{
                          width: "100%",
                          height: "180px",
                          sx: {
                            borderRadius: "20px",
                            border: "1px solid #e0e0e0",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                          },
                        }}
                        spacing={2}
                      />
                    ))}
                  </div>
                )
              ) : visibleList.length > 0 ? (
                showFilterCepheaChat ? (
                  <div
                    className="search-results-container"
                    style={{
                      height: "calc(100vh - 220px)",
                      display: "flex",
                      flexDirection: "column",
                      overflow: "hidden",
                    }}
                  >
                    {renderChatMessages(
                      <div
                        className="overall-card-container"
                        style={{ padding: "16px" }}
                      >
                        {visibleList.map((candidate, index) => (
                          <div
                            className="candidate-card-outer-container"
                            key={`chat-candidate-${candidate.id || index}`}
                            style={{ cursor: "default" }}
                          >
                            <Card
                              callStageMap={callStageMap}
                              name={candidate.name}
                              email={candidate.email}
                              phone={candidate.phone}
                              location={getLocationDisplay(candidate)}
                              role={
                                candidate.designation &&
                                candidate.designation.trim() !== ""
                                  ? candidate.designation
                                  : "Not specified"
                              }
                              tag={candidate.stage}
                              tagBackgroundColor={setTagColor(candidate.stage)}
                              experience={getCandidateExperienceValue(
                                candidate,
                              )}
                              skills={candidate.skills}
                              cardbackgroundColor="var(--card__background)"
                              cardBorder="1px solid var(--card__border)"
                              cardColor="black"
                              skillbackgroundColor="var(--skill-badge-bg)"
                              skillColor="var(--skill-badge-color)"
                              viewEvent={(e) => {
                                e.stopPropagation();
                                handleCardView(candidate, e);
                              }}
                              applications={candidate?.applications}
                              isDarkMode={isDarkMode}
                            />
                          </div>
                        ))}
                      </div>,
                      { flex: 1, overflowY: "auto" },
                    )}
                    <div
                      className="search-box-bottom"
                      style={{
                        flexShrink: 0,
                        backgroundColor: "var(--body__background)",
                      }}
                    >
                      <RecommendedSearchBox
                        isDarkMode={isDarkMode}
                        recommendedSearchBoxTitle="VybogTAL Chat"
                        askMeAnythingPlaceholder="Explore, compare, and review skills from the candidate results."
                        buttonLabel="Search"
                        TextAreaStyle={{ height: "55px" }}
                        inputsectionstylewrap={{ paddingBottom: "20px" }}
                        inputsectionstyle={{ paddingTop: "1px" }}
                        askMeAnythingValue={filterChatInput}
                        onAskChange={(e) => setFilterChatInput(e.target.value)}
                        onSubmit={handleFilterCandidateConversation}
                        showAttachResume={false}
                        showJobDescriptionField={false}
                        askmeanythingOnKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            handleFilterCandidateConversation();
                          }
                        }}
                        isSearchLoading={isBotProcessing}
                      />
                    </div>
                  </div>
                ) : isTrackedByMeActive ? (
                  <>
                    {trackedViewTab === 0 && (
                      <div
                        className="grouped-candidates-container"
                        ref={candidatesListRef}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          overflowY: "auto",
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : 0,
                          maxHeight: showFilterCepheaChat
                            ? "calc(100vh - 300px)"
                            : "calc(100vh - 200px)",
                        }}
                      >
                        {visibleList && visibleList.length > 0 ? (
                          <div className="overall-card-container">
                            {visibleList.map((candidate, index) => {
                              const isLast = index === visibleList.length - 1;
                              const isSelected =
                                !showFilterCepheaChat &&
                                isSelectMode &&
                                selectedCandidates.some(
                                  (c) => c.id === candidate.id,
                                );
                              const isAnySelectMode =
                                !showFilterCepheaChat && isSelectMode;
                              return (
                                <div
                                  className={`candidate-card-outer-container ${
                                    isSelected ? "selected" : ""
                                  }`}
                                  ref={isLast ? lastElement : null}
                                  key={`tracked-${candidate.id || index}`}
                                  onClick={(e) => {
                                    if (!showFilterCepheaChat && isSelectMode) {
                                      handleCardSelect(candidate, e);
                                    }
                                  }}
                                  style={{
                                    cursor: isAnySelectMode
                                      ? "pointer"
                                      : "default",
                                  }}
                                >
                                  <Card
                                    callStageMap={callStageMap}
                                    name={candidate.name}
                                    email={candidate.email}
                                    phone={candidate.phone}
                                    location={getLocationDisplay(candidate)}
                                    role={
                                      candidate.designation &&
                                      candidate.designation.trim() !== ""
                                        ? candidate.designation
                                        : "Not specified"
                                    }
                                    tag={candidate.stage}
                                    tagBackgroundColor={setTagColor(
                                      candidate.stage,
                                    )}
                                    experience={getCandidateExperienceValue(
                                      candidate,
                                    )}
                                    skills={candidate.skills}
                                    cardbackgroundColor={
                                      isSelected
                                        ? "rgba(104, 96, 238, 0.1)"
                                        : "var(--card__background)"
                                    }
                                    cardBorder={
                                      isSelected
                                        ? "1px solid rgba(104, 96, 238, 0.5)"
                                        : "1px solid var(--card__border)"
                                    }
                                    cardColor={"black"}
                                    skillbackgroundColor="var(--skill-badge-bg)"
                                    skillColor="var(--skill-badge-color)"
                                    viewEvent={(e) => {
                                      e.stopPropagation();
                                      handleCardView(candidate, e);
                                    }}
                                    isSelectMode={isAnySelectMode}
                                    isSelected={isSelected}
                                    applications={candidate?.applications}
                                    handleCardSelect={() => {
                                      if (!showFilterCepheaChat)
                                        handleCardSelect(candidate);
                                    }}
                                    isDarkMode={isDarkMode}
                                  />
                                </div>
                              );
                            })}
                            {isLoadingMore &&
                              // activeFilters.length === 0 &&
                              Array.from({ length: 10 }).map((_, idx) => (
                                <DynamicSkeleton
                                  key={`tracked-scroll-skeleton-${idx}`}
                                  variant="rectangular"
                                  dimensions={{
                                    width: "100%",
                                    height: "180px",
                                    sx: {
                                      borderRadius: "12px",
                                      border: "1px solid #e0e0e0ff",
                                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    },
                                  }}
                                />
                              ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "70vh",
                            }}
                          >
                            <p>
                              No Candidates are there in the selected stage.
                            </p>
                            <AnimationPlayer
                              animationSrc={NojobsAnimation}
                              playerHeight="300px"
                              playerWidth="300px"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {trackedViewTab === 1 && (
                      <div
                        style={{
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : "auto",
                        }}
                      >
                        <Table
                          key={`tracked-table`}
                          className="can-global-data-table"
                          columns={columnsDefinition}
                          data={visibleList}
                          highlightOnHover
                          pagination
                          onChangePage={handleTablePageChange}
                          fixedHeader
                          fixedHeaderScrollHeight={
                            showFilterCepheaChat
                              ? "calc(100vh - 300px)"
                              : "calc(100vh - 210px)"
                          }
                        />
                      </div>
                    )}
                  </>
                ) : isCreatedByMeActive ? (
                  <>
                    {trackedViewTab === 0 && (
                      <div
                        className="grouped-candidates-container"
                        ref={candidatesListRef}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          overflowY: "auto",
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : 0,
                          maxHeight: showFilterCepheaChat
                            ? "calc(100vh - 300px)"
                            : "calc(100vh - 200px)",
                        }}
                      >
                        {visibleList && visibleList.length > 0 ? (
                          <div className="overall-card-container">
                            {visibleList.map((candidate, index) => {
                              const isLast = index === visibleList.length - 1;
                              const isSelected =
                                !showFilterCepheaChat &&
                                isSelectMode &&
                                selectedCandidates.some(
                                  (c) => c.id === candidate.id,
                                );
                              const isAnySelectMode =
                                !showFilterCepheaChat && isSelectMode;
                              return (
                                <div
                                  className={`candidate-card-outer-container ${
                                    isSelected ? "selected" : ""
                                  }`}
                                  ref={isLast ? lastElement : null}
                                  key={`created-${candidate.id || index}`}
                                  onClick={(e) => {
                                    if (!showFilterCepheaChat && isSelectMode) {
                                      handleCardSelect(candidate, e);
                                    }
                                  }}
                                  style={{
                                    cursor: isAnySelectMode
                                      ? "pointer"
                                      : "default",
                                  }}
                                >
                                  <Card
                                    callStageMap={callStageMap}
                                    name={candidate.name}
                                    email={candidate.email}
                                    phone={candidate.phone}
                                    location={getLocationDisplay(candidate)}
                                    role={
                                      candidate.designation &&
                                      candidate.designation.trim() !== ""
                                        ? candidate.designation
                                        : "Not specified"
                                    }
                                    tag={candidate.stage}
                                    tagBackgroundColor={setTagColor(
                                      candidate.stage,
                                    )}
                                    experience={getCandidateExperienceValue(
                                      candidate,
                                    )}
                                    skills={candidate.skills}
                                    cardbackgroundColor={
                                      isSelected
                                        ? "rgba(104, 96, 238, 0.1)"
                                        : "var(--card__background)"
                                    }
                                    cardBorder={
                                      isSelected
                                        ? "1px solid rgba(104, 96, 238, 0.5)"
                                        : "1px solid var(--card__border)"
                                    }
                                    cardColor={"black"}
                                    skillbackgroundColor="var(--skill-badge-bg)"
                                    skillColor="var(--skill-badge-color)"
                                    viewEvent={(e) => {
                                      e.stopPropagation();
                                      handleCardView(candidate, e);
                                    }}
                                    isSelectMode={isAnySelectMode}
                                    isSelected={isSelected}
                                    handleCardSelect={() => {
                                      handleCardSelect(candidate);
                                    }}
                                    isDarkMode={isDarkMode}
                                    applications={candidate?.applications}
                                  />
                                </div>
                              );
                            })}
                            {isLoadingMore &&
                              // activeFilters.length === 0 &&
                              Array.from({ length: 10 }).map((_, idx) => (
                                <DynamicSkeleton
                                  key={`created-scroll-skeleton-${idx}`}
                                  variant="rectangular"
                                  dimensions={{
                                    width: "100%",
                                    height: "180px",
                                    sx: {
                                      borderRadius: "12px",
                                      border: "1px solid #e0e0e0",
                                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    },
                                  }}
                                />
                              ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "70vh",
                            }}
                          >
                            <p>
                              No Candidates are there in the selected stage.
                            </p>
                            <AnimationPlayer
                              animationSrc={NojobsAnimation}
                              playerHeight="300px"
                              playerWidth="300px"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {trackedViewTab === 1 && (
                      <div
                        style={{
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : "auto",
                        }}
                      >
                        <Table
                          key={`created-by-me-table`}
                          className="can-global-data-table"
                          columns={createdByMeColumnsDefinition}
                          data={visibleList}
                          highlightOnHover
                          pagination
                          onChangePage={handleTablePageChange}
                          fixedHeader
                          fixedHeaderScrollHeight={
                            showFilterCepheaChat
                              ? "calc(100vh - 300px)"
                              : "calc(100vh - 210px)"
                          }
                          dataNotFoundMessage="You haven't created any candidates yet."
                        />
                      </div>
                    )}
                  </>
                ) : isAllCandidatesActive ? (
                  <>
                    {allCandidatesViewTab === 0 && (
                      <div
                        className="grouped-candidates-container"
                        ref={candidatesListRef}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          overflowY: "auto",
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : 0,
                          maxHeight: showFilterCepheaChat
                            ? "calc(100vh - 300px)"
                            : "calc(100vh - 200px)",
                        }}
                      >
                        {visibleList && visibleList.length > 0 ? (
                          <div className="overall-card-container">
                            {visibleList.map((candidate, index) => {
                              const isLast = index === visibleList.length - 1;
                              let displayStage = candidate.stage;
                              if (
                                candidate.applications &&
                                candidate.applications.length > 0
                              ) {
                                const latestApp = candidate.applications.reduce(
                                  (latest, current) => {
                                    return new Date(current.updated_at) >
                                      new Date(latest.updated_at)
                                      ? current
                                      : latest;
                                  },
                                );
                                displayStage =
                                  latestApp?.stage || candidate.stage;
                              }
                              const isSelected =
                                !showFilterCepheaChat &&
                                isSelectMode &&
                                selectedCandidates.some(
                                  (c) => c.id === candidate.id,
                                );
                              const isAnySelectMode =
                                !showFilterCepheaChat && isSelectMode;
                              return (
                                <div
                                  className={`candidate-card-outer-container ${
                                    isSelected ? "selected" : ""
                                  }`}
                                  ref={isLast ? lastElement : null}
                                  key={`all-${candidate.id || index}`}
                                  onClick={(e) => {
                                    if (!showFilterCepheaChat && isSelectMode) {
                                      handleCardSelect(candidate, e);
                                    }
                                  }}
                                  style={{
                                    cursor: isAnySelectMode
                                      ? "pointer"
                                      : "default",
                                  }}
                                >
                                  <Card
                                    callStageMap={callStageMap}
                                    name={candidate.name}
                                    email={candidate.email}
                                    phone={candidate.phone}
                                    location={getLocationDisplay(candidate)}
                                    role={
                                      candidate.designation &&
                                      candidate.designation.trim() !== ""
                                        ? candidate.designation
                                        : "Not specified"
                                    }
                                    tag={displayStage}
                                    tagBackgroundColor={setTagColor(
                                      displayStage,
                                    )}
                                    experience={getCandidateExperienceValue(
                                      candidate,
                                    )}
                                    skills={candidate.skills}
                                    applications={candidate?.applications}
                                    cardbackgroundColor={
                                      isSelected
                                        ? "rgba(104, 96, 238, 0.1)"
                                        : "var(--card__background)"
                                    }
                                    cardBorder={
                                      isSelected
                                        ? "1px solid rgba(104, 96, 238, 0.5)"
                                        : "1px solid var(--card__border)"
                                    }
                                    cardColor={"black"}
                                    skillbackgroundColor="var(--skill-badge-bg)"
                                    skillColor="var(--skill-badge-color)"
                                    viewEvent={(e) => {
                                      e.stopPropagation();
                                      handleCardView(candidate, e);
                                    }}
                                    isSelectMode={isAnySelectMode}
                                    isSelected={isSelected}
                                    handleCardSelect={() => {
                                      if (!showFilterCepheaChat)
                                        handleCardSelect(candidate);
                                    }}
                                    isDarkMode={isDarkMode}
                                  />
                                </div>
                              );
                            })}
                            {isLoadingMore &&
                              // activeFilters.length === 0 &&
                              Array.from({ length: 10 }).map((_, idx) => (
                                <DynamicSkeleton
                                  key={`all-scroll-skeleton-${idx}`}
                                  variant="rectangular"
                                  dimensions={{
                                    width: "100%",
                                    height: "180px",
                                    sx: {
                                      borderRadius: "12px",
                                      border: "1px solid #e0e0e0",
                                      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                    },
                                  }}
                                />
                              ))}
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "70vh",
                            }}
                          >
                            <p>
                              No Candidates are there in the selected stage.
                            </p>
                            <AnimationPlayer
                              animationSrc={NojobsAnimation}
                              playerHeight="300px"
                              playerWidth="300px"
                            />
                          </div>
                        )}
                      </div>
                    )}
                    {allCandidatesViewTab === 1 && (
                      <div
                        style={{
                          minHeight: showFilterCepheaChat
                            ? "calc(100vh - 380px)"
                            : "auto",
                        }}
                      >
                        <Table
                          key={`all-candidates-table`}
                          className="can-global-data-table"
                          columns={allCandidatesColumnsDefinition}
                          data={visibleList}
                          highlightOnHover
                          pagination
                          onChangePage={handleTablePageChange}
                          fixedHeader
                          fixedHeaderScrollHeight={
                            showFilterCepheaChat
                              ? "calc(100vh - 300px)"
                              : activeFilters.length === 0
                                ? isSearchBoxCollapsed
                                  ? "calc(100vh - 280px)"
                                  : "calc(100vh - 350px)"
                                : "calc(100vh - 210px)"
                          }
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="overall-card-container">
                    {visibleList.map((candidate, index) => {
                      const isLast = index === visibleList.length - 1;
                      const isSelected =
                        !showFilterCepheaChat &&
                        isSelectMode &&
                        selectedCandidates.some((c) => c.id === candidate.id);
                      const isAnySelectMode =
                        !showFilterCepheaChat && isSelectMode;
                      return (
                        <div
                          className={`candidate-card-outer-container ${
                            isSelected ? "selected" : ""
                          }`}
                          ref={isLast && !isLoadingMore ? lastElement : null}
                          key={`${isAllCandidatesActive ? "all" : "tracked"}-${
                            candidate.id || index
                          }`}
                          onClick={(e) => {
                            if (!showFilterCepheaChat && isSelectMode) {
                              handleCardSelect(candidate, e);
                            }
                          }}
                          style={{
                            cursor: isAnySelectMode ? "pointer" : "default",
                          }}
                        >
                          <Card
                            callStageMap={callStageMap}
                            name={candidate.name}
                            email={candidate.email}
                            phone={candidate.phone}
                            location={getLocationDisplay(candidate)}
                            role={
                              candidate.designation &&
                              candidate.designation.trim() !== ""
                                ? candidate.designation
                                : "Not specified"
                            }
                            tag={candidate.stage}
                            tagBackgroundColor={setTagColor(candidate.stage)}
                            experience={getCandidateExperienceValue(candidate)}
                            skills={candidate.skills}
                            cardbackgroundColor={
                              isSelected
                                ? "rgba(104, 96, 238, 0.1)"
                                : "var(--body__background)"
                            }
                            cardColor={"black"}
                            skillbackgroundColor={"#E0DEFF"}
                            skillColor={"#2D23DB"}
                            viewEvent={(e) => {
                              e.stopPropagation();
                              handleCardView(candidate, e);
                            }}
                            isSelectMode={isAnySelectMode}
                            isSelected={isSelected}
                            handleCardSelect={() => {
                              if (!showFilterCepheaChat)
                                handleCardSelect(candidate);
                            }}
                            applications={candidate?.applications}
                            isDarkMode={isDarkMode}
                          />
                        </div>
                      );
                    })}
                    {isLoadingMore && activeFilters.length === 0 && (
                      <>
                        {Array.from({ length: 10 }).map((_, idx) => (
                          <DynamicSkeleton
                            key={`scroll-skeleton-${idx}`}
                            variant="rectangular"
                            dimensions={{
                              width: "100%",
                              height: "180px",
                              sx: {
                                borderRadius: "12px",
                                border: "1px solid #e0e0e0",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                              },
                            }}
                          />
                        ))}
                      </>
                    )}
                  </div>
                )
              ) : !isInitialLoading &&
                !isLoadingMore &&
                isFetchCompleted &&
                visibleList.length === 0 ? (
                isAllCandidatesActive ? (
                  activeFilters.length > 0 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "70vh",
                      }}
                    >
                      <h4
                        style={{ textAlign: "center", marginBottom: "-20px" }}
                      >
                        No candidates found for the applied filters.
                      </h4>
                      <div style={{ textAlign: "center" }}>
                        <AnimationPlayer
                          animationSrc={NojobsAnimation}
                          playerHeight="300px"
                          playerWidth="300px"
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="create-text-content"
                      style={{ textAlign: "center", marginTop: "100px" }}
                    >
                      <img
                        src={
                          isDarkMode
                            ? createDarkCandidateIcon
                            : createCandidateIcon
                        }
                        alt="CreateCandidateIcon"
                        className="interview-icon"
                        style={{ marginBottom: "-40px", marginLeft: "90px" }}
                      />
                      <h3>
                        Create a{" "}
                        <span className="inner-span">New Candidate</span>
                      </h3>
                      <p>Create a new candidate profile to get started.</p>
                      <div className="client-workspace-button-container">
                        <Button
                          label="Create Candidate"
                          event={handleOpenInviteModal}
                          className="create-button"
                        />
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "70vh",
                    }}
                  >
                    <h4 style={{ textAlign: "center", marginBottom: "-20px" }}>
                      {isAllCandidatesActive
                        ? "No candidates found."
                        : isTrackedByMeActive
                          ? "There are no candidates tracked by you."
                          : isCreatedByMeActive
                            ? "You haven't created any candidates yet."
                            : "No candidates found."}
                    </h4>
                    <div style={{ textAlign: "center" }}>
                      <AnimationPlayer
                        animationSrc={NojobsAnimation}
                        playerHeight="300px"
                        playerWidth="300px"
                      />
                    </div>
                  </div>
                )
              ) : null}
            </>
          )}
          {isModalOpen && !isCandidateDetailsLoading ? (
            <SidePopupCan
              key={selectedCandidate?.id || "no-candidate"}
              isOpen={isModalOpen}
              onClose={closeModal}
              title="Candidate Details"
              showDeleteButton={false}
              headerRightComponent={
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    marginRight: "10px",
                  }}
                >
                  {isEditingCandidate ? (
                    <div style={{ display: "flex", gap: "10px" }}>
                      <Button
                        label="Save"
                        event={saveCandidateChanges}
                        backgroundColor="#6860EE"
                        color="#FFFFFF"
                        border="none"
                        style={{ borderRadius: "12px" }}
                      />
                      <Button
                        label="Cancel"
                        event={resetCandidateEdit}
                        isCancel={true}
                        color="#000"
                        border="1px solid #ddd"
                        style={{ borderRadius: "12px", marginRight: "0px" }}
                      />
                    </div>
                  ) : (
                    <div
                      style={{ display: "flex", gap: "20px", marginTop: "5px" }}
                    >
                      {!selectedCandidate?.isFileBased &&
                        (selectedCandidate?.email ||
                          selectedCandidate?.parsedResumeData?.BasicInfo
                            ?.Email) && (
                          <CustomTooltip
                            title={getMonthlyEmailTooltip("Reach Out")}
                            arrow
                          >
                            <img
                              src={ReachOutIcon}
                              alt="Reach Out"
                              onClick={() => {
                                if (isMonthlyEmailLimitReached) return;
                                candidateDetailsRef.current?.openReachOut();
                              }}
                              style={{
                                width: "24px",
                                cursor: isMonthlyEmailLimitReached
                                  ? "not-allowed"
                                  : "pointer",
                                opacity: isMonthlyEmailLimitReached ? 0.5 : 1,
                              }}
                            />
                          </CustomTooltip>
                        )}
                      {!selectedCandidate?.isFileBased && (
                        <CustomTooltip title="Edit Candidate" arrow>
                          <img
                            src={editIcon}
                            alt="Edit"
                            onClick={handleEditCandidate}
                            style={{ width: "22px", cursor: "pointer" }}
                          />
                        </CustomTooltip>
                      )}
                      {AdminAccess && !showFilterCepheaChat && (
                        <CustomTooltip title="Delete Candidate" arrow>
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            onClick={handleOpenCandidateDeleteDialog}
                            style={{ width: "22px", cursor: "pointer" }}
                          />
                        </CustomTooltip>
                      )}
                    </div>
                  )}
                </div>
              }
            >
              <CandidateDetailsContainer
                ref={candidateDetailsRef}
                candidate={selectedCandidate}
                activeTab={activeTab}
                handleTabChange={handleTabChange}
                hasSearched={
                  hasSearched && !showCepheaChat && showFilterCepheaChat
                }
                showCandidateRecommendedJobsTab={
                  !showFilterCepheaChat || hasSearched
                }
                onAssignJobClick={handleAssignJobFromHistory}
                isEditingCandidate={isEditingCandidate}
                setIsEditingCandidate={setIsEditingCandidate}
                handleEditCandidate={handleEditCandidate}
                saveCandidateChanges={saveCandidateChanges}
                resetCandidateEdit={resetCandidateEdit}
                handleCandidateChange={handleCandidateChange}
                editedCandidateData={editedCandidateData}
                emailError={emailError}
                setEmailError={setEmailError}
                emailTouched={emailTouched}
                setEmailTouched={setEmailTouched}
                vendorList={vendorList}
                vendorOptionLoading={vendorOptionLoading}
                handleVendorInputChange={handleVendorInputChange}
                assignedVendor={assignedVendor}
                isRecommendedJobsLoading={isRecommendedJobsLoading}
                industryOptions={INDUSTRY_OPTIONS}
              />
            </SidePopupCan>
          ) : (
            <SidePopupCan
              key={selectedCandidate?.id || "no-candidate"}
              isOpen={isModalOpen}
              onClose={closeModal}
              title="Candidate Details"
              showDeleteButton={false}
              closeIconDisabled={true}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <VybogTALLoaderAnimation />
              </div>
            </SidePopupCan>
          )}
        </div>
        <SidePopupCan
          isOpen={candidateModal}
          onClose={handleCloseInviteModal}
          title="Create Candidate"
          sidePopupWidth={"var(--side-popup-w)"}
        >
          <div className="client-popup-container">
            <div className="form-group">
              <DynamicTextField
                label="Full Name"
                type="text"
                name="canName"
                placeholder="e.g. Alicia Carter"
                value={formik.values.canName}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("canName", true)}
                error={formik.touched.canName && formik.errors.canName}
                errorMessage={formik.errors.canName}
                style={{ width: "100%" }}
                required={true}
                labelStyle={{ marginBottom: "15px" }}
              />
              <DynamicTextField
                label="Email"
                type="email"
                name="canEmail"
                placeholder="e.g. alicia.carter@email.com"
                value={formik.values.canEmail}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("canEmail", true)}
                error={formik.touched.canEmail && formik.errors.canEmail}
                errorMessage={formik.errors.canEmail}
                style={{ width: "100%" }}
                required={!formik.values.canMobile}
                labelStyle={{ marginBottom: "15px" }}
              />
            </div>

            <div className="form-group">
              <PhoneNumberInput
                value={formik.values.canMobile}
                onChange={handlePhoneInputChange}
                onBlur={() => formik.setFieldTouched("canMobile", true)}
                error={formik.errors.canMobile}
                touched={formik.touched.canMobile}
                placeholder="e.g. (415) 555-0198"
                label="Contact No."
                width="100%"
                height="40px"
                countryListWidth="300px"
                phoneContainerStyle={{ marginBottom: "15px" }}
                required={!formik.values.canEmail}
              />
            </div>

            <div className="form-group">
              <label htmlFor="title" className="textfield-label">
                Skills <span className="required-asterisk">*</span>
              </label>
              <AutoComplete
                key={`auto-complete-${autoCompleteKey}`}
                multiple
                placeholder="e.g. JavaScript, React, Node.js"
                // options={skills.filter((skill) => {
                //   const selectedSkills = Array.isArray(formik.values.skills)
                //     ? formik.values.skills
                //     : [];
                //   return !selectedSkills.some(
                //     (selectedSkill) =>
                //       selectedSkill.toLowerCase() === skill.title.toLowerCase(),
                //   );
                // })}
                tags={true}
                name="canSkills"
                style={{ marginTop: "15px !important" }}
                value={formik.values.skills || []}
                onChange={(selectedOptions) => {
                  const validSkills = selectedOptions
                    .map((option) =>
                      typeof option === "string" ? option : option.title,
                    )
                    .filter((option) => option.trim() !== "");

                  const uniqueSkills = validSkills.filter(
                    (skill, index, self) =>
                      index ===
                      self.findIndex(
                        (s) => s.toLowerCase() === skill.toLowerCase(),
                      ),
                  );

                  formik.setFieldValue("skills", uniqueSkills);
                }}
                onBlur={() => formik.setFieldTouched("skills", true)}
                InputWrapperStyle={{
                  height: "100px",
                  overflowY: "auto",
                  padding: "10px",
                  marginBottom: "30px",
                  marginTop: "15px",
                }}
                showClearAll={true}
                error={formik.touched.skills && formik.errors.skills}
                errorMessage={formik.errors.skills}
              />
            </div>
            <div className="form-group">
              <DynamicTextField
                label="Designation"
                type="text"
                name="designation"
                placeholder="e.g. Senior Software Engineer"
                value={formik.values.designation}
                onChange={formik.handleChange}
                onBlur={() => formik.setFieldTouched("designation", true)}
                error={formik.touched.designation && formik.errors.designation}
                errorMessage={formik.errors.designation}
                style={{ width: "100%" }}
                labelStyle={{ marginBottom: "15px" }}
              />
            </div>
            {isVendorFeatureEnabled && (
              <div className="form-group">
                <label htmlFor="vendorID" className="textfield-label">
                  Vendor
                </label>
                <DynamicAutocomplete
                  key={`autocomplete-vendor-${
                    formik.values.vendorID || "empty"
                  }`}
                  onChange={(value) => {
                    formik.setFieldValue("vendorID", value?.value || "");
                    if (!value) {
                      setVendorList([]);
                    }
                  }}
                  value={
                    formik.values.vendorID
                      ? vendorList.find(
                          (vendor) => vendor.value === formik.values.vendorID,
                        ) || null
                      : null
                  }
                  placeholder={"Select Vendor"}
                  minCharsForSearch={3}
                  noOptionsText="No Vendor found."
                  onInputChange={handleVendorInputChange}
                  options={vendorList}
                  loading={vendorOptionLoading}
                  sx={{
                    mt: "5px",
                    ".MuiOutlinedInput-root": {
                      borderRadius: "12px",
                      height: "40px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid var(--border__color) !important",
                        borderRadius: "12px",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#6860ee",
                        borderRadius: "12px",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#7a70f2",
                        borderRadius: "12px",
                      },
                    },
                    ".MuiInputBase-input": {
                      color: "var(--header__color)",
                      padding: "8px 12px !important",
                      height: "40px",
                      fontFamily: "Satoshi !important",
                    },
                  }}
                  slotProps={{
                    paper: {
                      sx: {
                        backgroundColor: "var(--body__background)",
                        color: "var(--header__color)",
                        borderRadius: "12px",
                        boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                        border: "1px solid var(--border__color)",
                      },
                    },
                    listbox: {
                      sx: {
                        "& li": {
                          fontSize: "14px",
                          fontWeight: 500,
                          padding: "8px 16px",
                          color: "var(--header__color)",
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.04)",
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            )}
            <DynamicTextField
              label="Source"
              type="text"
              name="source"
              placeholder="Select source"
              value={formik.values.source}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("source", true)}
              error={formik.touched.source && formik.errors.source}
              errorMessage={formik.errors.source}
              selectStyle={{ width: "100%" }}
              labelStyle={{ marginBottom: "15px" }}
            />
            <DynamicSelectInput
              label="Industry"
              name="industry"
              defaultOption="Select industry"
              options={INDUSTRY_OPTIONS}
              value={formik.values.industry}
              onChange={formik.handleChange}
              labelStyle={{
                marginBottom: "15px",
                fontSize: "16px",
                fontWeight: 600,
                width: "fit-content",
              }}
              selectStyle={{
                width: "100%",
                height: "40px",
                fontFamily: "Satoshi",
                fontSize: "15px",
                fontWeight: 500,
                color: "var(--header__color)",
                borderRadius: "12px",
              }}
              wrapperStyle={{ marginBottom: "15px" }}
            />
            {fields
              .filter((field) => {
                const fieldKey = String(field?.field_key || "").toLowerCase();
                const label = String(field?.label || "").toLowerCase();
                return fieldKey !== "industry" && label !== "industry";
              })
              .map((field) => (
                <DynamicCandidateCustomField
                  key={field.field_key}
                  entity_type={field.entity_type}
                  field_key={field.field_key}
                  label={field.label}
                  field_type={field.field_type}
                  required={field.required}
                  options={field.options}
                  value={formik.values.custom_fields[field.field_key] ?? ""}
                  onChange={(value) => {
                    formik.setFieldValue(
                      `custom_fields.${field.field_key}`,
                      value,
                    );
                  }}
                  canCreateTextFieldLabelStyle={{ marginTop: "10px" }}
                  textfieldType={
                    field.field_type === "text"
                      ? "text"
                      : field.field_type === "integer" ||
                          field.field_type === "decimal"
                        ? "number"
                        : undefined
                  }
                />
              ))}
            <div
              className="create-client-button-container"
              style={{ marginTop: "20px" }}
            >
              <Button
                label="Cancel"
                event={handleCloseInviteModal}
                backgroundColor="#6860ee"
                isCancel={true}
              />
              <Button
                label="Create Candidate"
                event={handleCreateCandidate}
                backgroundColor="#6860ee"
              />
            </div>
          </div>
        </SidePopupCan>
        <CandidatesAssignJob
          isOpen={isAssignJobModalOpen}
          setAssignJobModalOpen={setAssignJobModalOpen}
          selectedCandidates={selectedCandidates}
          jobId={assignJobId}
          jobTitle={assignJobTitle}
        />
        <JobSelectionPopup
          isOpen={isJobSelectionOpen}
          onClose={() => setIsJobSelectionOpen(false)}
          onSelectJob={(data) => {
            const { job, actionType } = data;
            setIsJobSelectionOpen(false);
            switch (actionType) {
              case "assignJob":
                setAssignJobId(job.id);
                setAssignJobTitle(job.title);
                setAssignJobModalOpen(true);
                break;

              case "clientEmail":
                setAssignJobId(job.id);
                setAssignJobTitle(job.title);
                setIsClientEmailPopupOpen(true);
                break;
              case "emailCampaign":
                setAssignJobId(job.id);
                setAssignJobTitle(job.title);
                setIsEmailCampaignPopupOpen(true);
                break;

              default:
                setAssignJobId(job.id);
                setAssignJobTitle(job.title);
                setAssignJobModalOpen(true);
            }
          }}
          isDarkMode={isDarkMode}
          actionType={jobSelectionActionType}
          actionData={jobSelectionActionData}
        />
        <SidePopup
          isOpen={isExportFieldsPopupOpen}
          onClose={() => setIsExportFieldsPopupOpen(false)}
          width={"620px"}
          title="Export Candidates"
          subTitle="Customize the information you want to include in your Excel export."
        >
          <div className="candidate-export-popup">
            {isLoadingGetExport ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "180px",
                }}
              >
                <VybogTALLoaderAnimation />
              </div>
            ) : exportData.length > 0 ? (
              <>
                <div className="candidate-export-summary">
                  <div className="candidate-export-summary-icon">
                    <Users size={18} strokeWidth={2.4} />
                  </div>
                  <div className="candidate-export-summary-copy">
                    <div className="candidate-export-summary-title">
                      {selectedCandidates.length > 0
                        ? "Selected Candidates"
                        : "Matched Candidates"}
                    </div>
                    <div className="candidate-export-summary-text">
                      {selectedCandidates.length > 0
                        ? "Only selected candidates will be exported."
                        : "All matching candidates will be exported."}
                    </div>
                  </div>
                  <span className="candidate-export-count">
                    {exportCandidateCount}{" "}
                    {exportCandidateCount === 1 ? "candidate" : "candidates"}
                  </span>
                </div>

                <div className="candidate-export-toolbar">
                  <div>
                    <h3>Select & Order Columns</h3>
                  </div>
                  <div className="candidate-export-toolbar-actions">
                    <button type="button" onClick={handleResetExportFieldOrder}>
                      Reset Order
                    </button>
                    <button type="button" onClick={handleSelectAllExportFields}>
                      {selectedExportFieldKeys.length === exportData.length
                        ? "Clear All"
                        : "Select All"}
                    </button>
                  </div>
                </div>

                <DndContext
                  collisionDetection={closestCenter}
                  onDragEnd={handleExportFieldDragEnd}
                >
                  <SortableContext
                    items={exportData.map((field, index) =>
                      getExportFieldKey(field, index),
                    )}
                    strategy={verticalListSortingStrategy}
                  >
                    <div className="candidate-export-fields-list">
                      {exportData.map((field, index) => {
                        const label = getExportFieldLabel(field);
                        const key = getExportFieldKey(field, index);
                        const isSelected =
                          selectedExportFieldKeys.includes(key);
                        const isRequired = isRequiredExportField(field);

                        return (
                          <SortableExportField
                            key={key}
                            field={field}
                            index={index}
                          >
                            {({ listeners, isDragging }) => (
                              <div
                                className={`candidate-export-field-row ${
                                  isDragging
                                    ? "candidate-export-field-row-active"
                                    : ""
                                }`}
                              >
                                <button
                                  type="button"
                                  className="candidate-export-drag-handle"
                                  aria-label={`Reorder ${label}`}
                                  {...listeners}
                                >
                                  <GripVertical size={15} strokeWidth={2.4} />
                                </button>
                                <label className="candidate-export-field-label">
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    disabled={isRequired}
                                    onChange={() =>
                                      toggleExportField(field, index)
                                    }
                                  />
                                  <span>{label}</span>
                                </label>
                                {isRequired && (
                                  <div
                                    className="candidate-export-required-wrap"
                                    title="Required field"
                                  >
                                    <span className="candidate-export-count">
                                      Required
                                    </span>
                                    <Lock size={13} strokeWidth={2.4} />
                                  </div>
                                )}
                              </div>
                            )}
                          </SortableExportField>
                        );
                      })}
                    </div>
                  </SortableContext>
                </DndContext>

                <div className="candidate-export-footer">
                  <Button
                    label="Cancel"
                    event={() => setIsExportFieldsPopupOpen(false)}
                    backgroundColor="var(--body__background)"
                    color="var(--header__color)"
                    border="1px solid var(--border__color)"
                    style={{ padding: "9px 18px" }}
                  />
                  <Button
                    label={`Export ${exportCandidateCount} ${
                      exportCandidateCount === 1 ? "Candidate" : "Candidates"
                    }`}
                    event={handleExportCandidatesFromPopup}
                    backgroundColor="#6860ee"
                    color="#fff"
                    border="1px solid #6860ee"
                    style={{ padding: "9px 22px" }}
                    iconSrc={DownloadIcon}
                  />
                </div>
              </>
            ) : (
              <div
                style={{
                  color: "#6B7280",
                  fontSize: "14px",
                  padding: "16px",
                  textAlign: "center",
                }}
              >
                No export fields found.
              </div>
            )}
          </div>
        </SidePopup>
        <ConfirmationPopup
          isOpen={openConversationLimitPopup}
          onConfirm={() => {
            handleBackToList();
            setOpenConversationLimitPopup(false);
          }}
          title="Conversation limit reached."
          message="You have reached the limit of this conversation. Please start a new one"
          confirmLabel="New Chat"
          cancelLabel=""
        />
        <ConfirmationPopup
          isOpen={isDeleteCandidatePopupOpen}
          onClose={() => setIsDeleteCandidatePopupOpen(false)}
          onConfirm={handleDeleteCandidate}
          title="Delete Candidate?"
          subTitle="Confirmation required"
          message={
            <span>
              You are about to delete{" "}
              <span
                style={{
                  color: "#6665ea",
                  fontWeight: "bold",
                }}
              >
                "{applyEllipsis(selectedCandidate?.name, 35)}"
              </span>
              .
              <br />
              <br />
              This action will permanently remove this candidate details,
              including any associations with jobs or vendors.
              <br />
              <br />
              This action cannot be undone. Are you sure you want to delete?
            </span>
          }
          cancelLabel="No, Cancel"
          confirmLabel="Yes, Delete"
          confirmButtonClass="popup-button-danger"
        />
        <SidePopup
          isOpen={isEmailCampaignPopupOpen}
          onClose={() => setIsEmailCampaignPopupOpen(false)}
          width={"40%"}
          title={
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <img src={EmailCampaignIcon} alt="" />
                <span
                  style={{
                    color: "#534BDB",
                    fontSize: "18px",
                    fontWeight: "600",
                  }}
                >
                  Email Campaign
                </span>
              </div>

              <span
                style={{
                  color: "#6B7280",
                  fontSize: "12px",
                  marginLeft: "50px",
                }}
              >
                Send job opportunities to selected candidates
              </span>
            </div>
          }
        >
          <JobsBlastEmailCampaign
            selectedCandidates={selectedCandidates}
            isEmailPreviewOpen={isEmailPreviewOpen}
            setIsEmailPreviewOpen={setIsEmailPreviewOpen}
            setCanPreview={setCanPreview}
            onCancel={() => setIsEmailCampaignPopupOpen(false)}
          />
        </SidePopup>
        <ClientEmailPopup
          isOpen={isClientEmailPopupOpen}
          onClose={() => setIsClientEmailPopupOpen(false)}
          selectedCandidates={selectedCandidates}
          jobId={assignJobId}
          jobTitle={assignJobTitle}
        />
        {showMatchPercentagePopup && (
          <MatchPercentage onClose={() => setShowMatchPercentagePopup(false)} />
        )}
      </div>
    </div>
  );
}
export default CandidateTableList;
